export const translations = {
  lv: {
    languageLabel: 'LV',
    company: {
      slogan: 'Ilgtspējīga meža apsaimniekošana'
    },
    heroBadge: 'Neatkarīgi mežsaimniecības pakalpojumi',
    hero: {
      title: 'Neatkarīga cirsmu vērtēšana meža īpašniekiem',
      subtitle: 'Palīdzam meža īpašniekiem precīzi novērtēt cirsmas vērtību un sagatavot mežu ciršanai, nodrošinot profesionālus uzmērījumus un visu nepieciešamo dokumentāciju.',
      description: 'Strādājam tikai meža īpašnieka interesēs – nepērkam cirsmas un neesam saistīti ar koksnes pircējiem.',
      workIntro: 'Ko mēs veicam',
      workItems: [
        'Augošu koku dastošanu',
        'Caurmēra mērīšanu',
        'Cirsmas stigošanu',
        'Īpašuma robežu un robežzīmju atjaunošanu',
        'Dokumentācijas sagatavošanu un iesniegšanu institūcijām'
      ],
      workNote: 'Pilns darbu saraksts pieejams sadaļā “Darbi”.',
      reasonsTitle: 'Kāpēc izvēlēties mūs',
      reasons: [
        'Precīzi meža uzmērījumi',
        'Neatkarīgs cirsmu novērtējums',
        'Korekta dokumentācija',
        'Pilnīga darba procesa caurspīdība'
      ],
      closing: 'Klienti var tiešsaistē sekot līdzi darbu izpildei no jebkuras vietas.',
      tagline: 'Sazinieties ar mums, lai saņemtu profesionālu attieksmi!',
      ctaPrimary: 'Pieteikt cirsmas vērtēšanu',
      ctaSecondary: 'Klientu portāls',
      salesHighlights: [
        'Neatkarīgs vērtējums',
        'Precīzi uzmērījumi',
        'Pilna dokumentācija',
        'Pilnīga caurspīdība'
      ],
      calloutTitle: 'Sila Meži garantija',
      calloutBody: 'Precīzi mērījumi. Korekta dokumentācija. Pilnīga caurspīdība.',
      workLink: 'Skatīt darbus',
      scrollHint: 'Ritiniet tālāk',
      subtitleHighlight: 'precīzi novērtēt cirsmas vērtību',
      descriptionHighlight: 'nepērkam cirsmas un neesam saistīti ar koksnes pircējiem.'
    },
    trustBadges: [
      { id: 1, title: 'Precīzi meža uzmērījumi', description: 'Detalizēti lauka mērījumi un analīze' },
      { id: 2, title: 'Neatkarīgs cirsmu novērtējums', description: 'Bez interesēm koksnes pirkšanā' },
      { id: 3, title: 'Korekta dokumentācija', description: 'Pilns sagatavošanas un iesniegšanas atbalsts' },
      { id: 4, title: 'Pilnīga caurspīdība', description: 'Klienti seko līdzi darbam tiešsaistē' }
    ],
    services: {
      eyebrow: 'Mūsu pakalpojumi',
      title: 'Profesionāli mežsaimniecības pakalpojumi meža īpašniekiem',
      description: 'Piedāvājam pilnu mežsaimniecības pakalpojumu klāstu — no meža vērtēšanas un uzmērīšanas līdz dokumentācijas sagatavošanai, projektu vadībai un meža apsaimniekošanas darbu organizēšanai.',
      mission: 'Mūsu mērķis ir palīdzēt meža īpašniekiem pieņemt pārdomātus lēmumus, nodrošinot precīzu informāciju, profesionālu pieeju un pilnu procesa atbalstu.',
      ctaQuestion: 'Neesat pārliecināti, kāds pakalpojums jums nepieciešams?',
      ctaLink: 'Sazinieties ar mums bezmaksas konsultācijai'
    },
    servicesList: [
      {
        id: 1,
        category: 'Meža un cirsmu vērtēšana',
        description: 'Veicam profesionālu augošu koku un cirsmu vērtēšanu, balstoties uz detalizētiem lauka mērījumiem, aktuālajām tirgus cenām un spēkā esošajiem normatīvajiem aktiem. Vērtējums tiek sagatavots neatkarīgi no cirsmas pirkšanas, tādējādi nodrošinot objektīvu un uzticamu informāciju meža īpašniekam.',
        items: [
          'Augošu koku dastošana',
          'Koku caurmēra un citu parametru mērījumi',
          'Cirsmas vērtības aprēķins un analīze'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Meža uzmērīšana un robežu darbi',
        description: 'Nodrošinām dažādus meža uzmērīšanas darbus un īpašuma robežu precizēšanu dabā. Visi darbi tiek veikti, balstoties uz kadastrālajiem datiem un atbilstoši spēkā esošajiem normatīvajiem aktiem. Precīzi uzmērījumi palīdz izvairīties no robežstrīdiem un nodrošina korektu meža apsaimniekošanu.',
        items: [
          'Cirsmas stigošana',
          'Īpašuma robežu atjaunošana dabā',
          'Robežzīmju uzstādīšana un atjaunošana'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Meža atjaunošana un jaunaudžu kopšana',
        description: 'Palīdzam meža īpašniekiem nodrošināt ilgtspējīgu meža attīstību, organizējot meža atjaunošanas un jaunaudžu kopšanas darbus. Pareiza kopšana agrīnajos meža attīstības posmos būtiski ietekmē meža kvalitāti un nākotnes vērtību.',
        items: [
          'Meža atjaunošanas darbu organizēšana',
          'Stādīšanas darbu plānošana un koordinēšana',
          'Jaunaudžu kopšanas darbu organizēšana'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentācijas sagatavošana un saskaņojumi',
        description: 'Sagatavojam un iesniedzam visu nepieciešamo dokumentāciju meža darbiem Valsts meža dienestā un citās institūcijās. Nodrošinām pilnu administratīvo atbalstu visā procesā, lai meža īpašnieki izvairītos no sarežģītas birokrātijas.',
        items: [
          'Dokumentu sagatavošana valsts institūcijām',
          'Iesniegumu sagatavošana un iesniegšana',
          'Pilns administratīvā procesa atbalsts'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'Eiropas Savienības atbalsta projekti',
        description: 'Konsultējam meža īpašniekus par pieejamajiem Eiropas Savienības atbalsta instrumentiem mežsaimniecībā. Nodrošinām pilnu projekta sagatavošanas un administrēšanas procesu — no idejas līdz projekta realizācijai.',
        items: [
          'Konsultācijas par ES atbalsta iespējām',
          'Projektu dokumentācijas sagatavošana',
          'Projektu iesniegšana un uzraudzība'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Darbi',
      title: 'Darbi',
      description: 'Izvēlieties interesējošos darbus, un mēs sagatavosim precīzu cenu piedāvājumu. Jūsu izvēle automātiski tiks pievienota pieteikuma formai.',
      summaryTitle: 'Atlasītie darbi',
      summaryEmpty: 'Nav atlasītu darbu. Izvēlieties pakalpojumu sarakstā augstāk.',
      requestCta: 'Pieprasīt cenu piedāvājumu',
      contactCta: 'Sazināties ar mums',
      selectError: 'Lūdzu izvēlieties vismaz vienu darbu, lai pieprasītu cenu.',
      itemSelected: 'Pievienots cenu pieprasījumam',
      itemAdd: 'Atzīmējiet, lai pieprasītu cenu'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Mežsaimniecības darbi',
        description: 'Precīzi lauka darbi un cirsmu sagatavošana drošai un korektai meža apsaimniekošanai.',
        items: [
          'Cirsmu iestigošana (stigošana)',
          'Dastošana',
          'Augošu koku atzarošana'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Meža atjaunošana un kopšana',
        description: 'Ilgtspējīgas meža attīstības nodrošināšana ar mērķtiecīgi plānotiem atjaunošanas darbiem.',
        items: [
          'Meža atjaunošana',
          'Jaunaudžu kopšana',
          'Jaunaudžu aizsardzība pret dzīvnieku postījumiem'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Meža īpašumu apsaimniekošana',
        description: 'Pilna cikla meža īpašumu pārvaldība un darbu koordinēšana no plānošanas līdz izpildei.',
        items: ['Meža īpašumu apsaimniekošana']
      },
      {
        id: 'es',
        title: 'ES projektu sagatavošana',
        description: 'Konsultācijas, dokumentu sagatavošana un projektu uzraudzība ES atbalsta programmās.',
        items: ['Projektu iesniegšana un uzraudzība']
      }
    ],
    process: {
      eyebrow: 'Sadarbības process',
      title: 'Kā notiek sadarbība',
      description: 'Skaidrs un pārskatāms process no pieteikuma līdz pabeigšanai.',
      steps: [
        { id: 1, title: 'Pieteikums', description: 'Klients sazinās ar mums, lai pieteiktu cirsmas vērtēšanu vai citu pakalpojumu.' },
        { id: 2, title: 'Īpašuma apsekošana', description: 'Veicam īpašuma apmeklējumu un nepieciešamos lauka darbus.' },
        { id: 3, title: 'Mērījumi un vērtēšana', description: 'Precīzi uzmērām mežaudzi un sagatavojam objektīvu vērtējumu.' },
        { id: 4, title: 'Dokumentācijas sagatavošana', description: 'Sagatavojam un iesniedzam nepieciešamos dokumentus valsts institūcijām.' },
        { id: 5, title: 'Darbu uzraudzība tiešsaistē', description: 'Klients var sekot līdzi darbu izpildei klientu portālā.' },
        { id: 6, title: 'Noslēguma atskaite', description: 'Sniedzam pārskatāmu atskaiti par paveiktajiem darbiem un rezultātiem.' }
      ]
    },
    portal: {
      eyebrow: 'Digitālā platforma',
      title: 'Digitālā platforma – Klientu portāls',
      description: 'Mūsu klientiem piedāvājam ērtu un drošu tiešsaistes klientu portālu, kas nodrošina nepārtrauktu piekļuvi informācijai par projekta vai darbu gaitu. Portāls ļauj vienuviet pārskatīt aktuālo informāciju, sekot darbu statusam un piekļūt visiem ar projektu saistītajiem dokumentiem.',
      subtitle: 'Platforma ir izstrādāta, lai nodrošinātu maksimālu pārskatāmību un ērtu komunikāciju starp klientu un mūsu komandu. Klienti jebkurā brīdī var redzēt aktuālo situāciju bez nepieciešamības sazināties papildus. Portāls ir pieejams gan no datora, gan mobilajām ierīcēm, tādējādi nodrošinot piekļuvi informācijai jebkurā vietā un laikā.',
      featuresTitle: 'Galvenās funkcijas',
      features: [
        { id: 1, title: 'Darbu statuss', description: 'Sekojiet līdzi projekta vai darbu progresam reāllaikā – redziet, vai darbi ir plānoti, procesā vai pabeigti.', icon: 'Activity' },
        { id: 2, title: 'Dokumentu pieejamība', description: 'Visi ar projektu saistītie dokumenti pieejami vienuviet. Tos iespējams apskatīt un lejupielādēt jebkurā laikā.', icon: 'FolderOpen' },
        { id: 3, title: 'Paziņojumi', description: 'Saņemiet aktuālu informāciju par projekta gaitu, izmaiņām vai svarīgiem jaunumiem.', icon: 'Bell' },
        { id: 4, title: 'Pieejams jebkur', description: 'Portāls darbojas gan datorā, gan mobilajās ierīcēs, nodrošinot ērtu piekļuvi neatkarīgi no atrašanās vietas.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Pieslēgties portālam',
      ctaRequest: 'Pieprasīt piekļuvi',
      preview: {
        headerTitle: 'Mani projekti',
        headerActive: '3 aktīvi',
        items: [
          { title: 'Cirsmas vērtēšana #127', status: 'Pabeigts', tone: 'success' },
          { title: 'Meža uzmērīšana', status: 'Procesā', tone: 'warning' },
          { title: 'Dokumentācija VMD', status: 'Plānots', tone: 'info' }
        ],
        footerLeft: 'Pēdējā aktivitāte: šodien',
        footerRight: '2 jauni dokumenti'
      }
    },
    why: {
      title: 'Kāpēc izvēlēties neatkarīgu cirsmu vērtēšanu',
      description: 'Cirsmas vērtēšana, ko veic potenciālais pircējs, vienmēr ir saistīta ar interešu konfliktu. Neatkarīga vērtēšana nodrošina objektīvu skatījumu uz cirsmas reālo vērtību un palīdz meža īpašniekam pieņemt pamatotus lēmumus.',
      conclusion: 'Neatkarīgs vērtējums bieži ļauj izvairīties no finansiāli neizdevīgiem darījumiem un sniedz skaidru priekšstatu par meža īpašuma potenciālu.',
      stats: [
        { value: '15-30%', label: 'Potenciālā ienākumu atšķirība' },
        { value: '100%', label: 'Objektīvs novērtējums' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Kāpēc cirsmas pircējs nav objektīvs vērtētājs?',
        content: 'Cirsmas pircējam ir finansiāla ieinteresētība iegādāties mežu par iespējami zemāku cenu. Tas rada interešu konfliktu, veicot vērtēšanu. Neatkarīgs vērtētājs strādā tikai jūsu interesēs.'
      },
      {
        id: 2,
        title: 'Kā neatkarīgs vērtējums ietekmē ienākumus?',
        content: 'Precīzs un neatkarīgs vērtējums ļauj noteikt patieso cirsmas vērtību un sarunās ar pircējiem panākt godīgu cenu. Daudzi meža īpašnieki, izmantojot neatkarīgu vērtējumu, ir ieguvuši par 15-30% augstāku cenu.'
      },
      {
        id: 3,
        title: 'Biežāk pieļautās kļūdas',
        content: 'Nepietiekama informācija par koksnes apjomiem, paļaušanās tikai uz pircēja vērtējumu, nesagatavota dokumentācija un nezināšana par tirgus cenām – tās ir biežākās kļūdas, kas samazina meža īpašnieka ienākumus.'
      }
    ],
    about: {
      title: 'Par uzņēmumu',
      subtitle: 'Pieredze mežsaimniecībā',
      description: 'Mēs esam mežsaimniecības pakalpojumu sniedzējs ar specializāciju neatkarīgā cirsmu vērtēšanā un precīzos meža uzmērījumos. Strādājam saskaņā ar Latvijas Republikas normatīvajiem aktiem un ciešā sadarbībā ar valsts institūcijām.',
      mission: 'Mūsu mērķis ir nodrošināt meža īpašniekiem korektu, caurspīdīgu un profesionālu pakalpojumu visā sadarbības procesā.',
      points: [
        'Specializējamies neatkarīgā cirsmu vērtēšanā',
        'Precīzi meža uzmērījumi atbilstoši normatīvajiem aktiem',
        'Cieša sadarbība ar Valsts meža dienestu',
        'Pilna dokumentācijas nodrošināšana',
        'Sadarbojamies gan ar fiziskām, gan juridiskām personām'
      ],
      regionsLabel: 'Darbības reģioni',
      regions: ['Rīga un apkārtne', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Ilgtspējīga meža apsaimniekošana',
      sustainabilityText: 'Mēs palīdzam meža īpašniekiem saglabāt meža vērtību arī nākamajām paaudzēm, ievērojot ilgtspējīgas apsaimniekošanas principus un normatīvos aktus.',
      testimonialsEyebrow: 'Atsauksmes',
      testimonialsTitle: 'Ko saka mūsu klienti',
      testimonialsDescription: 'Īstas pieredzes un vērtējumi par mūsu sadarbību.',
      testimonialsAdd: 'Pievienot atsauksmi',
      testimonialsLoading: 'Ielādē atsauksmes...',
      testimonialsEmpty: 'Šobrīd nav atsauksmju. Esiet pirmais, kas dalās pieredzē!',
      testimonialsModalTitle: 'Pievienot atsauksmi',
      form: {
        nameLabel: 'Vārds vai uzņēmums',
        regionLabel: 'Reģions',
        ratingLabel: 'Vērtējums',
        speedLabel: 'Ātrums',
        qualityLabel: 'Kvalitāte',
        communicationLabel: 'Komunikācija',
        responsivenessLabel: 'Atsaucība',
        textLabel: 'Atsauksmes teksts',
        cancel: 'Atcelt',
        submit: 'Nosūtīt atsauksmi',
        sending: 'Nosūta...',
        success: 'Atsauksme nosūtīta apstiprināšanai',
        error: 'Neizdevās nosūtīt atsauksmi. Lūdzu, mēģiniet vēlreiz.'
      },
      metrics: {
        speed: 'Ātrums',
        quality: 'Kvalitāte',
        communication: 'Komunikācija',
        responsiveness: 'Atsaucība'
      }
    },
    contact: {
      eyebrow: 'Sazinieties ar mums',
      title: 'Kontakti',
      description: 'Sazinieties ar mums, lai pieteiktu pakalpojumu vai saņemtu konsultāciju par Jūsu meža īpašumu.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Mežsaimniecības speciālists',
      formNote: 'Aizpildiet pieteikuma formu, un mēs ar Jums sazināsimies.',
      infoTitle: 'Kontaktinformācija',
      phoneLabel: 'Tālrunis',
      emailLabel: 'E-pasts',
      addressLabel: 'Juridiskā adrese',
      hoursLabel: 'Darba laiks',
      freeConsultationTitle: 'Bezmaksas konsultācija',
      freeConsultationText: 'Pirmā saruna un situācijas izvērtējums ir bez maksas. Sazinieties ar mums un kopīgi izlemsim labāko risinājumu.',
      formTitle: 'Pieteikuma forma',
      successTitle: 'Paldies par pieteikumu!',
      successBody: 'Mēs ar Jums sazināsimies tuvākajā laikā.',
      formNameLabel: 'Vārds, uzvārds',
      formNamePlaceholder: 'Jānis Bērziņš',
      formPhoneLabel: 'Tālruņa numurs',
      formPhonePlaceholder: '+371 20 123 456',
      formEmailLabel: 'E-pasta adrese',
      formEmailPlaceholder: 'janis@example.com',
      formMessageLabel: 'Ziņojums',
      formMessagePlaceholder: 'Jūsu jautājums vai situācijas apraksts...',
      formConsent: 'Iesūtot formu, jūs piekrītat savu personas datu apstrādei saskaņā ar GDPR prasībām.',
      formSubmitting: 'Nosūta...',
      formSubmit: 'Nosūtīt pieteikumu',
      toastSavedTitle: 'Pieteikums saglabāts',
      toastSavedBody: 'E‑pasta piegādei nepieciešams verificēts domēns. Ziņojums ir redzams admin portālā.',
      toastSentTitle: 'Pieteikums nosūtīts!',
      toastSentBody: 'Mēs ar Jums sazināsimies tuvākajā laikā.',
      toastErrorTitle: 'Kļūda nosūtot pieteikumu',
      submitError: 'Kļūda nosūtot pieteikumu. Lūdzu mēģiniet vēlreiz.',
      prefillLabel: 'Vēlos saņemt cenu piedāvājumu par'
    },
    cookie: {
      text: 'Šī vietne izmanto sīkdatnes, lai uzlabotu lietošanas pieredzi.',
      accept: 'Piekrītu'
    },
    privacy: {
      badge: 'Privātuma politika',
      title: 'Sila Meži privātuma politika',
      intro: 'Mēs rūpējamies par Jūsu datu drošību un privātumu. Šajā politikā skaidrojam, kādus datus apstrādājam un kāpēc.',
      controllerTitle: 'Datu pārzinis',
      controllerRegLabel: 'Reģ. Nr.:',
      controllerAddressLabel: 'Adrese:',
      controllerEmailLabel: 'E-pasts datu jautājumiem:',
      dataTitle: 'Kādi dati tiek apstrādāti',
      dataItemContact: 'Kontaktu formā iesniegtie dati (vārds, e-pasts, tālrunis, ziņa).',
      dataItemVisits: 'Apmeklējumu uzskaite pēc sīkdatņu piekrišanas (IP adrese, reģions, apmeklējuma laiks).',
      dataItemEmail: 'E-pastu nosūtīšanas dati, izmantojot Resend servisu.',
      visitsTitle: 'Apmeklējumu uzskaite',
      visitsText: 'Apmeklējumu uzskaite tiek veikta tikai pēc Jūsu sīkdatņu piekrišanas. Reģiona noteikšanai izmantojam IPinfo servisu.',
      cookiesTitle: 'Sīkdatnes',
      cookiesText: 'Šī vietne izmanto nepieciešamās, funkcionalitātes un statistikas sīkdatnes, lai nodrošinātu vietnes darbību, uzlabotu lietošanas pieredzi un saprastu apmeklējumu tendences.',
      retentionTitle: 'Datu glabāšana un tiesības',
      retentionText: 'Dati tiek glabāti tik ilgi, cik tas nepieciešams pakalpojumu nodrošināšanai vai likumā noteiktā kārtībā. Jums ir tiesības pieprasīt savu datu labošanu vai dzēšanu, rakstot uz augstāk norādīto e‑pasta adresi.',
      thirdPartyTitle: 'Trešo pušu pakalpojumi',
      thirdPartyText: 'Reģiona noteikšanai izmantojam IPinfo, bet e‑pastu piegādei Resend. Trešās puses datus apstrādā atbilstoši savām privātuma politikām.'
    },
    footer: {
      companyDescription: 'Neatkarīga cirsmu vērtēšana un mežsaimniecības pakalpojumi visā Latvijā. Strādājam tikai meža īpašnieka interesēs.',
      companyNote: 'Sadarbojamies gan ar fiziskām, gan ar juridiskām personām.',
      navigationTitle: 'Navigācija',
      servicesTitle: 'Pakalpojumi',
      contactTitle: 'Kontakti',
      quickLinks: {
        home: 'Sākums',
        services: 'Pakalpojumi',
        process: 'Kā notiek sadarbība',
        portal: 'Klientu portāls',
        why: 'Kāpēc neatkarīga vērtēšana',
        about: 'Par mums',
        contact: 'Kontakti'
      },
      services: {
        assessment: 'Cirsmas vērtēšana',
        measurements: 'Meža uzmērījumi',
        documentation: 'Dokumentu sagatavošana',
        euProjects: 'ES projekti'
      },
      rights: 'Visas tiesības aizsargātas.',
      privacy: 'Privātuma politika',
      terms: 'Lietošanas noteikumi'
    },
    nav: {
      home: 'Sākums',
      services: 'Pakalpojumi',
      works: 'Darbi',
      process: 'Sadarbība',
      why: 'Kāpēc mēs',
      about: 'Par mums',
      contact: 'Kontakti',
      portal: 'Klientu portāls',
      consult: 'Pieteikties',
      consultMobile: 'Pieteikties konsultācijai'
    },
    portalUi: {
      common: { loading: 'Ielādē...' },
      status: {
        planned: 'Plānots',
        inProgress: 'Procesā',
        completed: 'Pabeigts',
        active: 'Aktīvs',
        onHold: 'Pauzēts',
        awaitingInfo: 'Gaida informāciju',
        submitted: 'Iesniegts',
        notStarted: 'Nav sākts',
        verified: 'Pārbaudīts',
        delivered: 'Nodots klientam',
        closed: 'Slēgts'
      },
      nav: {
        client: {
          dashboard: 'Pārskats',
          projects: 'Projekti',
          jobs: 'Darbi',
          documents: 'Dokumenti',
          messages: 'Ziņojumi',
          contact: 'Kontakti'
        },
        admin: {
          dashboard: 'Pārskats',
          clients: 'Klienti',
          projects: 'Projekti',
          jobs: 'Darbi',
          documents: 'Dokumenti',
          messages: 'Paziņojumi',
          visitors: 'Apmeklējumi',
          testimonials: 'Atsauksmes',
          audit: 'Audit logs',
          payroll: 'Algas aprēķins',
          employees: 'Darbinieki',
          employeeTasks: 'Darba uzdevumi',
          workEntries: 'Darba atskaites',
          salary: 'Mēneša alga',
          taxSettings: 'Nodokļu likmes',
          profit: 'Objektu peļņa',
          mileage: 'Kilometri',
          finance: 'Finanses'
        },
        employee: {
          home: 'Sākums',
          tasks: 'Mani darba uzdevumi',
          entries: 'Manas atskaites'
        }
      },
      layout: {
        portalLabel: 'Klientu portāls',
        roleAdmin: 'Administrators',
        roleClient: 'Klients',
        roleEmployee: 'Darbinieks',
        logout: 'Izrakstīties'
      },
      login: {
        portalLabel: 'Klientu portāls',
        title: 'Pieslēgties klientu portālam',
        description: 'Šeit varat sekot līdzi darbu statusiem, dokumentiem un atskaitēm par Jūsu īpašumu.',
        usernameLabel: 'Lietotājvārds',
        usernamePlaceholder: 'Ievadiet lietotājvārdu',
        passwordLabel: 'Parole',
        passwordPlaceholder: 'Ievadiet paroli',
        togglePassword: 'Rādīt paroli',
        submit: 'Pieslēgties',
        submitting: 'Pieslēdzas...',
        forgotText: 'Aizmirsu paroli?',
        contactAdmin: 'Sazinieties ar administratoru',
        securityTitle: 'Drošības paziņojums',
        securityText: 'Piekļuve tikai autorizētiem klientiem. Ja nepieciešama piekļuve, sazinieties ar mums:',
        backToSite: 'Atpakaļ uz galveno lapu',
        successToast: 'Veiksmīgi pieslēdzāties!',
        errorFallback: 'Pieslēgšanās kļūda'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      finance: {
        title: 'Ieņēmumi un izdevumi',
        subtitle: 'Pievienojiet ierakstus, analizējiet statistiku un ieteikumus',
        addEntry: 'Pievienot ierakstu',
        statsTitle: 'Statistika pa mēnešiem',
        dailyStats: 'Statistika pa dienām',
        topCategories: 'Top kategorijas',
        noCategories: 'Nav datu',
        entriesTitle: 'Ieraksti',
        table: {
          date: 'Datums',
          type: 'Tips',
          category: 'Kategorija',
          description: 'Apraksts',
          amount: 'Summa',
          payment: 'Maksājums',
          target: 'Kam paredzēts',
          actions: 'Darbības'
        },
        edit: 'Rediģēt',
        delete: 'Dzēst',
        categoriesTitle: 'Kategorijas',
        categoryName: 'Nosaukums',
        categoryPurpose: 'Kam paredzēts',
        addCategory: 'Pievienot kategoriju',
        archiveCategory: 'Arhivēt',
        statementTitle: 'Bankas izdruku imports',
        previewStatement: 'Veidot priekšskatījumu',
        previewCount: 'Atrasti',
        previewEntries: 'ieraksti',
        confirmImport: 'Apstiprināt importu',
        statementPreview: 'Priekšskatījums gatavs',
        statementImported: 'Ieraksti importēti',
        statementValidation: 'Izvēlieties PDF failu',
        statementError: 'Neizdevās apstrādāt PDF',
        statementImportError: 'Neizdevās importēt',
        chatTitle: 'AI finanšu čats',
        chatEmpty: 'Uzdod jautājumu par izdevumiem/ieņēmumiem',
        chatPlaceholder: 'Kur varam ietaupīt šomēnes?',
        chatSend: 'Sūtīt',
        chatSending: 'Domā...',
        chatError: 'Neizdevās saņemt AI atbildi',
        toastLoadError: 'Neizdevās ielādēt finanšu datus',
        toastValidation: 'Aizpildiet obligātos laukus',
        toastCreated: 'Ieraksts pievienots',
        toastUpdated: 'Ieraksts atjaunināts',
        toastSaveError: 'Kļūda saglabājot ierakstu',
        toastDeleted: 'Ieraksts dzēsts',
        toastDeleteError: 'Neizdevās dzēst ierakstu',
        categoryValidation: 'Ievadiet kategorijas nosaukumu',
        categoryCreated: 'Kategorija pievienota',
        categoryError: 'Neizdevās pievienot kategoriju',
        categoryConfirmDelete: 'Arhivēt kategoriju?',
        confirmDelete: 'Dzēst ierakstu?',
        modalDescription: 'Ievadiet finanšu ierakstu',
        addEntryLabel: 'Pievienot ierakstu',
        editEntry: 'Rediģēt ierakstu',
        cancel: 'Atcelt',
        save: 'Saglabāt',
        form: {
          date: 'Datums',
          type: 'Tips',
          amount: 'Summa',
          category: 'Kategorija',
          categoryPlaceholder: 'Izvēlieties kategoriju',
          payment: 'Maksājuma veids',
          target: 'Kam paredzēts',
          description: 'Apraksts',
          client: 'Klients',
          clientPlaceholder: 'Izvēlieties klientu',
          project: 'Projekts',
          projectPlaceholder: 'Izvēlieties projektu'
        }
      },
      forbidden: {
        title: 'Nav piekļuves',
        description: 'Jums nav tiesību piekļūt šai sadaļai.',
        detail: 'Ja uzskātāt, ka tā ir kļūda, sazinieties ar administratoru.',
        backToPanel: 'Atpakaļ uz paneli',
        home: 'Galvenā lapa'
      },
      documents: {
        title: 'Pievienot dokumentu projektam',
        fileRequired: 'Lūdzu izvēlieties failu',
        uploadSuccess: 'Fails augšupielādēts',
        uploadError: 'Augšupielādes kļūda',
        fileLabel: 'Fails',
        fileInstruction: 'Klikšķiniet, lai izvēlētos failu',
        fileFormats: 'PDF, Excel, Word, Attēli',
        categoryLabel: 'Dokumenta veids',
        categories: [
          { value: 'skice', label: 'Skice' },
          { value: 'iesniegums', label: 'Iesniegums' },
          { value: 'ligums', label: 'Līgums' },
          { value: 'atskaite', label: 'Atskaite' },
          { value: 'foto', label: 'Foto' },
          { value: 'cits', label: 'Cits' }
        ],
        visibleLabel: 'Klientam redzams',
        visibleHint: 'Klients varēs redzēt un lejupielādēt šo dokumentu',
        upload: 'Augšupielādēt',
        uploading: 'Augšupielādē...',
        cancel: 'Atcelt'
      },
      client: {
        dashboard: {
          greeting: 'Sveicināti',
          subtitle: 'Jūsu',
          subtitleHighlight: 'klientu portāla pārskats',
          stats: {
            totalJobs: 'Kopā darbu',
            activeJobs: 'Aktīvie darbi',
            completedJobs: 'Pabeigti',
            newMessages: 'Jauni ziņojumi'
          },
          lastUpdate: 'Pēdējais atjauninājums:',
          actions: {
            jobsTitle: 'Skatīt visus darbus',
            jobsDescription: 'Pārskatīt darbu statusus un detaļas',
            documentsTitle: 'Dokumenti',
            documentsDescription: 'Apskatīt un lejuplādēt failus'
          },
          recentTitle: 'Pēdējie darbi',
          viewAll: 'Skatīt visus',
          responsibleLabel: 'Atbildīgais',
          emptyJobs: 'Vēl nav darbu'
        },
        projects: {
          title: 'Mani projekti',
          subtitlePrefix: 'Jūsu',
          subtitleHighlight: 'mežsaimniecības projekti',
          subtitleSuffix: 'un to progress',
          cadastralLabel: 'Kadastra Nr.:',
          progressLabel: 'Kopējais progress',
          jobsTotal: 'Kopā',
          jobsCompleted: 'Pabeigti',
          jobsInProgress: 'Procesā',
          jobsPlanned: 'Plānoti',
          nextStepTitle: 'Kas notiks tālāk?',
          viewDetails: 'Skatīt detaļas',
          emptyTitle: 'Nav projektu',
          emptySubtitle: 'Jūsu projekti parādīsies šeit, kad administrators tos izveidos.'
        },
        jobs: {
          title: 'Darbi',
          subtitlePrefix: 'Pārskatiet savus darbus un to',
          subtitleHighlight: 'statusus',
          searchPlaceholder: 'Meklēt darbus...',
          filterAll: 'Visi',
          filterPlanned: 'Plānoti',
          filterInProgress: 'Procesā',
          filterCompleted: 'Pabeigti',
          deadlineLabel: 'Līdz',
          emptyTitle: 'Nav atrasti darbi',
          emptyFiltered: 'Mēģiniet mainīt meklēšanas kritērijus',
          emptyAll: 'Vēl nav pievienoti darbi'
        },
        jobDetail: {
          backToJobs: 'Atpakaļ pie darbiem',
          notFoundTitle: 'Darbs nav atrasts',
          infoTitle: 'Darba informācija',
          responsibleLabel: 'Atbildīgais',
          startDateLabel: 'Sākuma datums',
          plannedEndLabel: 'Plānotais beigu datums',
          completedLabel: 'Pabeigts',
          notesTitle: 'Piezīmes',
          documentsTitle: 'Pievienotie dokumenti',
          documentsEmpty: 'Nav pievienotu dokumentu',
          downloadError: 'Neizdevās lejupielādēt dokumentu',
          timelineTitle: 'Statusa laika līnija',
          timelineEmpty: 'Nav vēstures ierakstu'
        },
        documents: {
          title: 'Dokumenti',
          subtitlePrefix: 'Apskatiet un lejuplādējiet savus',
          subtitleHighlight: 'dokumentus',
          searchPlaceholder: 'Meklēt dokumentus, projektus vai autorus...',
          filterAll: 'Visi',
          allProjects: 'Visi projekti',
          allUploaders: 'Visi autori',
          sortNewest: 'Jaunākie vispirms',
          sortOldest: 'Vecākie vispirms',
          latestOnly: 'Tikai jaunākās versijas',
          download: 'Lejuplādēt',
          downloadError: 'Neizdevās lejupielādēt dokumentu',
          emptyTitle: 'Nav dokumentu',
          emptyNoDocuments: 'Šobrīd nav pievienotu dokumentu.',
          emptyFiltered: 'Nav atrasti dokumenti pēc izvēlētajiem filtriem.',
          versionLabel: 'Versija',
          categoryOther: 'Citi',
          categories: {
            valsts_institucijam: 'Valsts institūcijām',
            atskaites: 'Atskaites',
            merijumu_dati: 'Mērījumu dati',
            skices: 'Skices',
            cits: 'Citi'
          }
        },
        messages: {
          title: 'Ziņojumi',
          subtitle: 'Paziņojumi un ziņas no administrācijas',
          inboxTitle: 'Ienākošā paste',
          emptyList: 'Nav ziņojumu',
          emptyDetailTitle: 'Izvēlieties ziņojumu',
          emptyDetailText: 'Noklikšķiniet uz ziņojuma, lai to izlasītu'
        },
        contact: {
          title: 'Kontakti',
          subtitlePrefix: 'Uzdodiet jautājumu vai',
          subtitleHighlight: 'sazinieties ar mums',
          phoneLabel: 'Tālrunis',
          emailLabel: 'E-pasts',
          hoursLabel: 'Darba laiks',
          formTitle: 'Nosūtīt ziņojumu',
          subjectLabel: 'Tēma',
          subjectPlaceholder: 'Ziņojuma tēma',
          messageLabel: 'Ziņojums',
          messagePlaceholder: 'Jūsu jautājums vai ziņojums...',
          submit: 'Nosūtīt',
          submitting: 'Nosūta...',
          successTitle: 'Ziņojums nosūtīts!',
          successBody: 'Mēs ar Jums sazināsimies.',
          toastSuccess: 'Ziņojums nosūtīts!',
          toastError: 'Kļūda nosūtot ziņojumu'
        }
      },
      admin: {
        employees: {
          title: 'Darbinieki',
          subtitle: 'Pārvaldiet darbinieku piekļuves',
          add: 'Pievienot darbinieku',
          search: 'Meklēt darbiniekus...',
          edit: 'Rediģēt',
          delete: 'Dzēst',
          addTitle: 'Jauns darbinieks',
          editTitle: 'Rediģēt darbinieku',
          modalDescription: 'Ievadiet darbinieka informāciju',
          toastLoadError: 'Neizdevās ielādēt darbiniekus',
          toastCreated: 'Darbinieks pievienots',
          toastUpdated: 'Darbinieks atjaunināts',
          toastDeleted: 'Darbinieks dzēsts',
          toastDeleteError: 'Neizdevās dzēst darbinieku',
          toastValidation: 'Aizpildiet obligātos laukus',
          toastPassword: 'Parolei jābūt vismaz 8 simbolu garai',
          toastError: 'Kļūda saglabājot darbinieku',
          confirmDelete: 'Vai tiešām dzēst darbinieku?',
          empty: 'Nav pievienotu darbinieku',
          cancel: 'Atcelt',
          save: 'Saglabāt',
          create: 'Izveidot',
          table: {
            name: 'Vārds',
            username: 'Lietotājvārds',
            actions: 'Darbības'
          },
          form: {
            name: 'Vārds',
            username: 'Lietotājvārds',
            password: 'Parole',
            passwordEdit: 'Jauna parole (neobligāti)'
          }
        },
        employeeTasks: {
          title: 'Darbinieku uzdevumi',
          subtitle: 'Piešķiriet uzdevumus un pārskatiet atskaites',
          addTask: 'Pievienot uzdevumu',
          edit: 'Rediģēt',
          delete: 'Dzēst',
          viewReports: 'Atskaites',
          reportsTitle: 'Darbinieka atskaites',
          reportsDescription: 'Pārskatiet iesniegtās atskaites un izdevumus',
          reportsEmpty: 'Atskaites vēl nav iesniegtas.',
          copyLink: 'Kopēt darbinieka linku',
          linkCopied: 'Saite nokopēta',
          viewReceipt: 'Skatīt čeku',
          deleteExpense: 'Dzēst izdevumu',
          expenses: 'Izdevumi',
          expensesEmpty: 'Izdevumu nav.',
          confirmDelete: 'Vai tiešām dzēst uzdevumu?',
          confirmExpenseDelete: 'Vai dzēst šo izdevumu?',
          toastLoadError: 'Neizdevās ielādēt darbinieku uzdevumus',
          toastCreated: 'Uzdevums pievienots',
          toastUpdated: 'Uzdevums atjaunināts',
          toastDeleted: 'Uzdevums dzēsts',
          toastError: 'Kļūda saglabājot uzdevumu',
          toastDeleteError: 'Neizdevās dzēst uzdevumu',
          toastReportsError: 'Neizdevās ielādēt atskaites',
          toastReceiptOpenError: 'Neizdevās atvērt čeku',
          toastExpenseDeleted: 'Izdevums dzēsts',
          toastExpenseDeleteError: 'Neizdevās dzēst izdevumu',
          modalDescription: 'Aizpildiet uzdevuma informāciju',
          addTitle: 'Jauns uzdevums',
          editTitle: 'Rediģēt uzdevumu',
          form: {
            title: 'Nosaukums',
            dueDate: 'Termiņš',
            employee: 'Darbinieks',
            employeePlaceholder: 'Izvēlieties darbinieku',
            priority: 'Prioritāte',
            client: 'Klients',
            clientPlaceholder: 'Izvēlieties klientu',
            clientNone: 'Nav',
            project: 'Projekts',
            projectPlaceholder: 'Izvēlieties projektu',
            projectNone: 'Nav',
            property: 'Īpašums',
            address: 'Adrese',
            description: 'Apraksts',
            status: 'Statuss'
          },
          filters: {
            employee: 'Darbinieks',
            status: 'Statuss',
            priority: 'Prioritāte',
            all: 'Visi'
          },
          table: {
            title: 'Uzdevums',
            employee: 'Darbinieks',
            client: 'Klients',
            dueDate: 'Termiņš',
            status: 'Statuss',
            priority: 'Prioritāte',
            reports: 'Atskaites',
            actions: 'Darbības'
          },
          empty: 'Nav piešķirtu uzdevumu',
          cancel: 'Atcelt',
          save: 'Saglabāt',
          create: 'Izveidot'
        },
        dashboard: {
          title: 'Administrācijas',
          titleSuffix: 'panelis',
          subtitlePrefix: 'Pārvaldiet',
          subtitleHighlight: 'klientus, darbus un dokumentus',
          stats: {
            totalClients: 'Kopā klientu',
            totalJobs: 'Kopā darbu',
            activeJobs: 'Aktīvie darbi',
            completedJobs: 'Pabeigti'
          },
          quick: {
            clientsTitle: 'Pārvaldīt klientus',
            clientsDescription: 'Pievienot, rediģēt klientus',
            jobsTitle: 'Pārvaldīt darbus',
            jobsDescription: 'Izveidot, atjaunināt darbus',
            documentsTitle: 'Dokumenti',
            documentsDescription: 'Augšupielādēt dokumentus'
          },
          recentTitle: 'Pēdējie darbi',
          viewAll: 'Skatīt visus',
          emptyJobs: 'Nav darbu'
        },
        clients: {
          title: 'Klienti',
          subtitle: 'Pārvaldiet lietotājus un piekļuves tiesības',
          addButton: 'Pievienot klientu',
          searchPlaceholder: 'Meklēt klientus...',
          table: {
            client: 'Klients',
            username: 'Lietotājvārds',
            contacts: 'Kontakti',
            role: 'Loma',
            status: 'Statuss',
            actions: 'Darbības'
          },
          roleAdmin: 'Admins',
          roleEmployee: 'Darbinieks',
          roleClient: 'Klients',
          statusActive: 'Aktīvs',
          statusInactive: 'Neaktīvs',
          confirmDelete: 'Vai tiešām vēlaties dzēst lietotāju "{name}"?',
          toastCreated: 'Lietotājs izveidots',
          toastUpdated: 'Lietotājs atjaunināts',
          toastDeleted: 'Lietotājs dzēsts',
          toastDeleteError: 'Kļūda dzēšot',
          toastError: 'Kļūda',
          passwordLengthError: 'Parolei jābūt vismaz 12 simbolu garai',
          modal: {
            addTitle: 'Pievienot klientu',
            editTitle: 'Rediģēt lietotāju',
            clientNameLabel: 'Klienta vārds / uzņēmums',
            clientNamePlaceholder: 'SIA Meža Īpašnieks',
            emailLabel: 'E-pasts',
            phoneLabel: 'Tālrunis',
            usernameLabel: 'Lietotājvārds',
            usernamePlaceholder: 'lietotajvards',
            passwordLabel: 'Parole *',
            passwordEditLabel: 'Jauna parole (neobligāti)',
            passwordPlaceholder: 'Vismaz 12 simboli',
            roleLabel: 'Loma',
            cancel: 'Atcelt',
            create: 'Izveidot',
            save: 'Saglabāt'
          }
        },
        projects: {
          title: 'Projektu pārvaldība',
          subtitle: 'Pārvaldiet klientu projektus un darbus',
          addButton: 'Jauns projekts',
          searchPlaceholder: 'Meklēt projektus...',
          progressLabel: 'Progress',
          stats: {
            total: 'Kopā projekti',
            active: 'Procesā',
            completed: 'Pabeigti',
            totalJobs: 'Kopā darbi'
          },
          jobsTotal: 'Kopā',
          jobsCompleted: 'Pabeigti',
          jobsInProgress: 'Procesā',
          jobsPlanned: 'Plānoti',
          editButton: 'Rediģēt',
          deleteButton: 'Dzēst',
          emptyState: 'Nav atrasts neviens projekts',
          confirmDelete: 'Vai tiešām vēlaties dzēst šo projektu?',
          toastCreated: 'Projekts izveidots',
          toastUpdated: 'Projekts atjaunināts',
          toastDeleted: 'Projekts dzēsts',
          toastDeleteError: 'Neizdevās dzēst projektu',
          toastError: 'Kļūda',
          toastLoadError: 'Neizdevās ielādēt projektus',
          noClient: 'Nav norādīts',
          modal: {
            addTitle: 'Jauns projekts',
            editTitle: 'Rediģēt projektu',
            nameLabel: 'Projekta nosaukums',
            namePlaceholder: 'Īpašums Lejasrunķi - Mežsaimniecības darbi 2026',
            clientLabel: 'Klients',
            clientPlaceholder: 'Izvēlieties klientu',
            propertyNameLabel: 'Īpašuma nosaukums',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Kadastra apzīmējums',
            addressLabel: 'Īpašuma adrese',
            addressPlaceholder: 'Ropažu novads',
            descriptionLabel: 'Apraksts',
            descriptionPlaceholder: 'Projekta detalizēts apraksts...',
            statusLabel: 'Statuss',
            nextStepLabel: 'Kas notiks tālāk?',
            nextStepPlaceholder: 'Pabeigt cirsmas stigošanu',
            cancel: 'Atcelt',
            create: 'Izveidot',
            save: 'Saglabāt'
          }
        },
        jobs: {
          title: 'Darbi',
          subtitle: 'Pārvaldiet darbus un to statusus',
          addButton: 'Pievienot darbu',
          searchPlaceholder: 'Meklēt darbus...',
          filterAll: 'Visi',
          table: {
            job: 'Darbs',
            client: 'Klients',
            status: 'Statuss',
            dates: 'Datumi',
            responsible: 'Atbildīgais',
            actions: 'Darbības'
          },
          deadlineLabel: 'Līdz',
          confirmDelete: 'Vai tiešām vēlaties dzēst darbu "{title}"?',
          unknownClient: 'Nezināms',
          toastCreated: 'Darbs izveidots',
          toastUpdated: 'Darbs atjaunināts',
          toastDeleted: 'Darbs dzēsts',
          toastDeleteError: 'Kļūda',
          toastError: 'Kļūda',
          modal: {
            addTitle: 'Pievienot darbu',
            editTitle: 'Rediģēt darbu',
            titleLabel: 'Darba nosaukums',
            titlePlaceholder: 'Augošu koku dastošana',
            descriptionLabel: 'Apraksts',
            descriptionPlaceholder: 'Darba apraksts...',
            clientLabel: 'Klients',
            clientPlaceholder: 'Izvēlieties klientu',
            projectLabel: 'Projekts',
            projectPlaceholder: 'Izvēlieties projektu',
            projectPlaceholderEmpty: 'Vispirms izvēlieties klientu',
            statusLabel: 'Statuss',
            responsibleLabel: 'Atbildīgais',
            responsiblePlaceholder: 'Jānis Bērziņš',
            startDateLabel: 'Sākuma datums',
            endDateLabel: 'Plānotais beigu datums',
            notesLabel: 'Piezīmes klientam',
            notesPlaceholder: 'Piezīmes, kas būs redzamas klientam...',
            cancel: 'Atcelt',
            create: 'Izveidot',
            save: 'Saglabāt'
          }
        },
        bulkJob: {
          title: 'Pievienot vairākus darbus projektam',
          selectLabel: 'Izvēlieties darba veidus:',
          selectAll: 'Izvēlēties visus',
          clearAll: 'Notīrīt',
          selectError: 'Lūdzu izvēlieties vismaz vienu darba veidu',
          selectedCount: 'Izvēlēti',
          selectedSuffix: 'darba veidi',
          statusNote: 'Visi darbi tiks izveidoti ar statusu "Plānots"',
          cancel: 'Atcelt',
          creating: 'Izveido...',
          createCount: 'Izveidot {count} darbus',
          successTitle: 'Veiksmīgi izveidoti darbi!',
          error: 'Neizdevās izveidot darbus',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Augošu koku dastošana' },
            { id: 'caurmera_merishana', label: 'Caurmēra mērīšana' },
            { id: 'cirsmas_stigoshana', label: 'Cirsmas stigošana' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Īpašuma robežu atjaunošana' },
            { id: 'robezzimju_atjaunoshana', label: 'Robežzīmju atjaunošana' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Paliekošo koku izzīmēšana izlases cirtē' },
            { id: 'cirsmu_iezimeshana', label: 'Cirsmu iezīmēšana' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentācijas sagatavošana' },
            { id: 'es_projektu_sagatavoshana', label: 'ES projektu sagatavošana' },
            { id: 'cits', label: 'Cits' }
          ]
        },
        audit: {
          title: 'Audit logs',
          subtitle: 'Sistēmas darbību vēsture',
          emptyTitle: 'Nav audit log ierakstu',
          emptyBody: 'Darbību vēsture parādīsies šeit'
        },
        visitors: {
          title: 'Apmeklējumu statistika',
          subtitle: 'Publiskās mājaslapas apmeklējumi',
          range7: '7 dienas',
          range30: '30 dienas',
          range7Short: '7 dienas',
          range30Short: '30 dienas',
          rangeOther: '{count} dienas',
          totalLabel: 'Kopā apmeklējumi',
          uniqueLabel: 'Unikālie apmeklētāji',
          periodLabel: 'Periods',
          dailyTitle: 'Dienu apmeklējumi',
          dailyEmpty: 'Nav apmeklējumu datu izvēlētajā periodā.',
          recentTitle: 'Pēdējie apmeklējumi',
          recentEmpty: 'Nav apmeklējumu ierakstu.',
          unknownRegion: 'Nezināms reģions',
          visitNumber: 'Apmeklējums #{number}'
        },
        testimonials: {
          title: 'Atsauksmju pārvaldība',
          subtitle: 'Apstipriniet vai paslēpiet klientu atsauksmes, pirms tās parādās mājaslapā.',
          filters: {
            all: 'Visas',
            pending: 'Gaida apstiprinājumu',
            approved: 'Publicētas',
            hidden: 'Paslēptas'
          },
          loading: 'Ielādē atsauksmes...',
          empty: 'Šobrīd nav atsauksmju, kas atbilst izvēlētajam filtram.',
          average: 'Vidēji {rating}/5',
          speed: 'Ātrums',
          quality: 'Kvalitāte',
          communication: 'Komunikācija',
          responsiveness: 'Atsaucība',
          publish: 'Publicēt',
          hide: 'Paslēpt',
          returnToPending: 'Atgriezt uz gaidīšanu'
        },
        payroll: {
          title: 'Algas aprēķins',
          subtitle: 'Darbinieku algas aprēķins pa mēnešiem',
          addEntry: 'Pievienot ierakstu',
          export: 'Eksportēt XLSX',
          confirmDelete: 'Vai tiešām dzēst šo ierakstu?',
          toastCreated: 'Ieraksts saglabāts',
          toastUpdated: 'Ieraksts atjaunots',
          toastDeleted: 'Ieraksts izdzēsts',
          toastDeleteError: 'Neizdevās izdzēst ierakstu',
          toastError: 'Neizdevās saglabāt ierakstu',
          validation: {
            employee: 'Lūdzu izvēlieties darbinieku',
            workTypes: 'Lūdzu atzīmē vismaz vienu darba veidu'
          },
          filters: {
            month: 'Mēnesis',
            year: 'Gads',
            employee: 'Darbinieks',
            client: 'Klients',
            status: 'Rēķins',
            statusAll: 'Visi',
            statusPaid: 'Apmaksāts',
            statusUnpaid: 'Neapmaksāts'
          },
          summary: {
            totalSalary: 'Bruto alga kopā',
            totalCosts: 'Izmaksas kopā',
            fuelCost: 'Degviela',
            paintCost: 'Krāsa'
          },
          table: {
            title: 'Algas ieraksti',
            date: 'Datums',
            employee: 'Darbinieks',
            client: 'Klients',
            property: 'Īpašums',
            workTypes: 'Darba veidi',
            salary: 'Bruto alga',
            costs: 'Izmaksas',
            paid: 'Apmaksāts',
            actions: 'Darbības',
            edit: 'Rediģēt',
            delete: 'Dzēst'
          },
          empty: {
            title: 'Nav algu ierakstu',
            body: 'Izvēlētajā periodā ierakstu nav.'
          },
          form: {
            addTitle: 'Jauns algas ieraksts',
            editTitle: 'Rediģēt algas ierakstu',
            date: 'Datums',
            employee: 'Darbinieks',
            client: 'Klients (pēc izvēles)',
            propertyName: 'Īpašuma nosaukums',
            cadastralNumber: 'Kadastra numurs',
            kilometers: 'Nobrauktie kilometri',
            paintCans: 'Krāsas baloni (gab.)',
            fuelRate: 'Degvielas likme (€/km)',
            paintPrice: 'Krāsas balona cena (€/gab.)',
            workTypes: 'Darba veidi',
            amount: 'Apjoms',
            rate: 'Likme',
            notes: 'Piezīmes',
            customRateNote: 'Likmi ievada manuāli',
            invoicePaid: 'Rēķins apmaksāts',
            save: 'Saglabāt',
            cancel: 'Atcelt'
          },
          totals: {
            salary: 'Darbinieka alga bruto',
            costs: 'Uzņēmuma izmaksas',
            fuel: 'Degvielas izmaksas',
            paint: 'Krāsas izmaksas'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Dastošana',
            cirsmas_stigoshana: 'Stigošana',
            caurmera_merishana: 'Caurmēra mērīšana',
            paliekoso_koku_izzimeshana: 'Paliekošo koku izzīmēšana',
            cirsmu_iezimeshana: 'Cirsmu iezīmēšana',
            ipashuma_robezu_atjaunoshana: 'Robežu atjaunošana',
            robezzimju_atjaunoshana: 'Robežzīmju atjaunošana'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'gab.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projekts nav atrasts',
          back: 'Atpakaļ',
          propertyLabel: 'Īpašums:',
          cadastralLabel: 'Kadastrs:',
          addressLabel: 'Adrese:',
          progressLabel: 'Kopējais progress',
          jobsTotal: 'Kopā darbi',
          jobsCompleted: 'Pabeigti',
          jobsInProgress: 'Procesā',
          jobsPlanned: 'Plānoti',
          nextStepTitle: 'Kas notiks tālāk?',
          jobsTitle: 'Darbi projektā',
          bulkAddJobs: 'Pievienot vairākus darbus',
          deadlineLabel: 'Termiņš',
          lastUpdateLabel: 'Pēdējā izmaiņa:',
          emptyJobs: 'Šim projektam vēl nav pievienots neviens darbs'
        }
      }
    }
  },
  en: {
    languageLabel: 'EN',
    company: {
      slogan: 'Sustainable forest management'
    },
    heroBadge: 'Independent forestry services',
    hero: {
      title: 'Independent felling area valuation for forest owners',
      subtitle: 'We help forest owners accurately assess the value of a felling area and prepare the forest for harvesting, providing professional measurements and all required documentation.',
      description: 'We work only in the forest owner interest – we do not buy felling areas and are not affiliated with timber buyers.',
      workIntro: 'What we do',
      workItems: [
        'Marking of standing trees',
        'Diameter measurements',
        'Felling area staking',
        'Restoration of property boundaries and markers',
        'Preparation and submission of documentation to institutions'
      ],
      workNote: 'Full list of works is available in the “Works” section.',
      reasonsTitle: 'Why choose us',
      reasons: [
        'Accurate forest measurements',
        'Independent felling area valuation',
        'Proper documentation',
        'Full process transparency'
      ],
      closing: 'Clients can track work progress online from anywhere.',
      tagline: 'Contact us for a professional approach!',
      ctaPrimary: 'Request felling area valuation',
      ctaSecondary: 'Client portal',
      salesHighlights: [
        'Independent valuation',
        'Accurate measurements',
        'Full documentation',
        'Full transparency'
      ],
      calloutTitle: 'Sila Meži guarantee',
      calloutBody: 'Accurate measurements. Proper documentation. Full transparency.',
      workLink: 'View works',
      scrollHint: 'Scroll down',
      subtitleHighlight: 'accurately assess the value of a felling area',
      descriptionHighlight: 'we do not buy felling areas and are not affiliated with timber buyers.'
    },
    trustBadges: [
      { id: 1, title: 'Accurate forest measurements', description: 'Detailed field measurements and analysis' },
      { id: 2, title: 'Independent felling area valuation', description: 'No interest in timber purchasing' },
      { id: 3, title: 'Proper documentation', description: 'Full preparation and submission support' },
      { id: 4, title: 'Full transparency', description: 'Clients track work online' }
    ],
    services: {
      eyebrow: 'Our services',
      title: 'Professional forestry services for forest owners',
      description: 'We provide a full range of forestry services — from forest valuation and measurements to document preparation, project management and organizing forestry works.',
      mission: 'Our goal is to help forest owners make informed decisions by providing accurate information, professional expertise and full process support.',
      ctaQuestion: 'Not sure which service you need?',
      ctaLink: 'Contact us for a free consultation'
    },
    servicesList: [
      {
        id: 1,
        category: 'Forest and felling area valuation',
        description: 'We provide professional valuation of standing trees and felling areas based on detailed field measurements, current market prices and regulations. The valuation is prepared independently from timber purchase, ensuring objective and reliable information for the owner.',
        items: [
          'Standing tree marking',
          'Tree diameter and other parameter measurements',
          'Felling area value calculation and analysis'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Forest measurements and boundary works',
        description: 'We provide forest measurement works and property boundary clarification in the field. All works are carried out based on cadastral data and applicable regulations. Accurate measurements help avoid boundary disputes and ensure proper forest management.',
        items: [
          'Felling area staking',
          'Restoration of property boundaries in the field',
          'Installation and restoration of boundary markers'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Forest regeneration and young stand care',
        description: 'We help forest owners ensure sustainable forest development by organizing regeneration and young stand care works. Proper care at early stages significantly affects forest quality and future value.',
        items: [
          'Organization of regeneration works',
          'Planning and coordination of planting',
          'Organization of young stand care'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Documentation preparation and approvals',
        description: 'We prepare and submit all required documentation to the State Forest Service and other institutions. We provide full administrative support throughout the process, so owners avoid bureaucracy.',
        items: [
          'Document preparation for state institutions',
          'Preparation and submission of applications',
          'Full administrative process support'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'EU support projects',
        description: 'We advise forest owners on available EU support instruments in forestry. We provide full project preparation and administration from idea to implementation.',
        items: [
          'Consultations on EU support options',
          'Project documentation preparation',
          'Project submission and monitoring'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Works',
      title: 'Works',
      description: 'Select the works you are interested in and we will prepare a precise price offer. Your selection will be automatically added to the request form.',
      summaryTitle: 'Selected works',
      summaryEmpty: 'No works selected. Choose a service from the list above.',
      requestCta: 'Request a price offer',
      contactCta: 'Contact us',
      selectError: 'Please select at least one work to request a price.',
      itemSelected: 'Added to price request',
      itemAdd: 'Mark to request a price'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Forestry works',
        description: 'Precise field works and felling area preparation for safe and proper forest management.',
        items: [
          'Felling area staking',
          'Tree marking',
          'Pruning of standing trees'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Forest regeneration and care',
        description: 'Sustainable forest development with targeted regeneration works.',
        items: [
          'Forest regeneration',
          'Young stand care',
          'Protection of young stands against animal damage'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Forest property management',
        description: 'Full-cycle forest property management and work coordination from planning to execution.',
        items: ['Forest property management']
      },
      {
        id: 'es',
        title: 'EU project preparation',
        description: 'Consultations, document preparation and project monitoring in EU support programs.',
        items: ['Project submission and monitoring']
      }
    ],
    process: {
      eyebrow: 'Collaboration process',
      title: 'How collaboration works',
      description: 'A clear and transparent process from request to completion.',
      steps: [
        { id: 1, title: 'Request', description: 'The client contacts us to request valuation or another service.' },
        { id: 2, title: 'Property inspection', description: 'We visit the property and perform required field work.' },
        { id: 3, title: 'Measurements and valuation', description: 'We measure the stand precisely and prepare an objective valuation.' },
        { id: 4, title: 'Documentation', description: 'We prepare and submit required documents to state institutions.' },
        { id: 5, title: 'Online progress tracking', description: 'The client can follow work progress in the portal.' },
        { id: 6, title: 'Final report', description: 'We provide a clear report on completed works and results.' }
      ]
    },
    portal: {
      eyebrow: 'Digital platform',
      title: 'Digital platform – Client portal',
      description: 'We provide our clients with a convenient and secure online portal that offers constant access to project and work progress. The portal lets you review updates, track status and access all project documents in one place.',
      subtitle: 'The platform is designed for maximum transparency and easy communication with our team. Clients can see the current situation at any time without additional calls. The portal works on desktop and mobile, giving access anywhere and anytime.',
      featuresTitle: 'Key features',
      features: [
        { id: 1, title: 'Work status', description: 'Track project progress in real time – planned, in progress or completed.', icon: 'Activity' },
        { id: 2, title: 'Document access', description: 'All project documents in one place, ready to view and download.', icon: 'FolderOpen' },
        { id: 3, title: 'Notifications', description: 'Receive updates about progress, changes and important news.', icon: 'Bell' },
        { id: 4, title: 'Accessible anywhere', description: 'Works on desktop and mobile, easy access from any location.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Log in to portal',
      ctaRequest: 'Request access',
      preview: {
        headerTitle: 'My projects',
        headerActive: '3 active',
        items: [
          { title: 'Felling area valuation #127', status: 'Completed', tone: 'success' },
          { title: 'Forest measurement', status: 'In progress', tone: 'warning' },
          { title: 'Documentation for SFS', status: 'Planned', tone: 'info' }
        ],
        footerLeft: 'Last activity: today',
        footerRight: '2 new documents'
      }
    },
    why: {
      title: 'Why choose independent valuation',
      description: 'Valuation performed by a potential buyer always involves a conflict of interest. Independent valuation provides an objective view of real value and helps owners make sound decisions.',
      conclusion: 'An independent valuation often helps avoid unfavorable deals and provides a clear understanding of the forest property potential.',
      stats: [
        { value: '15–30%', label: 'Potential income difference' },
        { value: '100%', label: 'Objective valuation' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Why is the buyer not an objective valuer?',
        content: 'A buyer has a financial interest in purchasing for the lowest possible price, which creates a conflict of interest. An independent valuer works only for your benefit.'
      },
      {
        id: 2,
        title: 'How does independent valuation affect income?',
        content: 'Accurate independent valuation helps determine true value and negotiate a fair price. Many owners gain 15–30% higher prices after independent valuation.'
      },
      {
        id: 3,
        title: 'Most common mistakes',
        content: 'Insufficient information about timber volumes, relying only on buyer valuation, unprepared documentation and lack of market price knowledge — these mistakes reduce owner income.'
      }
    ],
    about: {
      title: 'About the company',
      subtitle: 'Experience in forestry',
      description: 'We are a forestry service provider specializing in independent felling area valuation and precise forest measurements. We work in compliance with regulations and in close cooperation with state institutions.',
      mission: 'Our goal is to provide forest owners with a correct, transparent and professional service throughout the process.',
      points: [
        'Specialized in independent felling area valuation',
        'Accurate forest measurements in line with regulations',
        'Close cooperation with the State Forest Service',
        'Full documentation support',
        'Work with both individuals and legal entities'
      ],
      regionsLabel: 'Regions of operation',
      regions: ['Rīga and surroundings', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Sustainable forest management',
      sustainabilityText: 'We help forest owners preserve forest value for future generations, following sustainable management principles and regulations.',
      testimonialsEyebrow: 'Testimonials',
      testimonialsTitle: 'What our clients say',
      testimonialsDescription: 'Real experiences and feedback about our cooperation.',
      testimonialsAdd: 'Add testimonial',
      testimonialsLoading: 'Loading testimonials...',
      testimonialsEmpty: 'No testimonials yet. Be the first to share your experience!',
      testimonialsModalTitle: 'Add testimonial',
      form: {
        nameLabel: 'Name or company',
        regionLabel: 'Region',
        ratingLabel: 'Rating',
        speedLabel: 'Speed',
        qualityLabel: 'Quality',
        communicationLabel: 'Communication',
        responsivenessLabel: 'Responsiveness',
        textLabel: 'Testimonial text',
        cancel: 'Cancel',
        submit: 'Send testimonial',
        sending: 'Sending...',
        success: 'Testimonial sent for approval',
        error: 'Failed to send testimonial. Please try again.'
      },
      metrics: {
        speed: 'Speed',
        quality: 'Quality',
        communication: 'Communication',
        responsiveness: 'Responsiveness'
      }
    },
    contact: {
      eyebrow: 'Contact us',
      title: 'Contacts',
      description: 'Contact us to request a service or get a consultation about your forest property.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Forestry specialist',
      formNote: 'Fill out the form and we will contact you.',
      infoTitle: 'Contact information',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      addressLabel: 'Legal address',
      hoursLabel: 'Working hours',
      freeConsultationTitle: 'Free consultation',
      freeConsultationText: 'The first conversation and assessment are free of charge. Contact us and we will decide on the best solution.',
      formTitle: 'Request form',
      successTitle: 'Thank you for your request!',
      successBody: 'We will contact you shortly.',
      formNameLabel: 'Full name',
      formNamePlaceholder: 'Janis Berzins',
      formPhoneLabel: 'Phone number',
      formPhonePlaceholder: '+371 20 123 456',
      formEmailLabel: 'Email address',
      formEmailPlaceholder: 'janis@example.com',
      formMessageLabel: 'Message',
      formMessagePlaceholder: 'Your question or situation description...',
      formConsent: 'By submitting the form you agree to the processing of your personal data according to GDPR.',
      formSubmitting: 'Sending...',
      formSubmit: 'Send request',
      toastSavedTitle: 'Request saved',
      toastSavedBody: 'Email delivery requires a verified domain. The message is visible in the admin portal.',
      toastSentTitle: 'Request sent!',
      toastSentBody: 'We will contact you shortly.',
      toastErrorTitle: 'Error sending request',
      submitError: 'Error sending request. Please try again.',
      prefillLabel: 'I want a price offer for'
    },
    cookie: {
      text: 'This site uses cookies to improve your experience.',
      accept: 'Accept'
    },
    privacy: {
      badge: 'Privacy policy',
      title: 'Sila Meži privacy policy',
      intro: 'We care about your data security and privacy. This policy explains what data we process and why.',
      controllerTitle: 'Data controller',
      controllerRegLabel: 'Reg. No.:',
      controllerAddressLabel: 'Address:',
      controllerEmailLabel: 'Email for data inquiries:',
      dataTitle: 'What data is processed',
      dataItemContact: 'Contact form data (name, email, phone, message).',
      dataItemVisits: 'Visit tracking after cookie consent (IP address, region, visit time).',
      dataItemEmail: 'Email delivery data via Resend service.',
      visitsTitle: 'Visit tracking',
      visitsText: 'Visits are tracked only after your cookie consent. We use IPinfo to determine region.',
      cookiesTitle: 'Cookies',
      cookiesText: 'This site uses necessary, functional and statistical cookies to ensure operation, improve experience and understand visitor trends.',
      retentionTitle: 'Data retention and rights',
      retentionText: 'Data is stored as long as needed to provide services or as required by law. You may request correction or deletion by writing to the email above.',
      thirdPartyTitle: 'Third-party services',
      thirdPartyText: 'We use IPinfo for region detection and Resend for email delivery. Third parties process data according to their privacy policies.'
    },
    footer: {
      companyDescription: 'Independent felling area valuation and forestry services across Latvia. We work only in the forest owner interest.',
      companyNote: 'We work with both individuals and legal entities.',
      navigationTitle: 'Navigation',
      servicesTitle: 'Services',
      contactTitle: 'Contacts',
      quickLinks: {
        home: 'Home',
        services: 'Services',
        process: 'How it works',
        portal: 'Client portal',
        why: 'Why independent valuation',
        about: 'About us',
        contact: 'Contacts'
      },
      services: {
        assessment: 'Felling area valuation',
        measurements: 'Forest measurements',
        documentation: 'Document preparation',
        euProjects: 'EU projects'
      },
      rights: 'All rights reserved.',
      privacy: 'Privacy policy',
      terms: 'Terms of use'
    },
    nav: {
      home: 'Home',
      services: 'Services',
      works: 'Works',
      process: 'Process',
      why: 'Why us',
      about: 'About',
      contact: 'Contacts',
      portal: 'Client portal',
      consult: 'Apply',
      consultMobile: 'Request consultation'
    },
    portalUi: {
      common: { loading: 'Loading...' },
      status: {
        planned: 'Planned',
        inProgress: 'In progress',
        completed: 'Completed',
        active: 'Active',
        onHold: 'On hold',
        awaitingInfo: 'Awaiting info',
        submitted: 'Submitted',
        notStarted: 'Not started',
        verified: 'Verified',
        delivered: 'Delivered to client',
        closed: 'Closed'
      },
      nav: {
        client: {
          dashboard: 'Overview',
          projects: 'Projects',
          jobs: 'Jobs',
          documents: 'Documents',
          messages: 'Messages',
          contact: 'Contact'
        },
        admin: {
          dashboard: 'Overview',
          clients: 'Clients',
          projects: 'Projects',
          jobs: 'Jobs',
          documents: 'Documents',
          messages: 'Notifications',
          visitors: 'Visits',
          testimonials: 'Testimonials',
          audit: 'Audit logs',
          payroll: 'Payroll'
        }
      },
      layout: {
        portalLabel: 'Client portal',
        roleAdmin: 'Administrator',
        roleClient: 'Client',
        logout: 'Log out'
      },
      login: {
        portalLabel: 'Client portal',
        title: 'Log in to the client portal',
        description: 'Track work statuses, documents and reports about your property.',
        usernameLabel: 'Username',
        usernamePlaceholder: 'Enter username',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter password',
        togglePassword: 'Show password',
        submit: 'Log in',
        submitting: 'Logging in...',
        forgotText: 'Forgot password?',
        contactAdmin: 'Contact administrator',
        securityTitle: 'Security notice',
        securityText: 'Access for authorized clients only. For access, contact us:',
        backToSite: 'Back to home',
        successToast: 'Logged in successfully!',
        errorFallback: 'Login error'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Access denied',
        description: 'You do not have permission to access this section.',
        detail: 'If you believe this is an error, contact the administrator.',
        backToPanel: 'Back to dashboard',
        home: 'Home'
      },
      documents: {
        title: 'Add document to project',
        fileRequired: 'Please select a file',
        uploadSuccess: 'File uploaded',
        uploadError: 'Upload error',
        fileLabel: 'File',
        fileInstruction: 'Click to select a file',
        fileFormats: 'PDF, Excel, Word, Images',
        categoryLabel: 'Document type',
        categories: [
          { value: 'skice', label: 'Sketch' },
          { value: 'iesniegums', label: 'Application' },
          { value: 'ligums', label: 'Contract' },
          { value: 'atskaite', label: 'Report' },
          { value: 'foto', label: 'Photo' },
          { value: 'cits', label: 'Other' }
        ],
        visibleLabel: 'Visible to client',
        visibleHint: 'The client will be able to view and download this document',
        upload: 'Upload',
        uploading: 'Uploading...',
        cancel: 'Cancel'
      },
      client: {
        dashboard: {
          greeting: 'Welcome',
          subtitle: 'Your',
          subtitleHighlight: 'client portal overview',
          stats: {
            totalJobs: 'Total jobs',
            activeJobs: 'Active jobs',
            completedJobs: 'Completed',
            newMessages: 'New messages'
          },
          lastUpdate: 'Last update:',
          actions: {
            jobsTitle: 'View all jobs',
            jobsDescription: 'Review job statuses and details',
            documentsTitle: 'Documents',
            documentsDescription: 'View and download files'
          },
          recentTitle: 'Recent jobs',
          viewAll: 'View all',
          responsibleLabel: 'Responsible',
          emptyJobs: 'No jobs yet'
        },
        projects: {
          title: 'My projects',
          subtitlePrefix: 'Your',
          subtitleHighlight: 'forestry projects',
          subtitleSuffix: 'and their progress',
          cadastralLabel: 'Cadastral No.:',
          progressLabel: 'Overall progress',
          jobsTotal: 'Total',
          jobsCompleted: 'Completed',
          jobsInProgress: 'In progress',
          jobsPlanned: 'Planned',
          nextStepTitle: 'What is next?',
          viewDetails: 'View details',
          emptyTitle: 'No projects',
          emptySubtitle: 'Your projects will appear here when the administrator creates them.'
        },
        jobs: {
          title: 'Jobs',
          subtitlePrefix: 'Review your jobs and their',
          subtitleHighlight: 'statuses',
          searchPlaceholder: 'Search jobs...',
          filterAll: 'All',
          filterPlanned: 'Planned',
          filterInProgress: 'In progress',
          filterCompleted: 'Completed',
          deadlineLabel: 'Until',
          emptyTitle: 'No jobs found',
          emptyFiltered: 'Try changing the search criteria',
          emptyAll: 'No jobs added yet'
        },
        jobDetail: {
          backToJobs: 'Back to jobs',
          notFoundTitle: 'Job not found',
          infoTitle: 'Job information',
          responsibleLabel: 'Responsible',
          startDateLabel: 'Start date',
          plannedEndLabel: 'Planned end date',
          completedLabel: 'Completed',
          notesTitle: 'Notes',
          documentsTitle: 'Attached documents',
          documentsEmpty: 'No documents attached',
          downloadError: 'Failed to download document',
          timelineTitle: 'Status timeline',
          timelineEmpty: 'No history entries'
        },
        documents: {
          title: 'Documents',
          subtitlePrefix: 'View and download your',
          subtitleHighlight: 'documents',
          searchPlaceholder: 'Search documents, projects or authors...',
          filterAll: 'All',
          allProjects: 'All projects',
          allUploaders: 'All authors',
          sortNewest: 'Newest first',
          sortOldest: 'Oldest first',
          latestOnly: 'Latest versions only',
          download: 'Download',
          downloadError: 'Failed to download document',
          emptyTitle: 'No documents',
          emptyNoDocuments: 'No documents available yet.',
          emptyFiltered: 'No documents match the selected filters.',
          versionLabel: 'Version',
          categoryOther: 'Other',
          categories: {
            valsts_institucijam: 'State institutions',
            atskaites: 'Reports',
            merijumu_dati: 'Measurement data',
            skices: 'Sketches',
            cits: 'Other'
          }
        },
        messages: {
          title: 'Messages',
          subtitle: 'Notifications and messages from administration',
          inboxTitle: 'Inbox',
          emptyList: 'No messages',
          emptyDetailTitle: 'Select a message',
          emptyDetailText: 'Click a message to read it'
        },
        contact: {
          title: 'Contact',
          subtitlePrefix: 'Ask a question or',
          subtitleHighlight: 'contact us',
          phoneLabel: 'Phone',
          emailLabel: 'Email',
          hoursLabel: 'Working hours',
          formTitle: 'Send a message',
          subjectLabel: 'Subject',
          subjectPlaceholder: 'Message subject',
          messageLabel: 'Message',
          messagePlaceholder: 'Your question or message...',
          submit: 'Send',
          submitting: 'Sending...',
          successTitle: 'Message sent!',
          successBody: 'We will contact you.',
          toastSuccess: 'Message sent!',
          toastError: 'Error sending message'
        }
      },
      admin: {
        dashboard: {
          title: 'Administration',
          titleSuffix: 'dashboard',
          subtitlePrefix: 'Manage',
          subtitleHighlight: 'clients, jobs and documents',
          stats: {
            totalClients: 'Total clients',
            totalJobs: 'Total jobs',
            activeJobs: 'Active jobs',
            completedJobs: 'Completed'
          },
          quick: {
            clientsTitle: 'Manage clients',
            clientsDescription: 'Add and edit clients',
            jobsTitle: 'Manage jobs',
            jobsDescription: 'Create and update jobs',
            documentsTitle: 'Documents',
            documentsDescription: 'Upload documents'
          },
          recentTitle: 'Recent jobs',
          viewAll: 'View all',
          emptyJobs: 'No jobs'
        },
        clients: {
          title: 'Clients',
          subtitle: 'Manage users and access rights',
          addButton: 'Add client',
          searchPlaceholder: 'Search clients...',
          table: {
            client: 'Client',
            username: 'Username',
            contacts: 'Contacts',
            role: 'Role',
            status: 'Status',
            actions: 'Actions'
          },
          roleAdmin: 'Admin',
          roleClient: 'Client',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          confirmDelete: 'Are you sure you want to delete user "{name}"?',
          toastCreated: 'User created',
          toastUpdated: 'User updated',
          toastDeleted: 'User deleted',
          toastDeleteError: 'Delete error',
          toastError: 'Error',
          passwordLengthError: 'Password must be at least 12 characters',
          modal: {
            addTitle: 'Add client',
            editTitle: 'Edit user',
            clientNameLabel: 'Client name / company',
            clientNamePlaceholder: 'Forest Owner LLC',
            emailLabel: 'Email',
            phoneLabel: 'Phone',
            usernameLabel: 'Username',
            usernamePlaceholder: 'username',
            passwordLabel: 'Password *',
            passwordEditLabel: 'New password (optional)',
            passwordPlaceholder: 'At least 12 characters',
            roleLabel: 'Role',
            cancel: 'Cancel',
            create: 'Create',
            save: 'Save'
          }
        },
        projects: {
          title: 'Project management',
          subtitle: 'Manage client projects and jobs',
          addButton: 'New project',
          searchPlaceholder: 'Search projects...',
          progressLabel: 'Progress',
          stats: {
            total: 'Total projects',
            active: 'In progress',
            completed: 'Completed',
            totalJobs: 'Total jobs'
          },
          jobsTotal: 'Total',
          jobsCompleted: 'Completed',
          jobsInProgress: 'In progress',
          jobsPlanned: 'Planned',
          editButton: 'Edit',
          deleteButton: 'Delete',
          emptyState: 'No projects found',
          confirmDelete: 'Are you sure you want to delete this project?',
          toastCreated: 'Project created',
          toastUpdated: 'Project updated',
          toastDeleted: 'Project deleted',
          toastDeleteError: 'Failed to delete project',
          toastError: 'Error',
          toastLoadError: 'Failed to load projects',
          noClient: 'Not specified',
          modal: {
            addTitle: 'New project',
            editTitle: 'Edit project',
            nameLabel: 'Project name',
            namePlaceholder: 'Lejasrunki property – Forestry works 2026',
            clientLabel: 'Client',
            clientPlaceholder: 'Select client',
            propertyNameLabel: 'Property name',
            propertyNamePlaceholder: 'Lejasrunki',
            cadastralLabel: 'Cadastral ID',
            addressLabel: 'Property address',
            addressPlaceholder: 'Ropazi municipality',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Detailed project description...',
            statusLabel: 'Status',
            nextStepLabel: 'What is next?',
            nextStepPlaceholder: 'Finish felling area staking',
            cancel: 'Cancel',
            create: 'Create',
            save: 'Save'
          }
        },
        jobs: {
          title: 'Jobs',
          subtitle: 'Manage jobs and their statuses',
          addButton: 'Add job',
          searchPlaceholder: 'Search jobs...',
          filterAll: 'All',
          table: {
            job: 'Job',
            client: 'Client',
            status: 'Status',
            dates: 'Dates',
            responsible: 'Responsible',
            actions: 'Actions'
          },
          deadlineLabel: 'Until',
          confirmDelete: 'Are you sure you want to delete job "{title}"?',
          unknownClient: 'Unknown',
          toastCreated: 'Job created',
          toastUpdated: 'Job updated',
          toastDeleted: 'Job deleted',
          toastDeleteError: 'Error',
          toastError: 'Error',
          modal: {
            addTitle: 'Add job',
            editTitle: 'Edit job',
            titleLabel: 'Job title',
            titlePlaceholder: 'Standing tree marking',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Job description...',
            clientLabel: 'Client',
            clientPlaceholder: 'Select client',
            projectLabel: 'Project',
            projectPlaceholder: 'Select project',
            projectPlaceholderEmpty: 'Select client first',
            statusLabel: 'Status',
            responsibleLabel: 'Responsible',
            responsiblePlaceholder: 'Janis Berzins',
            startDateLabel: 'Start date',
            endDateLabel: 'Planned end date',
            notesLabel: 'Notes for client',
            notesPlaceholder: 'Notes visible to client...',
            cancel: 'Cancel',
            create: 'Create',
            save: 'Save'
          }
        },
        bulkJob: {
          title: 'Add multiple jobs to a project',
          selectLabel: 'Select job types:',
          selectAll: 'Select all',
          clearAll: 'Clear',
          selectError: 'Please select at least one job type',
          selectedCount: 'Selected',
          selectedSuffix: 'job types',
          statusNote: 'All jobs will be created with status "Planned"',
          cancel: 'Cancel',
          creating: 'Creating...',
          createCount: 'Create {count} jobs',
          successTitle: 'Jobs created successfully!',
          error: 'Failed to create jobs',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Standing tree marking' },
            { id: 'caurmera_merishana', label: 'Diameter measurement' },
            { id: 'cirsmas_stigoshana', label: 'Felling area staking' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Property boundary restoration' },
            { id: 'robezzimju_atjaunoshana', label: 'Boundary marker restoration' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Retention tree marking in selective felling' },
            { id: 'cirsmu_iezimeshana', label: 'Felling area marking' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Documentation preparation' },
            { id: 'es_projektu_sagatavoshana', label: 'EU project preparation' },
            { id: 'cits', label: 'Other' }
          ]
        },
        audit: {
          title: 'Audit logs',
          subtitle: 'System activity history',
          emptyTitle: 'No audit log entries',
          emptyBody: 'Activity history will appear here'
        },
        visitors: {
          title: 'Visitor analytics',
          subtitle: 'Public website visits',
          range7: '7 days',
          range30: '30 days',
          range7Short: '7 days',
          range30Short: '30 days',
          rangeOther: '{count} days',
          totalLabel: 'Total visits',
          uniqueLabel: 'Unique visitors',
          periodLabel: 'Period',
          dailyTitle: 'Daily visits',
          dailyEmpty: 'No visit data for the selected period.',
          recentTitle: 'Recent visits',
          recentEmpty: 'No visit records.',
          unknownRegion: 'Unknown region',
          visitNumber: 'Visit #{number}'
        },
        testimonials: {
          title: 'Testimonials management',
          subtitle: 'Approve or hide client testimonials before they appear on the website.',
          filters: {
            all: 'All',
            pending: 'Pending approval',
            approved: 'Published',
            hidden: 'Hidden'
          },
          loading: 'Loading testimonials...',
          empty: 'No testimonials match the selected filter.',
          average: 'Average {rating}/5',
          speed: 'Speed',
          quality: 'Quality',
          communication: 'Communication',
          responsiveness: 'Responsiveness',
          publish: 'Publish',
          hide: 'Hide',
          returnToPending: 'Return to pending'
        },
        payroll: {
          title: 'Payroll calculation',
          subtitle: 'Monthly payroll calculation for employees',
          addEntry: 'Add entry',
          export: 'Export XLSX',
          confirmDelete: 'Are you sure you want to delete this entry?',
          toastCreated: 'Entry saved',
          toastUpdated: 'Entry updated',
          toastDeleted: 'Entry deleted',
          toastDeleteError: 'Failed to delete entry',
          toastError: 'Failed to save entry',
          validation: {
            employee: 'Please select an employee',
            workTypes: 'Please select at least one work type'
          },
          filters: {
            month: 'Month',
            year: 'Year',
            employee: 'Employee',
            client: 'Client',
            status: 'Invoice',
            statusAll: 'All',
            statusPaid: 'Paid',
            statusUnpaid: 'Unpaid'
          },
          summary: {
            totalSalary: 'Total gross salary',
            totalCosts: 'Total costs',
            fuelCost: 'Fuel',
            paintCost: 'Paint'
          },
          table: {
            title: 'Payroll entries',
            date: 'Date',
            employee: 'Employee',
            client: 'Client',
            property: 'Property',
            workTypes: 'Work types',
            salary: 'Gross salary',
            costs: 'Costs',
            paid: 'Paid',
            actions: 'Actions',
            edit: 'Edit',
            delete: 'Delete'
          },
          empty: {
            title: 'No payroll entries',
            body: 'There are no entries for the selected period.'
          },
          form: {
            addTitle: 'New payroll entry',
            editTitle: 'Edit payroll entry',
            date: 'Date',
            employee: 'Employee',
            client: 'Client (optional)',
            propertyName: 'Property name',
            cadastralNumber: 'Cadastral number',
            kilometers: 'Kilometers traveled',
            paintCans: 'Paint cans (pcs.)',
            fuelRate: 'Fuel rate (€/km)',
            paintPrice: 'Paint can price (€/pcs.)',
            workTypes: 'Work types',
            amount: 'Amount',
            rate: 'Rate',
            notes: 'Notes',
            customRateNote: 'Rate entered manually',
            invoicePaid: 'Payment received',
            save: 'Save',
            cancel: 'Cancel'
          },
          totals: {
            salary: 'Gross salary',
            costs: 'Company costs',
            fuel: 'Fuel cost',
            paint: 'Paint cost'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Tree marking',
            cirsmas_stigoshana: 'Staking',
            caurmera_merishana: 'Diameter measurement',
            paliekoso_koku_izzimeshana: 'Retention tree marking',
            cirsmu_iezimeshana: 'Felling area marking',
            ipashuma_robezu_atjaunoshana: 'Boundary restoration',
            robezzimju_atjaunoshana: 'Boundary marker restoration'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'pcs.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Project not found',
          back: 'Back',
          propertyLabel: 'Property:',
          cadastralLabel: 'Cadastral:',
          addressLabel: 'Address:',
          progressLabel: 'Overall progress',
          jobsTotal: 'Total jobs',
          jobsCompleted: 'Completed',
          jobsInProgress: 'In progress',
          jobsPlanned: 'Planned',
          nextStepTitle: 'What is next?',
          jobsTitle: 'Project jobs',
          bulkAddJobs: 'Add multiple jobs',
          deadlineLabel: 'Deadline',
          lastUpdateLabel: 'Last update:',
          emptyJobs: 'No jobs have been added to this project yet'
        }
      }
    }
  },
  ru: {
    languageLabel: 'RU',
    company: {
      slogan: 'Устойчивое лесоуправление'
    },
    heroBadge: 'Независимые лесохозяйственные услуги',
    hero: {
      title: 'Независимая оценка делянок для владельцев леса',
      subtitle: 'Помогаем владельцам леса точно оценить стоимость делянки и подготовить лес к рубке, выполняя профессиональные измерения и всю необходимую документацию.',
      description: 'Мы работаем только в интересах владельца леса — не покупаем делянки и не связаны с покупателями древесины.',
      workIntro: 'Что мы выполняем',
      workItems: [
        'Маркировка стоящих деревьев',
        'Измерение диаметра',
        'Разметка делянки',
        'Восстановление границ и межевых знаков',
        'Подготовка и подача документации в учреждения'
      ],
      workNote: 'Полный список работ доступен в разделе «Работы».',
      reasonsTitle: 'Почему выбирают нас',
      reasons: [
        'Точные лесные измерения',
        'Независимая оценка делянок',
        'Корректная документация',
        'Полная прозрачность процесса'
      ],
      closing: 'Клиенты могут онлайн отслеживать выполнение работ из любой точки.',
      tagline: 'Свяжитесь с нами за профессиональным подходом!',
      ctaPrimary: 'Заказать оценку делянки',
      ctaSecondary: 'Клиентский портал',
      salesHighlights: [
        'Независимая оценка',
        'Точные измерения',
        'Полная документация',
        'Полная прозрачность'
      ],
      calloutTitle: 'Гарантия Sila Meži',
      calloutBody: 'Точные измерения. Корректная документация. Полная прозрачность.',
      workLink: 'Посмотреть работы',
      scrollHint: 'Листайте дальше',
      subtitleHighlight: 'точно оценить стоимость делянки',
      descriptionHighlight: 'не покупаем делянки и не связаны с покупателями древесины.'
    },
    trustBadges: [
      { id: 1, title: 'Точные лесные измерения', description: 'Подробные полевые измерения и анализ' },
      { id: 2, title: 'Независимая оценка делянок', description: 'Без интереса к покупке древесины' },
      { id: 3, title: 'Корректная документация', description: 'Полное сопровождение подготовки и подачи' },
      { id: 4, title: 'Полная прозрачность', description: 'Клиенты отслеживают работы онлайн' }
    ],
    services: {
      eyebrow: 'Наши услуги',
      title: 'Профессиональные лесохозяйственные услуги для владельцев леса',
      description: 'Предлагаем полный спектр лесохозяйственных услуг — от оценки и измерений до подготовки документов, управления проектами и организации работ.',
      mission: 'Наша цель — помочь владельцам леса принимать обоснованные решения, предоставляя точные данные, профессиональный подход и полное сопровождение.',
      ctaQuestion: 'Не уверены, какая услуга вам нужна?',
      ctaLink: 'Свяжитесь с нами для бесплатной консультации'
    },
    servicesList: [
      {
        id: 1,
        category: 'Оценка леса и делянок',
        description: 'Проводим профессиональную оценку стоящих деревьев и делянок на основе детальных полевых измерений, актуальных рыночных цен и действующих норм. Оценка выполняется независимо от покупки древесины, что обеспечивает объективность.',
        items: [
          'Маркировка стоящих деревьев',
          'Измерение диаметра и других параметров',
          'Расчёт и анализ стоимости делянки'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Измерения леса и работы по границам',
        description: 'Выполняем измерения леса и уточнение границ в натуре. Все работы проводятся на основе кадастровых данных и действующих норм. Точные измерения помогают избежать споров и обеспечить корректное управление лесом.',
        items: [
          'Разметка делянки',
          'Восстановление границ участка на местности',
          'Установка и восстановление межевых знаков'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Лесовосстановление и уход за молодняком',
        description: 'Помогаем обеспечить устойчивое развитие леса, организуя работы по восстановлению и уходу за молодняком. Правильный уход на ранних этапах влияет на качество и будущую ценность леса.',
        items: [
          'Организация работ по лесовосстановлению',
          'Планирование и координация посадок',
          'Организация ухода за молодняком'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Подготовка документов и согласования',
        description: 'Готовим и подаём все необходимые документы в Государственную лесную службу и другие учреждения. Обеспечиваем полную административную поддержку, чтобы избежать бюрократии.',
        items: [
          'Подготовка документов для госучреждений',
          'Подготовка и подача заявлений',
          'Полное сопровождение административного процесса'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'Проекты поддержки ЕС',
        description: 'Консультируем владельцев леса по программам поддержки ЕС. Обеспечиваем полный цикл подготовки и администрирования проектов — от идеи до реализации.',
        items: [
          'Консультации по возможностям поддержки ЕС',
          'Подготовка проектной документации',
          'Подача и мониторинг проектов'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Работы',
      title: 'Работы',
      description: 'Выберите интересующие работы, и мы подготовим точное ценовое предложение. Ваш выбор автоматически добавится в форму заявки.',
      summaryTitle: 'Выбранные работы',
      summaryEmpty: 'Работы не выбраны. Выберите услугу в списке выше.',
      requestCta: 'Запросить предложение',
      contactCta: 'Связаться с нами',
      selectError: 'Пожалуйста, выберите хотя бы одну работу.',
      itemSelected: 'Добавлено в запрос',
      itemAdd: 'Отметьте для запроса цены'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Лесохозяйственные работы',
        description: 'Точные полевые работы и подготовка делянки для безопасного и корректного управления лесом.',
        items: [
          'Разметка делянок (стигование)',
          'Маркировка деревьев',
          'Обрезка стоящих деревьев'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Лесовосстановление и уход',
        description: 'Устойчивое развитие леса за счёт целевых работ по восстановлению.',
        items: [
          'Лесовосстановление',
          'Уход за молодняком',
          'Защита молодняка от повреждений животными'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Управление лесными участками',
        description: 'Полный цикл управления лесными участками от планирования до выполнения работ.',
        items: ['Управление лесными участками']
      },
      {
        id: 'es',
        title: 'Подготовка проектов ЕС',
        description: 'Консультации, подготовка документов и мониторинг проектов в рамках программ ЕС.',
        items: ['Подача и сопровождение проектов']
      }
    ],
    process: {
      eyebrow: 'Процесс сотрудничества',
      title: 'Как проходит сотрудничество',
      description: 'Понятный и прозрачный процесс от заявки до завершения.',
      steps: [
        { id: 1, title: 'Заявка', description: 'Клиент связывается с нами для оценки или другой услуги.' },
        { id: 2, title: 'Осмотр участка', description: 'Посещаем участок и выполняем необходимые полевые работы.' },
        { id: 3, title: 'Измерения и оценка', description: 'Точно измеряем насаждения и готовим объективную оценку.' },
        { id: 4, title: 'Документация', description: 'Готовим и подаём необходимые документы в госучреждения.' },
        { id: 5, title: 'Онлайн‑контроль работ', description: 'Клиент может отслеживать ход работ в портале.' },
        { id: 6, title: 'Итоговый отчёт', description: 'Предоставляем понятный отчёт о выполненных работах и результатах.' }
      ]
    },
    portal: {
      eyebrow: 'Цифровая платформа',
      title: 'Цифровая платформа – Клиентский портал',
      description: 'Мы предлагаем клиентам удобный и безопасный онлайн‑портал с постоянным доступом к информации о ходе работ. В портале можно следить за статусами и получать документы.',
      subtitle: 'Платформа создана для максимальной прозрачности и удобной коммуникации. Доступна на компьютере и мобильных устройствах в любое время.',
      featuresTitle: 'Основные функции',
      features: [
        { id: 1, title: 'Статус работ', description: 'Отслеживайте прогресс проекта в реальном времени.', icon: 'Activity' },
        { id: 2, title: 'Документы', description: 'Все документы проекта в одном месте для просмотра и скачивания.', icon: 'FolderOpen' },
        { id: 3, title: 'Уведомления', description: 'Получайте актуальные обновления по проекту.', icon: 'Bell' },
        { id: 4, title: 'Доступ отовсюду', description: 'Портал работает на компьютере и телефоне.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Войти в портал',
      ctaRequest: 'Запросить доступ',
      preview: {
        headerTitle: 'Мои проекты',
        headerActive: '3 активных',
        items: [
          { title: 'Оценка делянки #127', status: 'Завершено', tone: 'success' },
          { title: 'Измерение леса', status: 'В процессе', tone: 'warning' },
          { title: 'Документация SFS', status: 'Запланировано', tone: 'info' }
        ],
        footerLeft: 'Последняя активность: сегодня',
        footerRight: '2 новых документа'
      }
    },
    why: {
      title: 'Почему выбирать независимую оценку',
      description: 'Оценка, выполненная потенциальным покупателем, связана с конфликтом интересов. Независимая оценка даёт объективный взгляд и помогает принимать обоснованные решения.',
      conclusion: 'Независимая оценка помогает избежать невыгодных сделок и понять потенциал лесного участка.',
      stats: [
        { value: '15–30%', label: 'Потенциальная разница дохода' },
        { value: '100%', label: 'Объективная оценка' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Почему покупатель не является объективным оценщиком?',
        content: 'Покупатель финансово заинтересован купить дешевле, что создаёт конфликт интересов. Независимый оценщик работает в ваших интересах.'
      },
      {
        id: 2,
        title: 'Как независимая оценка влияет на доход?',
        content: 'Точная оценка помогает определить реальную стоимость и договориться о справедливой цене. Многие владельцы получают на 15–30% выше.'
      },
      {
        id: 3,
        title: 'Самые частые ошибки',
        content: 'Недостаточная информация об объёмах древесины, доверие только оценке покупателя, неподготовленные документы и незнание рынка — частые ошибки, снижающие доход.'
      }
    ],
    about: {
      title: 'О компании',
      subtitle: 'Опыт в лесном хозяйстве',
      description: 'Мы — поставщик лесохозяйственных услуг, специализирующийся на независимой оценке делянок и точных лесных измерениях. Работаем в соответствии с нормативами и в сотрудничестве с госучреждениями.',
      mission: 'Наша цель — обеспечить владельцам леса корректный, прозрачный и профессиональный сервис.',
      points: [
        'Специализация на независимой оценке делянок',
        'Точные измерения в соответствии с нормативами',
        'Тесное сотрудничество с Государственной лесной службой',
        'Полное сопровождение документации',
        'Работаем с физическими и юридическими лицами'
      ],
      regionsLabel: 'Регионы работы',
      regions: ['Рига и окрестности', 'Видземе', 'Латгале', 'Курземе', 'Земгале'],
      stats: [],
      sustainabilityTitle: 'Устойчивое лесоуправление',
      sustainabilityText: 'Мы помогаем сохранять ценность леса для будущих поколений, следуя принципам устойчивого управления и нормативам.',
      testimonialsEyebrow: 'Отзывы',
      testimonialsTitle: 'Что говорят наши клиенты',
      testimonialsDescription: 'Реальные истории и оценки сотрудничества.',
      testimonialsAdd: 'Добавить отзыв',
      testimonialsLoading: 'Загрузка отзывов...',
      testimonialsEmpty: 'Пока нет отзывов. Будьте первым!',
      testimonialsModalTitle: 'Добавить отзыв',
      form: {
        nameLabel: 'Имя или компания',
        regionLabel: 'Регион',
        ratingLabel: 'Оценка',
        speedLabel: 'Скорость',
        qualityLabel: 'Качество',
        communicationLabel: 'Коммуникация',
        responsivenessLabel: 'Отклик',
        textLabel: 'Текст отзыва',
        cancel: 'Отмена',
        submit: 'Отправить отзыв',
        sending: 'Отправка...',
        success: 'Отзыв отправлен на модерацию',
        error: 'Не удалось отправить отзыв. Попробуйте ещё раз.'
      },
      metrics: {
        speed: 'Скорость',
        quality: 'Качество',
        communication: 'Коммуникация',
        responsiveness: 'Отклик'
      }
    },
    contact: {
      eyebrow: 'Свяжитесь с нами',
      title: 'Контакты',
      description: 'Свяжитесь с нами, чтобы заказать услугу или получить консультацию.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Специалист по лесному хозяйству',
      formNote: 'Заполните форму, и мы свяжемся с вами.',
      infoTitle: 'Контактная информация',
      phoneLabel: 'Телефон',
      emailLabel: 'Email',
      addressLabel: 'Юридический адрес',
      hoursLabel: 'Часы работы',
      freeConsultationTitle: 'Бесплатная консультация',
      freeConsultationText: 'Первый разговор и оценка ситуации бесплатны. Свяжитесь с нами, и мы подберём лучшее решение.',
      formTitle: 'Форма заявки',
      successTitle: 'Спасибо за заявку!',
      successBody: 'Мы свяжемся с вами в ближайшее время.',
      formNameLabel: 'Имя и фамилия',
      formNamePlaceholder: 'Иван Иванов',
      formPhoneLabel: 'Телефон',
      formPhonePlaceholder: '+371 20 123 456',
      formEmailLabel: 'Email адрес',
      formEmailPlaceholder: 'ivan@example.com',
      formMessageLabel: 'Сообщение',
      formMessagePlaceholder: 'Ваш вопрос или описание ситуации...',
      formConsent: 'Отправляя форму, вы соглашаетесь на обработку персональных данных согласно GDPR.',
      formSubmitting: 'Отправка...',
      formSubmit: 'Отправить заявку',
      toastSavedTitle: 'Заявка сохранена',
      toastSavedBody: 'Для доставки email требуется подтверждённый домен. Сообщение видно в админ‑портале.',
      toastSentTitle: 'Заявка отправлена!',
      toastSentBody: 'Мы свяжемся с вами в ближайшее время.',
      toastErrorTitle: 'Ошибка отправки заявки',
      submitError: 'Ошибка отправки заявки. Попробуйте ещё раз.',
      prefillLabel: 'Хочу получить предложение по'
    },
    cookie: {
      text: 'Сайт использует файлы cookie для улучшения работы.',
      accept: 'Согласен'
    },
    privacy: {
      badge: 'Политика конфиденциальности',
      title: 'Политика конфиденциальности Sila Meži',
      intro: 'Мы заботимся о безопасности ваших данных. В этой политике объясняем, какие данные обрабатываем и почему.',
      controllerTitle: 'Оператор данных',
      controllerRegLabel: 'Рег. №:',
      controllerAddressLabel: 'Адрес:',
      controllerEmailLabel: 'Email для вопросов по данным:',
      dataTitle: 'Какие данные обрабатываются',
      dataItemContact: 'Данные из контактной формы (имя, email, телефон, сообщение).',
      dataItemVisits: 'Учёт посещений после согласия на cookies (IP, регион, время визита).',
      dataItemEmail: 'Данные отправки email через сервис Resend.',
      visitsTitle: 'Учёт посещений',
      visitsText: 'Учёт ведётся только после согласия на cookies. Для определения региона используем IPinfo.',
      cookiesTitle: 'Cookies',
      cookiesText: 'Сайт использует необходимые, функциональные и статистические cookies для работы, улучшения опыта и анализа посещений.',
      retentionTitle: 'Хранение данных и права',
      retentionText: 'Данные хранятся столько, сколько нужно для предоставления услуг или в соответствии с законом. Вы можете запросить исправление или удаление, написав на указанный email.',
      thirdPartyTitle: 'Сторонние сервисы',
      thirdPartyText: 'Мы используем IPinfo для определения региона и Resend для отправки email. Сторонние сервисы обрабатывают данные согласно своим политикам.'
    },
    footer: {
      companyDescription: 'Независимая оценка делянок и лесохозяйственные услуги по всей Латвии. Работаем в интересах владельца леса.',
      companyNote: 'Работаем с физическими и юридическими лицами.',
      navigationTitle: 'Навигация',
      servicesTitle: 'Услуги',
      contactTitle: 'Контакты',
      quickLinks: {
        home: 'Главная',
        services: 'Услуги',
        process: 'Как это работает',
        portal: 'Клиентский портал',
        why: 'Почему независимая оценка',
        about: 'О нас',
        contact: 'Контакты'
      },
      services: {
        assessment: 'Оценка делянки',
        measurements: 'Лесные измерения',
        documentation: 'Подготовка документов',
        euProjects: 'Проекты ЕС'
      },
      rights: 'Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования'
    },
    nav: {
      home: 'Главная',
      services: 'Услуги',
      works: 'Работы',
      process: 'Процесс',
      why: 'Почему мы',
      about: 'О нас',
      contact: 'Контакты',
      portal: 'Клиентский портал',
      consult: 'Заявка',
      consultMobile: 'Записаться на консультацию'
    },
    portalUi: {
      common: { loading: 'Загрузка...' },
      status: {
        planned: 'Запланировано',
        inProgress: 'В процессе',
        completed: 'Завершено',
        active: 'Активно',
        onHold: 'На паузе',
        awaitingInfo: 'Ожидает данных',
        submitted: 'Подано'
      },
      nav: {
        client: {
          dashboard: 'Обзор',
          projects: 'Проекты',
          jobs: 'Работы',
          documents: 'Документы',
          messages: 'Сообщения',
          contact: 'Контакты'
        },
        admin: {
          dashboard: 'Обзор',
          clients: 'Клиенты',
          projects: 'Проекты',
          jobs: 'Работы',
          documents: 'Документы',
          messages: 'Уведомления',
          visitors: 'Посещения',
          testimonials: 'Отзывы',
          audit: 'Аудит',
          payroll: 'Расчет зарплаты'
        }
      },
      layout: {
        portalLabel: 'Клиентский портал',
        roleAdmin: 'Администратор',
        roleClient: 'Клиент',
        logout: 'Выйти'
      },
      login: {
        portalLabel: 'Клиентский портал',
        title: 'Вход в клиентский портал',
        description: 'Отслеживайте статусы работ, документы и отчёты по вашему участку.',
        usernameLabel: 'Логин',
        usernamePlaceholder: 'Введите логин',
        passwordLabel: 'Пароль',
        passwordPlaceholder: 'Введите пароль',
        togglePassword: 'Показать пароль',
        submit: 'Войти',
        submitting: 'Вход...',
        forgotText: 'Забыли пароль?',
        contactAdmin: 'Свяжитесь с администратором',
        securityTitle: 'Сообщение безопасности',
        securityText: 'Доступ только для авторизованных клиентов. Для доступа свяжитесь с нами:',
        backToSite: 'На главную',
        successToast: 'Успешный вход!',
        errorFallback: 'Ошибка входа'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Нет доступа',
        description: 'У вас нет прав доступа к этому разделу.',
        detail: 'Если считаете это ошибкой — свяжитесь с администратором.',
        backToPanel: 'Назад в панель',
        home: 'Главная'
      },
      documents: {
        title: 'Добавить документ в проект',
        fileRequired: 'Пожалуйста, выберите файл',
        uploadSuccess: 'Файл загружен',
        uploadError: 'Ошибка загрузки',
        fileLabel: 'Файл',
        fileInstruction: 'Нажмите, чтобы выбрать файл',
        fileFormats: 'PDF, Excel, Word, Изображения',
        categoryLabel: 'Тип документа',
        categories: [
          { value: 'skice', label: 'Схема' },
          { value: 'iesniegums', label: 'Заявление' },
          { value: 'ligums', label: 'Договор' },
          { value: 'atskaite', label: 'Отчёт' },
          { value: 'foto', label: 'Фото' },
          { value: 'cits', label: 'Другое' }
        ],
        visibleLabel: 'Видно клиенту',
        visibleHint: 'Клиент сможет видеть и скачивать этот документ',
        upload: 'Загрузить',
        uploading: 'Загрузка...',
        cancel: 'Отмена'
      },
      client: {
        dashboard: {
          greeting: 'Здравствуйте',
          subtitle: 'Ваш',
          subtitleHighlight: 'обзор портала',
          stats: {
            totalJobs: 'Всего работ',
            activeJobs: 'Активные',
            completedJobs: 'Завершено',
            newMessages: 'Новые сообщения'
          },
          lastUpdate: 'Последнее обновление:',
          actions: {
            jobsTitle: 'Посмотреть все работы',
            jobsDescription: 'Статусы и детали работ',
            documentsTitle: 'Документы',
            documentsDescription: 'Просмотреть и скачать файлы'
          },
          recentTitle: 'Последние работы',
          viewAll: 'Смотреть все',
          responsibleLabel: 'Ответственный',
          emptyJobs: 'Пока нет работ'
        },
        projects: {
          title: 'Мои проекты',
          subtitlePrefix: 'Ваши',
          subtitleHighlight: 'лесные проекты',
          subtitleSuffix: 'и их прогресс',
          cadastralLabel: 'Кадастровый №:',
          progressLabel: 'Общий прогресс',
          jobsTotal: 'Всего',
          jobsCompleted: 'Завершено',
          jobsInProgress: 'В процессе',
          jobsPlanned: 'Запланировано',
          nextStepTitle: 'Что дальше?',
          viewDetails: 'Подробнее',
          emptyTitle: 'Нет проектов',
          emptySubtitle: 'Проекты появятся после их создания администратором.'
        },
        jobs: {
          title: 'Работы',
          subtitlePrefix: 'Просмотрите свои работы и их',
          subtitleHighlight: 'статусы',
          searchPlaceholder: 'Поиск работ...',
          filterAll: 'Все',
          filterPlanned: 'Запланировано',
          filterInProgress: 'В процессе',
          filterCompleted: 'Завершено',
          deadlineLabel: 'До',
          emptyTitle: 'Работы не найдены',
          emptyFiltered: 'Измените критерии поиска',
          emptyAll: 'Пока нет работ'
        },
        jobDetail: {
          backToJobs: 'Назад к работам',
          notFoundTitle: 'Работа не найдена',
          infoTitle: 'Информация о работе',
          responsibleLabel: 'Ответственный',
          startDateLabel: 'Дата начала',
          plannedEndLabel: 'Плановая дата завершения',
          completedLabel: 'Завершено',
          notesTitle: 'Заметки',
          documentsTitle: 'Прикреплённые документы',
          documentsEmpty: 'Нет документов',
          downloadError: 'Не удалось скачать документ',
          timelineTitle: 'Лента статусов',
          timelineEmpty: 'Нет записей истории'
        },
        documents: {
          title: 'Документы',
          subtitlePrefix: 'Просматривайте и скачивайте',
          subtitleHighlight: 'документы',
          searchPlaceholder: 'Поиск документов, проектов или авторов...',
          filterAll: 'Все',
          allProjects: 'Все проекты',
          allUploaders: 'Все авторы',
          sortNewest: 'Сначала новые',
          sortOldest: 'Сначала старые',
          latestOnly: 'Только последние версии',
          download: 'Скачать',
          downloadError: 'Не удалось скачать документ',
          emptyTitle: 'Нет документов',
          emptyNoDocuments: 'Документов пока нет.',
          emptyFiltered: 'Нет документов по выбранным фильтрам.',
          versionLabel: 'Версия',
          categoryOther: 'Другое',
          categories: {
            valsts_institucijam: 'Госучреждениям',
            atskaites: 'Отчёты',
            merijumu_dati: 'Данные измерений',
            skices: 'Схемы',
            cits: 'Другое'
          }
        },
        messages: {
          title: 'Сообщения',
          subtitle: 'Уведомления и сообщения от администрации',
          inboxTitle: 'Входящие',
          emptyList: 'Сообщений нет',
          emptyDetailTitle: 'Выберите сообщение',
          emptyDetailText: 'Нажмите на сообщение, чтобы прочитать'
        },
        contact: {
          title: 'Контакты',
          subtitlePrefix: 'Задайте вопрос или',
          subtitleHighlight: 'свяжитесь с нами',
          phoneLabel: 'Телефон',
          emailLabel: 'Email',
          hoursLabel: 'Часы работы',
          formTitle: 'Отправить сообщение',
          subjectLabel: 'Тема',
          subjectPlaceholder: 'Тема сообщения',
          messageLabel: 'Сообщение',
          messagePlaceholder: 'Ваш вопрос или сообщение...',
          submit: 'Отправить',
          submitting: 'Отправка...',
          successTitle: 'Сообщение отправлено!',
          successBody: 'Мы свяжемся с вами.',
          toastSuccess: 'Сообщение отправлено!',
          toastError: 'Ошибка отправки сообщения'
        }
      },
      admin: {
        dashboard: {
          title: 'Администрирование',
          titleSuffix: 'панель',
          subtitlePrefix: 'Управляйте',
          subtitleHighlight: 'клиентами, работами и документами',
          stats: {
            totalClients: 'Всего клиентов',
            totalJobs: 'Всего работ',
            activeJobs: 'Активные',
            completedJobs: 'Завершено'
          },
          quick: {
            clientsTitle: 'Управление клиентами',
            clientsDescription: 'Добавлять и редактировать клиентов',
            jobsTitle: 'Управление работами',
            jobsDescription: 'Создавать и обновлять работы',
            documentsTitle: 'Документы',
            documentsDescription: 'Загружать документы'
          },
          recentTitle: 'Последние работы',
          viewAll: 'Смотреть все',
          emptyJobs: 'Нет работ'
        },
        clients: {
          title: 'Клиенты',
          subtitle: 'Управление пользователями и доступами',
          addButton: 'Добавить клиента',
          searchPlaceholder: 'Поиск клиентов...',
          table: {
            client: 'Клиент',
            username: 'Логин',
            contacts: 'Контакты',
            role: 'Роль',
            status: 'Статус',
            actions: 'Действия'
          },
          roleAdmin: 'Админ',
          roleClient: 'Клиент',
          statusActive: 'Активен',
          statusInactive: 'Неактивен',
          confirmDelete: 'Удалить пользователя "{name}"?',
          toastCreated: 'Пользователь создан',
          toastUpdated: 'Пользователь обновлён',
          toastDeleted: 'Пользователь удалён',
          toastDeleteError: 'Ошибка удаления',
          toastError: 'Ошибка',
          passwordLengthError: 'Пароль должен быть не менее 12 символов',
          modal: {
            addTitle: 'Добавить клиента',
            editTitle: 'Редактировать пользователя',
            clientNameLabel: 'Имя клиента / компания',
            clientNamePlaceholder: 'ООО Лесовладелец',
            emailLabel: 'Email',
            phoneLabel: 'Телефон',
            usernameLabel: 'Логин',
            usernamePlaceholder: 'username',
            passwordLabel: 'Пароль *',
            passwordEditLabel: 'Новый пароль (необязательно)',
            passwordPlaceholder: 'Не менее 12 символов',
            roleLabel: 'Роль',
            cancel: 'Отмена',
            create: 'Создать',
            save: 'Сохранить'
          }
        },
        projects: {
          title: 'Управление проектами',
          subtitle: 'Управляйте проектами и работами клиентов',
          addButton: 'Новый проект',
          searchPlaceholder: 'Поиск проектов...',
          progressLabel: 'Прогресс',
          stats: {
            total: 'Всего проектов',
            active: 'Активные',
            completed: 'Завершённые',
            totalJobs: 'Всего работ'
          },
          jobsTotal: 'Всего',
          jobsCompleted: 'Завершено',
          jobsInProgress: 'В процессе',
          jobsPlanned: 'Запланировано',
          editButton: 'Редактировать',
          deleteButton: 'Удалить',
          emptyState: 'Проекты не найдены',
          confirmDelete: 'Удалить этот проект?',
          toastCreated: 'Проект создан',
          toastUpdated: 'Проект обновлён',
          toastDeleted: 'Проект удалён',
          toastDeleteError: 'Не удалось удалить проект',
          toastError: 'Ошибка',
          toastLoadError: 'Не удалось загрузить проекты',
          noClient: 'Не указано',
          modal: {
            addTitle: 'Новый проект',
            editTitle: 'Редактировать проект',
            nameLabel: 'Название проекта',
            namePlaceholder: 'Участок Lejasrunķi – Работы 2026',
            clientLabel: 'Клиент',
            clientPlaceholder: 'Выберите клиента',
            propertyNameLabel: 'Название участка',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Кадастровый номер',
            addressLabel: 'Адрес участка',
            addressPlaceholder: 'Муниципалитет Ропажи',
            descriptionLabel: 'Описание',
            descriptionPlaceholder: 'Подробное описание проекта...',
            statusLabel: 'Статус',
            nextStepLabel: 'Что дальше?',
            nextStepPlaceholder: 'Завершить разметку делянки',
            cancel: 'Отмена',
            create: 'Создать',
            save: 'Сохранить'
          }
        },
        jobs: {
          title: 'Работы',
          subtitle: 'Управляйте работами и их статусами',
          addButton: 'Добавить работу',
          searchPlaceholder: 'Поиск работ...',
          filterAll: 'Все',
          table: {
            job: 'Работа',
            client: 'Клиент',
            status: 'Статус',
            dates: 'Даты',
            responsible: 'Ответственный',
            actions: 'Действия'
          },
          deadlineLabel: 'До',
          confirmDelete: 'Удалить работу "{title}"?',
          unknownClient: 'Неизвестно',
          toastCreated: 'Работа создана',
          toastUpdated: 'Работа обновлена',
          toastDeleted: 'Работа удалена',
          toastDeleteError: 'Ошибка',
          toastError: 'Ошибка',
          modal: {
            addTitle: 'Добавить работу',
            editTitle: 'Редактировать работу',
            titleLabel: 'Название работы',
            titlePlaceholder: 'Маркировка деревьев',
            descriptionLabel: 'Описание',
            descriptionPlaceholder: 'Описание работы...',
            clientLabel: 'Клиент',
            clientPlaceholder: 'Выберите клиента',
            projectLabel: 'Проект',
            projectPlaceholder: 'Выберите проект',
            projectPlaceholderEmpty: 'Сначала выберите клиента',
            statusLabel: 'Статус',
            responsibleLabel: 'Ответственный',
            responsiblePlaceholder: 'Иван Иванов',
            startDateLabel: 'Дата начала',
            endDateLabel: 'Плановая дата завершения',
            notesLabel: 'Заметки для клиента',
            notesPlaceholder: 'Заметки, видимые клиенту...',
            cancel: 'Отмена',
            create: 'Создать',
            save: 'Сохранить'
          }
        },
        bulkJob: {
          title: 'Добавить несколько работ к проекту',
          selectLabel: 'Выберите виды работ:',
          selectAll: 'Выбрать все',
          clearAll: 'Очистить',
          selectError: 'Выберите хотя бы один вид работ',
          selectedCount: 'Выбрано',
          selectedSuffix: 'видов работ',
          statusNote: 'Все работы будут созданы со статусом «Запланировано»',
          cancel: 'Отмена',
          creating: 'Создание...',
          createCount: 'Создать {count} работ',
          successTitle: 'Работы успешно созданы!',
          error: 'Не удалось создать работы',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Маркировка деревьев' },
            { id: 'caurmera_merishana', label: 'Измерение диаметра' },
            { id: 'cirsmas_stigoshana', label: 'Разметка делянки' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Восстановление границ участка' },
            { id: 'robezzimju_atjaunoshana', label: 'Восстановление межевых знаков' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Обозначение сохраняемых деревьев при выборочной рубке' },
            { id: 'cirsmu_iezimeshana', label: 'Обозначение лесосеки' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Подготовка документации' },
            { id: 'es_projektu_sagatavoshana', label: 'Подготовка проектов ЕС' },
            { id: 'cits', label: 'Другое' }
          ]
        },
        audit: {
          title: 'Журнал аудита',
          subtitle: 'История действий системы',
          emptyTitle: 'Нет записей аудита',
          emptyBody: 'История действий появится здесь'
        },
        visitors: {
          title: 'Статистика посещений',
          subtitle: 'Посещения публичного сайта',
          range7: '7 дней',
          range30: '30 дней',
          range7Short: '7 дней',
          range30Short: '30 дней',
          rangeOther: '{count} дней',
          totalLabel: 'Всего посещений',
          uniqueLabel: 'Уникальные посетители',
          periodLabel: 'Период',
          dailyTitle: 'Посещения по дням',
          dailyEmpty: 'Нет данных за выбранный период.',
          recentTitle: 'Последние посещения',
          recentEmpty: 'Нет записей посещений.',
          unknownRegion: 'Неизвестный регион',
          visitNumber: 'Посещение #{number}'
        },
        testimonials: {
          title: 'Управление отзывами',
          subtitle: 'Подтверждайте или скрывайте отзывы перед публикацией на сайте.',
          filters: {
            all: 'Все',
            pending: 'Ожидают подтверждения',
            approved: 'Опубликованные',
            hidden: 'Скрытые'
          },
          loading: 'Загрузка отзывов...',
          empty: 'Нет отзывов для выбранного фильтра.',
          average: 'Средняя {rating}/5',
          speed: 'Скорость',
          quality: 'Качество',
          communication: 'Коммуникация',
          responsiveness: 'Отклик',
          publish: 'Опубликовать',
          hide: 'Скрыть',
          returnToPending: 'Вернуть в ожидание'
        },
        payroll: {
          title: 'Расчет зарплаты',
          subtitle: 'Помесячный расчет зарплаты сотрудников',
          addEntry: 'Добавить запись',
          export: 'Экспорт XLSX',
          confirmDelete: 'Удалить эту запись?',
          toastCreated: 'Запись сохранена',
          toastUpdated: 'Запись обновлена',
          toastDeleted: 'Запись удалена',
          toastDeleteError: 'Не удалось удалить запись',
          toastError: 'Не удалось сохранить запись',
          validation: {
            employee: 'Выберите сотрудника',
            workTypes: 'Выберите хотя бы один вид работ'
          },
          filters: {
            month: 'Месяц',
            year: 'Год',
            employee: 'Сотрудник',
            client: 'Клиент',
            status: 'Счет',
            statusAll: 'Все',
            statusPaid: 'Оплачен',
            statusUnpaid: 'Не оплачен'
          },
          summary: {
            totalSalary: 'Итого зарплата (брутто)',
            totalCosts: 'Итого расходы',
            fuelCost: 'Топливо',
            paintCost: 'Краска'
          },
          table: {
            title: 'Записи по зарплате',
            date: 'Дата',
            employee: 'Сотрудник',
            client: 'Клиент',
            property: 'Объект',
            workTypes: 'Виды работ',
            salary: 'Брутто',
            costs: 'Расходы',
            paid: 'Оплачен',
            actions: 'Действия',
            edit: 'Редактировать',
            delete: 'Удалить'
          },
          empty: {
            title: 'Нет записей по зарплате',
            body: 'Нет записей за выбранный период.'
          },
          form: {
            addTitle: 'Новая запись зарплаты',
            editTitle: 'Редактировать запись',
            date: 'Дата',
            employee: 'Сотрудник',
            client: 'Клиент (необязательно)',
            propertyName: 'Название объекта',
            cadastralNumber: 'Кадастровый номер',
            kilometers: 'Пробег (км)',
            paintCans: 'Баллоны краски (шт.)',
            fuelRate: 'Ставка топлива (€/км)',
            paintPrice: 'Цена баллона краски (€/шт.)',
            workTypes: 'Виды работ',
            amount: 'Объем',
            rate: 'Ставка',
            notes: 'Примечания',
            customRateNote: 'Ставка вводится вручную',
            invoicePaid: 'Оплата получена',
            save: 'Сохранить',
            cancel: 'Отмена'
          },
          totals: {
            salary: 'Зарплата (брутто)',
            costs: 'Расходы компании',
            fuel: 'Расходы на топливо',
            paint: 'Расходы на краску'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Маркировка деревьев',
            cirsmas_stigoshana: 'Разметка делянки',
            caurmera_merishana: 'Измерение диаметра',
            paliekoso_koku_izzimeshana: 'Обозначение сохраняемых деревьев',
            cirsmu_iezimeshana: 'Обозначение лесосеки',
            ipashuma_robezu_atjaunoshana: 'Восстановление границ',
            robezzimju_atjaunoshana: 'Восстановление межевых знаков'
          },
          units: {
            hectares: 'га',
            kilometers: 'км',
            pieces: 'шт.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Проект не найден',
          back: 'Назад',
          propertyLabel: 'Участок:',
          cadastralLabel: 'Кадастр:',
          addressLabel: 'Адрес:',
          progressLabel: 'Общий прогресс',
          jobsTotal: 'Всего работ',
          jobsCompleted: 'Завершено',
          jobsInProgress: 'В процессе',
          jobsPlanned: 'Запланировано',
          nextStepTitle: 'Что дальше?',
          jobsTitle: 'Работы проекта',
          bulkAddJobs: 'Добавить несколько работ',
          deadlineLabel: 'Срок',
          lastUpdateLabel: 'Последнее изменение:',
          emptyJobs: 'В проекте пока нет работ'
        }
      }
    }
  },
  lt: {
    languageLabel: 'LT',
    company: {
      slogan: 'Tvari miškų tvarkyba'
    },
    heroBadge: 'Nepriklausomos miškininkystės paslaugos',
    hero: {
      title: 'Nepriklausomas kirtimų biržės vertinimas miško savininkams',
      subtitle: 'Padedame miško savininkams tiksliai įvertinti kirtimų biržės vertę ir paruošti mišką kirtimui, atlikdami profesionalius matavimus ir parengdami visą reikalingą dokumentaciją.',
      description: 'Dirbame tik miško savininko interesais – neperkame kirtimų biržių ir nesame susiję su medienos pirkėjais.',
      workIntro: 'Ką atliekame',
      workItems: [
        'Augančių medžių pažymėjimas',
        'Skersmens matavimai',
        'Kirtimų biržės nužymėjimas',
        'Sklypo ribų ir riboženklių atkūrimas',
        'Dokumentacijos parengimas ir pateikimas institucijoms'
      ],
      workNote: 'Visas darbų sąrašas pateikiamas skiltyje „Darbai“.',
      reasonsTitle: 'Kodėl rinktis mus',
      reasons: [
        'Tikslūs miško matavimai',
        'Nepriklausomas kirtimų biržės vertinimas',
        'Tvarkinga dokumentacija',
        'Visiškas proceso skaidrumas'
      ],
      closing: 'Klientai gali sekti darbų eigą internetu iš bet kurios vietos.',
      tagline: 'Susisiekite su mumis dėl profesionalaus požiūrio!',
      ctaPrimary: 'Užsakyti kirtimų biržės vertinimą',
      ctaSecondary: 'Klientų portalas',
      salesHighlights: [
        'Nepriklausomas vertinimas',
        'Tikslūs matavimai',
        'Visa dokumentacija',
        'Visiškas skaidrumas'
      ],
      calloutTitle: 'Sila Meži garantija',
      calloutBody: 'Tikslūs matavimai. Tvarkinga dokumentacija. Visiškas skaidrumas.',
      workLink: 'Peržiūrėti darbus',
      scrollHint: 'Slinkite žemyn',
      subtitleHighlight: 'tiksliai įvertinti kirtimų biržės vertę',
      descriptionHighlight: 'neperkame kirtimų biržių ir nesame susiję su medienos pirkėjais.'
    },
    trustBadges: [
      { id: 1, title: 'Tikslūs miško matavimai', description: 'Išsamūs lauko matavimai ir analizė' },
      { id: 2, title: 'Nepriklausomas kirtimų biržės vertinimas', description: 'Be interesų medienos pirkime' },
      { id: 3, title: 'Tvarkinga dokumentacija', description: 'Visapusiška parengimo ir pateikimo pagalba' },
      { id: 4, title: 'Visiškas skaidrumas', description: 'Klientai stebi darbus internetu' }
    ],
    services: {
      eyebrow: 'Mūsų paslaugos',
      title: 'Profesionalios miškininkystės paslaugos miško savininkams',
      description: 'Teikiame visą miškininkystės paslaugų spektrą — nuo miško vertinimo ir matavimų iki dokumentų parengimo, projektų valdymo ir miško darbų organizavimo.',
      mission: 'Mūsų tikslas – padėti miško savininkams priimti pagrįstus sprendimus, suteikiant tikslią informaciją, profesionalų požiūrį ir visapusišką proceso palaikymą.',
      ctaQuestion: 'Nežinote, kokios paslaugos jums reikia?',
      ctaLink: 'Susisiekite dėl nemokamos konsultacijos'
    },
    servicesList: [
      {
        id: 1,
        category: 'Miško ir kirtimų biržės vertinimas',
        description: 'Atliekame profesionalų augančių medžių ir kirtimų biržių vertinimą, remdamiesi išsamiais lauko matavimais, aktualiomis rinkos kainomis ir galiojančiais teisės aktais. Vertinimas parengiamas nepriklausomai nuo medienos pirkimo, todėl miško savininkas gauna objektyvią ir patikimą informaciją.',
        items: [
          'Augančių medžių pažymėjimas',
          'Medžių skersmens ir kitų parametrų matavimai',
          'Kirtimų biržės vertės skaičiavimas ir analizė'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Miško matavimai ir ribų darbai',
        description: 'Teikiame įvairius miško matavimo darbus ir sklypo ribų patikslinimą vietoje. Visi darbai atliekami remiantis kadastriniais duomenimis ir galiojančiais teisės aktais. Tikslūs matavimai padeda išvengti ribų ginčų ir užtikrina teisingą miško tvarkymą.',
        items: [
          'Kirtimų biržės nužymėjimas',
          'Sklypo ribų atkūrimas vietoje',
          'Riboženklių įrengimas ir atkūrimas'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Miško atkūrimas ir jaunuolynų priežiūra',
        description: 'Padedame miško savininkams užtikrinti tvarią miško plėtrą, organizuodami miško atkūrimo ir jaunuolynų priežiūros darbus. Tinkama priežiūra ankstyvuose miško vystymosi etapuose ženkliai lemia miško kokybę ir būsimą vertę.',
        items: [
          'Miško atkūrimo darbų organizavimas',
          'Sodinimo darbų planavimas ir koordinavimas',
          'Jaunuolynų priežiūros darbų organizavimas'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentacijos parengimas ir derinimai',
        description: 'Parengiame ir pateikiame visą reikalingą dokumentaciją Valstybinei miškų tarnybai ir kitoms institucijoms. Užtikriname visą administracinį palaikymą procese, kad savininkai išvengtų sudėtingos biurokratijos.',
        items: [
          'Dokumentų parengimas valstybinėms institucijoms',
          'Prašymų parengimas ir pateikimas',
          'Visapusiškas administracinio proceso palaikymas'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'Europos Sąjungos paramos projektai',
        description: 'Konsultuojame miško savininkus dėl ES paramos priemonių miškininkystėje. Užtikriname visą projekto parengimo ir administravimo procesą — nuo idėjos iki įgyvendinimo.',
        items: [
          'Konsultacijos dėl ES paramos galimybių',
          'Projektų dokumentacijos parengimas',
          'Projektų pateikimas ir priežiūra'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Darbai',
      title: 'Darbai',
      description: 'Pasirinkite jus dominančius darbus, ir mes parengsime tikslų kainos pasiūlymą. Jūsų pasirinkimas automatiškai bus įtrauktas į užklausos formą.',
      summaryTitle: 'Pasirinkti darbai',
      summaryEmpty: 'Nėra pasirinktų darbų. Pasirinkite paslaugą sąraše aukščiau.',
      requestCta: 'Prašyti kainos pasiūlymo',
      contactCta: 'Susisiekti su mumis',
      selectError: 'Prašome pasirinkti bent vieną darbą, kad gautumėte kainą.',
      itemSelected: 'Pridėta prie kainos užklausos',
      itemAdd: 'Pažymėkite, kad gautumėte kainą'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Miškininkystės darbai',
        description: 'Tikslūs lauko darbai ir kirtimų biržės paruošimas saugiam ir taisyklingam miško tvarkymui.',
        items: [
          'Kirtimų biržės nužymėjimas',
          'Medžių pažymėjimas',
          'Augančių medžių genėjimas'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Miško atkūrimas ir priežiūra',
        description: 'Tvarios miško plėtros užtikrinimas tikslingai planuojant atkūrimo darbus.',
        items: [
          'Miško atkūrimas',
          'Jaunuolynų priežiūra',
          'Jaunuolynų apsauga nuo gyvūnų pažeidimų'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Miško valdų tvarkymas',
        description: 'Pilno ciklo miško valdų valdymas ir darbų koordinavimas nuo planavimo iki įgyvendinimo.',
        items: ['Miško valdų tvarkymas']
      },
      {
        id: 'es',
        title: 'ES projektų parengimas',
        description: 'Konsultacijos, dokumentų parengimas ir projektų priežiūra ES paramos programose.',
        items: ['Projektų pateikimas ir priežiūra']
      }
    ],
    process: {
      eyebrow: 'Bendradarbiavimo procesas',
      title: 'Kaip vyksta bendradarbiavimas',
      description: 'Aiškus ir skaidrus procesas nuo užklausos iki pabaigos.',
      steps: [
        { id: 1, title: 'Užklausa', description: 'Klientas susisiekia su mumis, kad užsakytų vertinimą ar kitą paslaugą.' },
        { id: 2, title: 'Sklypo apžiūra', description: 'Apsilankome sklype ir atliekame reikalingus lauko darbus.' },
        { id: 3, title: 'Matavimai ir vertinimas', description: 'Tiksliai išmatuojame medyną ir parengiame objektyvų vertinimą.' },
        { id: 4, title: 'Dokumentacija', description: 'Parengiame ir pateikiame reikalingus dokumentus valstybės institucijoms.' },
        { id: 5, title: 'Darbų stebėjimas internetu', description: 'Klientas gali sekti darbų eigą portale.' },
        { id: 6, title: 'Galutinė ataskaita', description: 'Pateikiame aiškią ataskaitą apie atliktus darbus ir rezultatus.' }
      ]
    },
    portal: {
      eyebrow: 'Skaitmeninė platforma',
      title: 'Skaitmeninė platforma – Klientų portalas',
      description: 'Savo klientams siūlome patogų ir saugų internetinį portalą, kuris užtikrina nuolatinę prieigą prie projekto ir darbų eigos. Portale galima peržiūrėti naujienas, sekti statusus ir vienoje vietoje rasti visus projekto dokumentus.',
      subtitle: 'Platforma sukurta maksimaliam skaidrumui ir patogiam bendravimui su mūsų komanda. Klientai bet kada mato aktualią situaciją be papildomo skambinimo. Portalas veikia tiek kompiuteryje, tiek mobiliajame, tad informacija pasiekiama visur.',
      featuresTitle: 'Pagrindinės funkcijos',
      features: [
        { id: 1, title: 'Darbų statusas', description: 'Stebėkite projekto eigą realiu laiku – planuojama, vykdoma ar užbaigta.', icon: 'Activity' },
        { id: 2, title: 'Dokumentų prieiga', description: 'Visi projekto dokumentai vienoje vietoje, paruošti peržiūrai ir atsisiuntimui.', icon: 'FolderOpen' },
        { id: 3, title: 'Pranešimai', description: 'Gaukite naujienas apie eigą, pakeitimus ir svarbius pranešimus.', icon: 'Bell' },
        { id: 4, title: 'Pasiekiama visur', description: 'Veikia kompiuteryje ir mobiliajame, patogi prieiga iš bet kurios vietos.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Prisijungti prie portalo',
      ctaRequest: 'Prašyti prieigos',
      preview: {
        headerTitle: 'Mano projektai',
        headerActive: '3 aktyvūs',
        items: [
          { title: 'Kirtimų biržės vertinimas #127', status: 'Užbaigta', tone: 'success' },
          { title: 'Miško matavimas', status: 'Vykdoma', tone: 'warning' },
          { title: 'Dokumentacija VMT', status: 'Planuojama', tone: 'info' }
        ],
        footerLeft: 'Paskutinė veikla: šiandien',
        footerRight: '2 nauji dokumentai'
      }
    },
    why: {
      title: 'Kodėl verta rinktis nepriklausomą vertinimą',
      description: 'Vertinimas, kurį atlieka potencialus pirkėjas, visada yra susijęs su interesų konfliktu. Nepriklausomas vertinimas suteikia objektyvų požiūrį į realią vertę ir padeda savininkams priimti pagrįstus sprendimus.',
      conclusion: 'Nepriklausomas vertinimas dažnai padeda išvengti nepalankių sandorių ir suteikia aiškų supratimą apie miško valdos potencialą.',
      stats: [
        { value: '15–30%', label: 'Galimas pajamų skirtumas' },
        { value: '100%', label: 'Objektyvus vertinimas' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Kodėl pirkėjas nėra objektyvus vertintojas?',
        content: 'Pirkėjas turi finansinį interesą įsigyti mišką kuo pigiau, todėl kyla interesų konfliktas. Nepriklausomas vertintojas dirba tik jūsų naudai.'
      },
      {
        id: 2,
        title: 'Kaip nepriklausomas vertinimas veikia pajamas?',
        content: 'Tikslus nepriklausomas vertinimas leidžia nustatyti tikrąją vertę ir derybose pasiekti sąžiningą kainą. Daugelis savininkų, pasinaudoję nepriklausomu vertinimu, gauna 15–30% didesnę kainą.'
      },
      {
        id: 3,
        title: 'Dažniausios klaidos',
        content: 'Nepakankama informacija apie medienos apimtis, pasikliovimas tik pirkėjo vertinimu, neparengta dokumentacija ir nežinojimas apie rinkos kainas – dažniausios klaidos, mažinančios savininko pajamas.'
      }
    ],
    about: {
      title: 'Apie įmonę',
      subtitle: 'Patirtis miškininkystėje',
      description: 'Esame miškininkystės paslaugų teikėjas, specializuojamės nepriklausomame kirtimų biržės vertinime ir tiksliuose miško matavimuose. Dirbame laikydamiesi galiojančių teisės aktų ir glaudžiai bendradarbiaujame su valstybinėmis institucijomis.',
      mission: 'Mūsų tikslas – užtikrinti miško savininkams korektišką, skaidrų ir profesionalų aptarnavimą viso bendradarbiavimo metu.',
      points: [
        'Specializuojamės nepriklausomame kirtimų biržės vertinime',
        'Tikslūs miško matavimai pagal teisės aktus',
        'Glaudus bendradarbiavimas su valstybine miškų tarnyba',
        'Visapusiškas dokumentacijos parengimas',
        'Bendradarbiaujame tiek su fiziniais, tiek su juridiniais asmenimis'
      ],
      regionsLabel: 'Veiklos regionai',
      regions: ['Ryga ir apylinkės', 'Vidžemė', 'Latgala', 'Kurzeme', 'Žiemgala'],
      stats: [],
      sustainabilityTitle: 'Tvari miškų tvarkyba',
      sustainabilityText: 'Padedame miško savininkams išsaugoti miško vertę ateities kartoms, laikydamiesi tvarios tvarkybos principų ir teisės aktų.',
      testimonialsEyebrow: 'Atsiliepimai',
      testimonialsTitle: 'Ką sako mūsų klientai',
      testimonialsDescription: 'Tikra patirtis ir atsiliepimai apie mūsų bendradarbiavimą.',
      testimonialsAdd: 'Pridėti atsiliepimą',
      testimonialsLoading: 'Įkeliami atsiliepimai...',
      testimonialsEmpty: 'Šiuo metu nėra atsiliepimų. Būkite pirmieji, kurie pasidalins patirtimi!',
      testimonialsModalTitle: 'Pridėti atsiliepimą',
      form: {
        nameLabel: 'Vardas arba įmonė',
        regionLabel: 'Regionas',
        ratingLabel: 'Įvertinimas',
        speedLabel: 'Greitis',
        qualityLabel: 'Kokybė',
        communicationLabel: 'Komunikacija',
        responsivenessLabel: 'Atsakas',
        textLabel: 'Atsiliepimo tekstas',
        cancel: 'Atšaukti',
        submit: 'Siųsti atsiliepimą',
        sending: 'Siunčiama...',
        success: 'Atsiliepimas išsiųstas patvirtinimui',
        error: 'Nepavyko išsiųsti atsiliepimo. Bandykite dar kartą.'
      },
      metrics: {
        speed: 'Greitis',
        quality: 'Kokybė',
        communication: 'Komunikacija',
        responsiveness: 'Atsakas'
      }
    },
    contact: {
      eyebrow: 'Susisiekite su mumis',
      title: 'Kontaktai',
      description: 'Susisiekite su mumis dėl paslaugos arba konsultacijos apie jūsų miško valdą.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Miškininkystės specialistas',
      formNote: 'Užpildykite formą ir mes su jumis susisieksime.',
      infoTitle: 'Kontaktinė informacija',
      phoneLabel: 'Telefonas',
      emailLabel: 'El. paštas',
      addressLabel: 'Juridinis adresas',
      hoursLabel: 'Darbo laikas',
      freeConsultationTitle: 'Nemokama konsultacija',
      freeConsultationText: 'Pirmas pokalbis ir situacijos įvertinimas yra nemokami. Susisiekite su mumis ir kartu parinksime geriausią sprendimą.',
      formTitle: 'Užklausos forma',
      successTitle: 'Ačiū už užklausą!',
      successBody: 'Netrukus su jumis susisieksime.',
      formNameLabel: 'Vardas, pavardė',
      formNamePlaceholder: 'Jonas Petrauskas',
      formPhoneLabel: 'Telefono numeris',
      formPhonePlaceholder: '+370 600 12345',
      formEmailLabel: 'El. pašto adresas',
      formEmailPlaceholder: 'jonas@example.com',
      formMessageLabel: 'Žinutė',
      formMessagePlaceholder: 'Jūsų klausimas ar situacijos aprašymas...',
      formConsent: 'Siųsdami formą sutinkate su asmens duomenų tvarkymu pagal GDPR.',
      formSubmitting: 'Siunčiama...',
      formSubmit: 'Siųsti užklausą',
      toastSavedTitle: 'Užklausa išsaugota',
      toastSavedBody: 'El. pašto pristatymui reikia patvirtinto domeno. Žinutė matoma administravimo portale.',
      toastSentTitle: 'Užklausa išsiųsta!',
      toastSentBody: 'Netrukus su jumis susisieksime.',
      toastErrorTitle: 'Klaida siunčiant užklausą',
      submitError: 'Klaida siunčiant užklausą. Prašome bandyti dar kartą.',
      prefillLabel: 'Noriu gauti kainos pasiūlymą dėl'
    },
    cookie: {
      text: 'Ši svetainė naudoja slapukus, kad pagerintų jūsų patirtį.',
      accept: 'Sutinku'
    },
    privacy: {
      badge: 'Privatumo politika',
      title: 'Sila Meži privatumo politika',
      intro: 'Rūpinamės jūsų duomenų saugumu ir privatumu. Šioje politikoje paaiškiname, kokius duomenis tvarkome ir kodėl.',
      controllerTitle: 'Duomenų valdytojas',
      controllerRegLabel: 'Reg. Nr.:',
      controllerAddressLabel: 'Adresas:',
      controllerEmailLabel: 'El. paštas duomenų klausimams:',
      dataTitle: 'Kokie duomenys tvarkomi',
      dataItemContact: 'Kontaktų formoje pateikti duomenys (vardas, el. paštas, telefonas, žinutė).',
      dataItemVisits: 'Apsilankymų apskaita po slapukų sutikimo (IP adresas, regionas, apsilankymo laikas).',
      dataItemEmail: 'El. laiškų siuntimo duomenys naudojant Resend.',
      visitsTitle: 'Apsilankymų apskaita',
      visitsText: 'Apsilankymai fiksuojami tik po jūsų sutikimo. Regionui nustatyti naudojame IPinfo.',
      cookiesTitle: 'Slapukai',
      cookiesText: 'Ši svetainė naudoja būtinuosius, funkcinius ir statistinius slapukus, kad užtikrintų veikimą, pagerintų patirtį ir suprastų lankytojų tendencijas.',
      retentionTitle: 'Duomenų saugojimas ir teisės',
      retentionText: 'Duomenys saugomi tiek, kiek reikia paslaugoms teikti ar kaip numato įstatymai. Galite prašyti duomenų taisymo ar ištrynimo rašydami nurodytu el. paštu.',
      thirdPartyTitle: 'Trečiųjų šalių paslaugos',
      thirdPartyText: 'Regionui nustatyti naudojame IPinfo, o el. laiškų siuntimui – Resend. Trečiosios šalys tvarko duomenis pagal savo privatumo politikas.'
    },
    footer: {
      companyDescription: 'Nepriklausomas kirtimų biržės vertinimas ir miškininkystės paslaugos visoje Latvijoje. Dirbame tik miško savininko interesais.',
      companyNote: 'Bendradarbiaujame tiek su fiziniais, tiek su juridiniais asmenimis.',
      navigationTitle: 'Navigacija',
      servicesTitle: 'Paslaugos',
      contactTitle: 'Kontaktai',
      quickLinks: {
        home: 'Pradžia',
        services: 'Paslaugos',
        process: 'Kaip vyksta',
        portal: 'Klientų portalas',
        why: 'Kodėl nepriklausomas vertinimas',
        about: 'Apie mus',
        contact: 'Kontaktai'
      },
      services: {
        assessment: 'Kirtimų biržės vertinimas',
        measurements: 'Miško matavimai',
        documentation: 'Dokumentų parengimas',
        euProjects: 'ES projektai'
      },
      rights: 'Visos teisės saugomos.',
      privacy: 'Privatumo politika',
      terms: 'Naudojimo sąlygos'
    },
    nav: {
      home: 'Pradžia',
      services: 'Paslaugos',
      works: 'Darbai',
      process: 'Procesas',
      why: 'Kodėl mes',
      about: 'Apie',
      contact: 'Kontaktai',
      portal: 'Klientų portalas',
      consult: 'Pateikti užklausą',
      consultMobile: 'Registruotis konsultacijai'
    },
    portalUi: {
      common: { loading: 'Įkeliama...' },
      status: {
        planned: 'Planuojama',
        inProgress: 'Vykdoma',
        completed: 'Užbaigta',
        active: 'Aktyvus',
        onHold: 'Sustabdyta',
        awaitingInfo: 'Laukiama informacijos',
        submitted: 'Pateikta'
      },
      nav: {
        client: {
          dashboard: 'Apžvalga',
          projects: 'Projektai',
          jobs: 'Darbai',
          documents: 'Dokumentai',
          messages: 'Žinutės',
          contact: 'Kontaktai'
        },
        admin: {
          dashboard: 'Apžvalga',
          clients: 'Klientai',
          projects: 'Projektai',
          jobs: 'Darbai',
          documents: 'Dokumentai',
          messages: 'Pranešimai',
          visitors: 'Apsilankymai',
          testimonials: 'Atsiliepimai',
          audit: 'Audito žurnalas',
          payroll: 'Darbo užmokestis'
        }
      },
      layout: {
        portalLabel: 'Klientų portalas',
        roleAdmin: 'Administratorius',
        roleClient: 'Klientas',
        logout: 'Atsijungti'
      },
      login: {
        portalLabel: 'Klientų portalas',
        title: 'Prisijungti prie klientų portalo',
        description: 'Čia galite sekti darbų statusus, dokumentus ir ataskaitas apie savo valdą.',
        usernameLabel: 'Vartotojo vardas',
        usernamePlaceholder: 'Įveskite vartotojo vardą',
        passwordLabel: 'Slaptažodis',
        passwordPlaceholder: 'Įveskite slaptažodį',
        togglePassword: 'Rodyti slaptažodį',
        submit: 'Prisijungti',
        submitting: 'Prisijungiama...',
        forgotText: 'Pamiršote slaptažodį?',
        contactAdmin: 'Susisiekite su administratoriumi',
        securityTitle: 'Saugumo pranešimas',
        securityText: 'Prieiga tik autorizuotiems klientams. Dėl prieigos susisiekite su mumis:',
        backToSite: 'Atgal į pagrindinį puslapį',
        successToast: 'Prisijungta sėkmingai!',
        errorFallback: 'Prisijungimo klaida'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Nėra prieigos',
        description: 'Jūs neturite teisės pasiekti šios skilties.',
        detail: 'Jei manote, kad tai klaida, susisiekite su administratoriumi.',
        backToPanel: 'Atgal į panelę',
        home: 'Pagrindinis puslapis'
      },
      documents: {
        title: 'Pridėti dokumentą projektui',
        fileRequired: 'Prašome pasirinkti failą',
        uploadSuccess: 'Failas įkeltas',
        uploadError: 'Įkėlimo klaida',
        fileLabel: 'Failas',
        fileInstruction: 'Spustelėkite, kad pasirinktumėte failą',
        fileFormats: 'PDF, Excel, Word, Nuotraukos',
        categoryLabel: 'Dokumento tipas',
        categories: [
          { value: 'skice', label: 'Schema' },
          { value: 'iesniegums', label: 'Prašymas' },
          { value: 'ligums', label: 'Sutartis' },
          { value: 'atskaite', label: 'Ataskaita' },
          { value: 'foto', label: 'Nuotrauka' },
          { value: 'cits', label: 'Kita' }
        ],
        visibleLabel: 'Matoma klientui',
        visibleHint: 'Klientas galės matyti ir atsisiųsti šį dokumentą',
        upload: 'Įkelti',
        uploading: 'Įkeliama...',
        cancel: 'Atšaukti'
      },
      client: {
        dashboard: {
          greeting: 'Sveiki',
          subtitle: 'Jūsų',
          subtitleHighlight: 'klientų portalo apžvalga',
          stats: {
            totalJobs: 'Viso darbų',
            activeJobs: 'Aktyvūs darbai',
            completedJobs: 'Užbaigti',
            newMessages: 'Nauji pranešimai'
          },
          lastUpdate: 'Paskutinis atnaujinimas:',
          actions: {
            jobsTitle: 'Peržiūrėti visus darbus',
            jobsDescription: 'Peržiūrėti darbų statusus ir detales',
            documentsTitle: 'Dokumentai',
            documentsDescription: 'Peržiūrėti ir atsisiųsti failus'
          },
          recentTitle: 'Naujausi darbai',
          viewAll: 'Peržiūrėti visus',
          responsibleLabel: 'Atsakingasis',
          emptyJobs: 'Dar nėra darbų'
        },
        projects: {
          title: 'Mano projektai',
          subtitlePrefix: 'Jūsų',
          subtitleHighlight: 'miškininkystės projektai',
          subtitleSuffix: 'ir jų progresas',
          cadastralLabel: 'Kadastrinis Nr.:',
          progressLabel: 'Bendras progresas',
          jobsTotal: 'Viso',
          jobsCompleted: 'Užbaigti',
          jobsInProgress: 'Vykdomi',
          jobsPlanned: 'Planuojami',
          nextStepTitle: 'Kas toliau?',
          viewDetails: 'Peržiūrėti detales',
          emptyTitle: 'Nėra projektų',
          emptySubtitle: 'Jūsų projektai atsiras čia, kai administratorius juos sukurs.'
        },
        jobs: {
          title: 'Darbai',
          subtitlePrefix: 'Peržiūrėkite savo darbus ir jų',
          subtitleHighlight: 'statusus',
          searchPlaceholder: 'Ieškoti darbų...',
          filterAll: 'Visi',
          filterPlanned: 'Planuojami',
          filterInProgress: 'Vykdomi',
          filterCompleted: 'Užbaigti',
          deadlineLabel: 'Iki',
          emptyTitle: 'Darbų nerasta',
          emptyFiltered: 'Pabandykite pakeisti paieškos kriterijus',
          emptyAll: 'Dar nėra pridėtų darbų'
        },
        jobDetail: {
          backToJobs: 'Atgal į darbus',
          notFoundTitle: 'Darbas nerastas',
          infoTitle: 'Darbo informacija',
          responsibleLabel: 'Atsakingasis',
          startDateLabel: 'Pradžios data',
          plannedEndLabel: 'Planuojama pabaiga',
          completedLabel: 'Užbaigta',
          notesTitle: 'Pastabos',
          documentsTitle: 'Pridėti dokumentai',
          documentsEmpty: 'Nėra pridėtų dokumentų',
          downloadError: 'Nepavyko atsisiųsti dokumento',
          timelineTitle: 'Statuso laiko juosta',
          timelineEmpty: 'Nėra istorijos įrašų'
        },
        documents: {
          title: 'Dokumentai',
          subtitlePrefix: 'Peržiūrėkite ir atsisiųskite savo',
          subtitleHighlight: 'dokumentus',
          searchPlaceholder: 'Ieškoti dokumentų, projektų ar autorių...',
          filterAll: 'Visi',
          allProjects: 'Visi projektai',
          allUploaders: 'Visi autoriai',
          sortNewest: 'Naujausi pirmi',
          sortOldest: 'Seniausi pirmi',
          latestOnly: 'Tik naujausios versijos',
          download: 'Atsisiųsti',
          downloadError: 'Nepavyko atsisiųsti dokumento',
          emptyTitle: 'Nėra dokumentų',
          emptyNoDocuments: 'Šiuo metu dokumentų nėra.',
          emptyFiltered: 'Pagal pasirinktus filtrus dokumentų nėra.',
          versionLabel: 'Versija',
          categoryOther: 'Kita',
          categories: {
            valsts_institucijam: 'Valstybės institucijoms',
            atskaites: 'Ataskaitos',
            merijumu_dati: 'Matavimų duomenys',
            skices: 'Schemos',
            cits: 'Kita'
          }
        },
        messages: {
          title: 'Žinutės',
          subtitle: 'Pranešimai ir žinutės iš administracijos',
          inboxTitle: 'Įeinantys',
          emptyList: 'Žinučių nėra',
          emptyDetailTitle: 'Pasirinkite žinutę',
          emptyDetailText: 'Spustelėkite žinutę, kad perskaitytumėte'
        },
        contact: {
          title: 'Kontaktai',
          subtitlePrefix: 'Užduokite klausimą ar',
          subtitleHighlight: 'susisiekite su mumis',
          phoneLabel: 'Telefonas',
          emailLabel: 'El. paštas',
          hoursLabel: 'Darbo laikas',
          formTitle: 'Siųsti žinutę',
          subjectLabel: 'Tema',
          subjectPlaceholder: 'Žinutės tema',
          messageLabel: 'Žinutė',
          messagePlaceholder: 'Jūsų klausimas ar žinutė...',
          submit: 'Siųsti',
          submitting: 'Siunčiama...',
          successTitle: 'Žinutė išsiųsta!',
          successBody: 'Netrukus su jumis susisieksime.',
          toastSuccess: 'Žinutė išsiųsta!',
          toastError: 'Klaida siunčiant žinutę'
        }
      },
      admin: {
        dashboard: {
          title: 'Administracija',
          titleSuffix: 'skydelis',
          subtitlePrefix: 'Valdykite',
          subtitleHighlight: 'klientus, darbus ir dokumentus',
          stats: {
            totalClients: 'Viso klientų',
            totalJobs: 'Viso darbų',
            activeJobs: 'Aktyvūs darbai',
            completedJobs: 'Užbaigti'
          },
          quick: {
            clientsTitle: 'Valdyti klientus',
            clientsDescription: 'Pridėti ir redaguoti klientus',
            jobsTitle: 'Valdyti darbus',
            jobsDescription: 'Kurti ir atnaujinti darbus',
            documentsTitle: 'Dokumentai',
            documentsDescription: 'Įkelti dokumentus'
          },
          recentTitle: 'Naujausi darbai',
          viewAll: 'Peržiūrėti visus',
          emptyJobs: 'Nėra darbų'
        },
        clients: {
          title: 'Klientai',
          subtitle: 'Valdykite vartotojus ir prieigos teises',
          addButton: 'Pridėti klientą',
          searchPlaceholder: 'Ieškoti klientų...',
          table: {
            client: 'Klientas',
            username: 'Vartotojo vardas',
            contacts: 'Kontaktai',
            role: 'Rolė',
            status: 'Statusas',
            actions: 'Veiksmai'
          },
          roleAdmin: 'Administratorius',
          roleClient: 'Klientas',
          statusActive: 'Aktyvus',
          statusInactive: 'Neaktyvus',
          confirmDelete: 'Ar tikrai norite ištrinti naudotoją "{name}"?',
          toastCreated: 'Naudotojas sukurtas',
          toastUpdated: 'Naudotojas atnaujintas',
          toastDeleted: 'Naudotojas ištrintas',
          toastDeleteError: 'Klaida ištrinant',
          toastError: 'Klaida',
          passwordLengthError: 'Slaptažodis turi būti bent 12 simbolių',
          modal: {
            addTitle: 'Pridėti klientą',
            editTitle: 'Redaguoti naudotoją',
            clientNameLabel: 'Kliento vardas / įmonė',
            clientNamePlaceholder: 'UAB Miško Savininkas',
            emailLabel: 'El. paštas',
            phoneLabel: 'Telefonas',
            usernameLabel: 'Vartotojo vardas',
            usernamePlaceholder: 'vartotojas',
            passwordLabel: 'Slaptažodis *',
            passwordEditLabel: 'Naujas slaptažodis (nebūtina)',
            passwordPlaceholder: 'Bent 12 simbolių',
            roleLabel: 'Rolė',
            cancel: 'Atšaukti',
            create: 'Sukurti',
            save: 'Išsaugoti'
          }
        },
        projects: {
          title: 'Projektų valdymas',
          subtitle: 'Valdykite klientų projektus ir darbus',
          addButton: 'Naujas projektas',
          searchPlaceholder: 'Ieškoti projektų...',
          progressLabel: 'Progresas',
          stats: {
            total: 'Viso projektų',
            active: 'Aktyvūs',
            completed: 'Užbaigti',
            totalJobs: 'Viso darbų'
          },
          jobsTotal: 'Viso',
          jobsCompleted: 'Užbaigti',
          jobsInProgress: 'Vykdomi',
          jobsPlanned: 'Planuojami',
          editButton: 'Redaguoti',
          deleteButton: 'Ištrinti',
          emptyState: 'Projektų nerasta',
          confirmDelete: 'Ar tikrai norite ištrinti šį projektą?',
          toastCreated: 'Projektas sukurtas',
          toastUpdated: 'Projektas atnaujintas',
          toastDeleted: 'Projektas ištrintas',
          toastDeleteError: 'Nepavyko ištrinti projekto',
          toastError: 'Klaida',
          toastLoadError: 'Nepavyko įkelti projektų',
          noClient: 'Nenurodyta',
          modal: {
            addTitle: 'Naujas projektas',
            editTitle: 'Redaguoti projektą',
            nameLabel: 'Projekto pavadinimas',
            namePlaceholder: 'Lejasrunķi valda – Darbai 2026',
            clientLabel: 'Klientas',
            clientPlaceholder: 'Pasirinkite klientą',
            propertyNameLabel: 'Sklypo pavadinimas',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Kadastrinis numeris',
            addressLabel: 'Sklypo adresas',
            addressPlaceholder: 'Ropaži savivaldybė',
            descriptionLabel: 'Aprašymas',
            descriptionPlaceholder: 'Išsamus projekto aprašymas...',
            statusLabel: 'Statusas',
            nextStepLabel: 'Kas toliau?',
            nextStepPlaceholder: 'Užbaigti kirtimų biržės nužymėjimą',
            cancel: 'Atšaukti',
            create: 'Sukurti',
            save: 'Išsaugoti'
          }
        },
        jobs: {
          title: 'Darbai',
          subtitle: 'Valdykite darbus ir jų statusus',
          addButton: 'Pridėti darbą',
          searchPlaceholder: 'Ieškoti darbų...',
          filterAll: 'Visi',
          table: {
            job: 'Darbas',
            client: 'Klientas',
            status: 'Statusas',
            dates: 'Datos',
            responsible: 'Atsakingasis',
            actions: 'Veiksmai'
          },
          deadlineLabel: 'Iki',
          confirmDelete: 'Ar tikrai norite ištrinti darbą "{title}"?',
          unknownClient: 'Nežinoma',
          toastCreated: 'Darbas sukurtas',
          toastUpdated: 'Darbas atnaujintas',
          toastDeleted: 'Darbas ištrintas',
          toastDeleteError: 'Klaida',
          toastError: 'Klaida',
          modal: {
            addTitle: 'Pridėti darbą',
            editTitle: 'Redaguoti darbą',
            titleLabel: 'Darbo pavadinimas',
            titlePlaceholder: 'Augančių medžių pažymėjimas',
            descriptionLabel: 'Aprašymas',
            descriptionPlaceholder: 'Darbo aprašymas...',
            clientLabel: 'Klientas',
            clientPlaceholder: 'Pasirinkite klientą',
            projectLabel: 'Projektas',
            projectPlaceholder: 'Pasirinkite projektą',
            projectPlaceholderEmpty: 'Pirmiausia pasirinkite klientą',
            statusLabel: 'Statusas',
            responsibleLabel: 'Atsakingasis',
            responsiblePlaceholder: 'Jonas Petrauskas',
            startDateLabel: 'Pradžios data',
            endDateLabel: 'Planuojama pabaiga',
            notesLabel: 'Pastabos klientui',
            notesPlaceholder: 'Pastabos, kurias matys klientas...',
            cancel: 'Atšaukti',
            create: 'Sukurti',
            save: 'Išsaugoti'
          }
        },
        bulkJob: {
          title: 'Pridėti kelis darbus projektui',
          selectLabel: 'Pasirinkite darbų tipus:',
          selectAll: 'Pasirinkti visus',
          clearAll: 'Išvalyti',
          selectError: 'Pasirinkite bent vieną darbų tipą',
          selectedCount: 'Pasirinkta',
          selectedSuffix: 'darbų tipų',
          statusNote: 'Visi darbai bus sukurti su statusu „Planuojama“',
          cancel: 'Atšaukti',
          creating: 'Kuriama...',
          createCount: 'Sukurti {count} darbus',
          successTitle: 'Darbai sėkmingai sukurti!',
          error: 'Nepavyko sukurti darbų',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Augančių medžių pažymėjimas' },
            { id: 'caurmera_merishana', label: 'Skersmens matavimas' },
            { id: 'cirsmas_stigoshana', label: 'Kirtimų biržės nužymėjimas' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Sklypo ribų atkūrimas' },
            { id: 'robezzimju_atjaunoshana', label: 'Riboženklių atkūrimas' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Paliekamų medžių žymėjimas atrankiniame kirtime' },
            { id: 'cirsmu_iezimeshana', label: 'Biržės ribų žymėjimas' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentacijos parengimas' },
            { id: 'es_projektu_sagatavoshana', label: 'ES projektų parengimas' },
            { id: 'cits', label: 'Kita' }
          ]
        },
        audit: {
          title: 'Audito žurnalas',
          subtitle: 'Sistemos veiksmų istorija',
          emptyTitle: 'Nėra audito įrašų',
          emptyBody: 'Veiksmų istorija bus rodoma čia'
        },
        visitors: {
          title: 'Apsilankymų statistika',
          subtitle: 'Viešosios svetainės apsilankymai',
          range7: '7 dienos',
          range30: '30 dienų',
          range7Short: '7 dienos',
          range30Short: '30 dienų',
          rangeOther: '{count} dienų',
          totalLabel: 'Viso apsilankymų',
          uniqueLabel: 'Unikalūs lankytojai',
          periodLabel: 'Laikotarpis',
          dailyTitle: 'Apsilankymai pagal dienas',
          dailyEmpty: 'Pasirinktame laikotarpyje nėra apsilankymų duomenų.',
          recentTitle: 'Paskutiniai apsilankymai',
          recentEmpty: 'Apsilankymų įrašų nėra.',
          unknownRegion: 'Nežinomas regionas',
          visitNumber: 'Apsilankymas #{number}'
        },
        testimonials: {
          title: 'Atsiliepimų valdymas',
          subtitle: 'Patvirtinkite arba paslėpkite klientų atsiliepimus prieš rodant svetainėje.',
          filters: {
            all: 'Visi',
            pending: 'Laukiama patvirtinimo',
            approved: 'Publikuoti',
            hidden: 'Paslėpti'
          },
          loading: 'Įkeliami atsiliepimai...',
          empty: 'Nėra atsiliepimų pagal pasirinktą filtrą.',
          average: 'Vidutiniškai {rating}/5',
          speed: 'Greitis',
          quality: 'Kokybė',
          communication: 'Komunikacija',
          responsiveness: 'Atsakas',
          publish: 'Publikuoti',
          hide: 'Paslėpti',
          returnToPending: 'Grąžinti į laukimą'
        },
        payroll: {
          title: 'Darbo užmokestis',
          subtitle: 'Darbuotojų atlyginimų skaičiavimas pagal mėnesius',
          addEntry: 'Pridėti įrašą',
          export: 'Eksportuoti XLSX',
          confirmDelete: 'Ar tikrai ištrinti šį įrašą?',
          toastCreated: 'Įrašas išsaugotas',
          toastUpdated: 'Įrašas atnaujintas',
          toastDeleted: 'Įrašas ištrintas',
          toastDeleteError: 'Nepavyko ištrinti įrašo',
          toastError: 'Nepavyko išsaugoti įrašo',
          validation: {
            employee: 'Pasirinkite darbuotoją',
            workTypes: 'Pasirinkite bent vieną darbų tipą'
          },
          filters: {
            month: 'Mėnuo',
            year: 'Metai',
            employee: 'Darbuotojas',
            client: 'Klientas',
            status: 'Sąskaita',
            statusAll: 'Visi',
            statusPaid: 'Apmokėta',
            statusUnpaid: 'Neapmokėta'
          },
          summary: {
            totalSalary: 'Bendra bruto alga',
            totalCosts: 'Bendros išlaidos',
            fuelCost: 'Kuras',
            paintCost: 'Dažai'
          },
          table: {
            title: 'Atlyginimų įrašai',
            date: 'Data',
            employee: 'Darbuotojas',
            client: 'Klientas',
            property: 'Turtas',
            workTypes: 'Darbų tipai',
            salary: 'Bruto',
            costs: 'Išlaidos',
            paid: 'Apmokėta',
            actions: 'Veiksmai',
            edit: 'Redaguoti',
            delete: 'Ištrinti'
          },
          empty: {
            title: 'Nėra atlyginimo įrašų',
            body: 'Pasirinktam laikotarpiui įrašų nėra.'
          },
          form: {
            addTitle: 'Naujas atlyginimo įrašas',
            editTitle: 'Redaguoti įrašą',
            date: 'Data',
            employee: 'Darbuotojas',
            client: 'Klientas (nebūtina)',
            propertyName: 'Turto pavadinimas',
            cadastralNumber: 'Kadastrinis numeris',
            kilometers: 'Nuvažiuoti kilometrai',
            paintCans: 'Dažų balionėliai (vnt.)',
            fuelRate: 'Degalų tarifas (€/km)',
            paintPrice: 'Dažų baliono kaina (€/vnt.)',
            workTypes: 'Darbų tipai',
            amount: 'Apimtis',
            rate: 'Įkainis',
            notes: 'Pastabos',
            customRateNote: 'Įkainis įvedamas rankiniu būdu',
            invoicePaid: 'Apmokėjimas gautas',
            save: 'Išsaugoti',
            cancel: 'Atšaukti'
          },
          totals: {
            salary: 'Bruto alga',
            costs: 'Įmonės išlaidos',
            fuel: 'Kuro išlaidos',
            paint: 'Dažų išlaidos'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Medžių žymėjimas',
            cirsmas_stigoshana: 'Biržės stigojimas',
            caurmera_merishana: 'Skersmens matavimas',
            paliekoso_koku_izzimeshana: 'Paliekamų medžių žymėjimas',
            cirsmu_iezimeshana: 'Biržės ribų žymėjimas',
            ipashuma_robezu_atjaunoshana: 'Ribų atkūrimas',
            robezzimju_atjaunoshana: 'Ribos ženklų atkūrimas'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'vnt.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projektas nerastas',
          back: 'Atgal',
          propertyLabel: 'Sklypas:',
          cadastralLabel: 'Kadastras:',
          addressLabel: 'Adresas:',
          progressLabel: 'Bendras progresas',
          jobsTotal: 'Viso darbų',
          jobsCompleted: 'Užbaigti',
          jobsInProgress: 'Vykdomi',
          jobsPlanned: 'Planuojami',
          nextStepTitle: 'Kas toliau?',
          jobsTitle: 'Projekto darbai',
          bulkAddJobs: 'Pridėti kelis darbus',
          deadlineLabel: 'Terminas',
          lastUpdateLabel: 'Paskutinis pakeitimas:',
          emptyJobs: 'Šiam projektui dar nepridėta jokių darbų'
        }
      }
    }
  },
  et: {
    languageLabel: 'ET',
    company: {
      slogan: 'Jätkusuutlik metsamajandamine'
    },
    heroBadge: 'Sõltumatud metsateenused',
    hero: {
      title: 'Sõltumatu raiealade hindamine metsaomanikele',
      subtitle: 'Aitame metsaomanikel täpselt hinnata raieala väärtust ja valmistada metsa raieks, pakkudes professionaalseid mõõdistusi ja kogu vajalikku dokumentatsiooni.',
      description: 'Töötame ainult metsaomaniku huvides – me ei osta raiealasid ega ole seotud puidu ostjatega.',
      workIntro: 'Mida me teeme',
      workItems: [
        'Seisvate puude märgistamine',
        'Läbimõõdu mõõtmine',
        'Raieala märkimine',
        'Kinnistu piiride ja piirimärkide taastamine',
        'Dokumentatsiooni koostamine ja esitamine asutustele'
      ],
      workNote: 'Täielik tööde nimekiri on saadaval jaotises „Tööd“.',
      reasonsTitle: 'Miks valida meid',
      reasons: [
        'Täpsed metsamõõdistused',
        'Sõltumatu raieala hindamine',
        'Korralik dokumentatsioon',
        'Täielik protsessi läbipaistvus'
      ],
      closing: 'Kliendid saavad tööde edenemist veebis jälgida kõikjal.',
      tagline: 'Võtke meiega ühendust professionaalseks lähenemiseks!',
      ctaPrimary: 'Taotle raieala hindamist',
      ctaSecondary: 'Kliendiportaal',
      salesHighlights: [
        'Sõltumatu hindamine',
        'Täpsed mõõdistused',
        'Täielik dokumentatsioon',
        'Täielik läbipaistvus'
      ],
      calloutTitle: 'Sila Meži garantii',
      calloutBody: 'Täpsed mõõdistused. Korralik dokumentatsioon. Täielik läbipaistvus.',
      workLink: 'Vaata töid',
      scrollHint: 'Keri edasi',
      subtitleHighlight: 'täpselt hinnata raieala väärtust',
      descriptionHighlight: 'me ei osta raiealasid ega ole seotud puidu ostjatega.'
    },
    trustBadges: [
      { id: 1, title: 'Täpsed metsamõõdistused', description: 'Üksikasjalikud välitöömõõtmised ja analüüs' },
      { id: 2, title: 'Sõltumatu raieala hindamine', description: 'Ilma huvita puidu ostmisel' },
      { id: 3, title: 'Korralik dokumentatsioon', description: 'Täielik koostamise ja esitamise tugi' },
      { id: 4, title: 'Täielik läbipaistvus', description: 'Kliendid jälgivad töid veebis' }
    ],
    services: {
      eyebrow: 'Meie teenused',
      title: 'Professionaalsed metsateenused metsaomanikele',
      description: 'Pakume täielikku metsateenuste valikut — alates metsa hindamisest ja mõõdistustest kuni dokumentatsiooni koostamise, projektijuhtimise ja metsatööde korraldamiseni.',
      mission: 'Meie eesmärk on aidata metsaomanikel teha läbimõeldud otsuseid, pakkudes täpset teavet, professionaalset lähenemist ja täielikku protsessituge.',
      ctaQuestion: 'Pole kindel, millist teenust vajate?',
      ctaLink: 'Võtke meiega ühendust tasuta konsultatsiooniks'
    },
    servicesList: [
      {
        id: 1,
        category: 'Metsa ja raieala hindamine',
        description: 'Pakume professionaalset seisvate puude ja raiealade hindamist, tuginedes üksikasjalikele välitöömõõtmistele, ajakohastele turuhindadele ja kehtivatele õigusaktidele. Hindamine koostatakse sõltumatult raieala ostmisest, tagades objektiivse ja usaldusväärse info metsaomanikule.',
        items: [
          'Seisvate puude märgistamine',
          'Puude läbimõõdu ja muude parameetrite mõõtmine',
          'Raieala väärtuse arvutus ja analüüs'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Metsamõõdistused ja piiride tööd',
        description: 'Pakume erinevaid metsamõõdistustöid ja kinnistu piiride täpsustamist looduses. Kõik tööd tehakse katastriandmete ja kehtivate õigusaktide alusel. Täpsed mõõtmised aitavad vältida piirivaidlusi ja tagavad korrektse metsamajandamise.',
        items: [
          'Raieala märkimine',
          'Kinnistu piiride taastamine looduses',
          'Piirimärkide paigaldus ja taastamine'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Metsa uuendamine ja noorendike hooldus',
        description: 'Aitame metsaomanikel tagada jätkusuutliku metsa arengu, korraldades metsauuenduse ja noorendike hoolduse töid. Õige hooldus varases arengujärgus mõjutab oluliselt metsa kvaliteeti ja tulevast väärtust.',
        items: [
          'Metsauuenduse tööde korraldamine',
          'Istutustööde planeerimine ja koordineerimine',
          'Noorendike hoolduse tööde korraldamine'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentatsiooni koostamine ja kooskõlastused',
        description: 'Koostame ja esitame kogu vajaliku dokumentatsiooni riiklikule metsateenistusele ja teistele asutustele. Tagame täieliku haldusliku toe kogu protsessi vältel, et metsaomanikud väldiksid keerulist bürokraatiat.',
        items: [
          'Dokumentide koostamine riigiasutustele',
          'Taotluste koostamine ja esitamine',
          'Täielik haldusprotsessi tugi'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'Euroopa Liidu toetusprojektid',
        description: 'Nõustame metsaomanikke ELi toetusmeetmete osas metsanduses. Tagame kogu projekti ettevalmistuse ja halduse – ideest elluviimiseni.',
        items: [
          'Konsultatsioonid ELi toetusvõimaluste kohta',
          'Projektidokumentatsiooni koostamine',
          'Projektide esitamine ja jälgimine'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Tööd',
      title: 'Tööd',
      description: 'Valige teid huvitavad tööd ja valmistame täpse hinnapakkumise. Teie valik lisatakse automaatselt taotlusvormile.',
      summaryTitle: 'Valitud tööd',
      summaryEmpty: 'Ühtegi tööd pole valitud. Valige teenus ülalolevast loendist.',
      requestCta: 'Taotle hinnapakkumist',
      contactCta: 'Võta ühendust',
      selectError: 'Palun valige vähemalt üks töö, et taotleda hinda.',
      itemSelected: 'Lisatud hinnapäringule',
      itemAdd: 'Märgi hinnapäringu saamiseks'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Metsandustööd',
        description: 'Täpsed välitööd ja raieala ettevalmistus turvaliseks ja korrektseks metsamajandamiseks.',
        items: [
          'Raieala märkimine',
          'Puude märgistamine',
          'Seisvate puude oksalõikus'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Metsa uuendamine ja hooldus',
        description: 'Jätkusuutliku metsa arengu tagamine sihipäraste uuendustöödega.',
        items: [
          'Metsauuendus',
          'Noorendike hooldus',
          'Noorendike kaitse ulukikahjustuste eest'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Metsaomandite haldamine',
        description: 'Täistsükli metsaomandite haldus ja tööde koordineerimine planeerimisest teostuseni.',
        items: ['Metsaomandite haldamine']
      },
      {
        id: 'es',
        title: 'EL projektide ettevalmistus',
        description: 'Konsultatsioonid, dokumentide koostamine ja projektide jälgimine ELi toetusprogrammides.',
        items: ['Projektide esitamine ja jälgimine']
      }
    ],
    process: {
      eyebrow: 'Koostöö protsess',
      title: 'Kuidas koostöö toimub',
      description: 'Selge ja läbipaistev protsess alates taotlusest kuni lõpetamiseni.',
      steps: [
        { id: 1, title: 'Taotlus', description: 'Klient võtab meiega ühendust, et taotleda hindamist või muud teenust.' },
        { id: 2, title: 'Kinnistu ülevaatus', description: 'Külastame kinnistut ja teeme vajalikud välitööd.' },
        { id: 3, title: 'Mõõtmised ja hindamine', description: 'Mõõdame metsa täpselt ja koostame objektiivse hinnangu.' },
        { id: 4, title: 'Dokumentatsioon', description: 'Koostame ja esitame vajalikud dokumendid riigiasutustele.' },
        { id: 5, title: 'Tööde jälgimine veebis', description: 'Klient saab tööde kulgu jälgida kliendiportaalis.' },
        { id: 6, title: 'Lõpparuanne', description: 'Esitame selge aruande tehtud töödest ja tulemustest.' }
      ]
    },
    portal: {
      eyebrow: 'Digitaalne platvorm',
      title: 'Digitaalne platvorm – Kliendiportaal',
      description: 'Pakume klientidele mugavat ja turvalist veebipõhist kliendiportaali, mis tagab pideva ligipääsu projekti ja tööde kulule. Portaal võimaldab ühes kohas üle vaadata uuendused, jälgida staatuseid ja leida kõik projektiga seotud dokumendid.',
      subtitle: 'Platvorm on loodud maksimaalseks läbipaistvuseks ja mugavaks suhtluseks meie meeskonnaga. Kliendid näevad igal ajal hetkeolukorda ilma täiendava suhtluseta. Portaal töötab nii arvutis kui mobiilis, võimaldades ligipääsu kõikjal ja igal ajal.',
      featuresTitle: 'Põhifunktsioonid',
      features: [
        { id: 1, title: 'Tööde staatus', description: 'Jälgige projekti edenemist reaalajas – planeeritud, käimas või lõpetatud.', icon: 'Activity' },
        { id: 2, title: 'Dokumentide kättesaadavus', description: 'Kõik projekti dokumendid ühes kohas, valmis vaatamiseks ja allalaadimiseks.', icon: 'FolderOpen' },
        { id: 3, title: 'Teavitused', description: 'Saage teavet edenemise, muudatuste ja oluliste teadete kohta.', icon: 'Bell' },
        { id: 4, title: 'Kättesaadav kõikjal', description: 'Töötab nii arvutis kui mobiilis, mugav ligipääs olenemata asukohast.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Logi portaali',
      ctaRequest: 'Taotle ligipääsu',
      preview: {
        headerTitle: 'Minu projektid',
        headerActive: '3 aktiivset',
        items: [
          { title: 'Raieala hindamine #127', status: 'Lõpetatud', tone: 'success' },
          { title: 'Metsamõõdistus', status: 'Käimas', tone: 'warning' },
          { title: 'Dokumentatsioon metsateenistusele', status: 'Planeeritud', tone: 'info' }
        ],
        footerLeft: 'Viimane tegevus: täna',
        footerRight: '2 uut dokumenti'
      }
    },
    why: {
      title: 'Miks valida sõltumatu hindamine',
      description: 'Potentsiaalse ostja tehtud hindamine on alati seotud huvide konfliktiga. Sõltumatu hindamine annab objektiivse ülevaate tegelikust väärtusest ja aitab metsaomanikul teha põhjendatud otsuseid.',
      conclusion: 'Sõltumatu hindamine aitab sageli vältida ebasoodsaid tehinguid ja annab selge arusaama metsaomandi potentsiaalist.',
      stats: [
        { value: '15–30%', label: 'Võimalik tulu erinevus' },
        { value: '100%', label: 'Objektiivne hinnang' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Miks ei ole ostja objektiivne hindaja?',
        content: 'Ostjal on finantshuvi osta mets võimalikult madala hinnaga, mis tekitab huvide konflikti. Sõltumatu hindaja töötab ainult teie huvides.'
      },
      {
        id: 2,
        title: 'Kuidas mõjutab sõltumatu hindamine tulu?',
        content: 'Täpsed ja sõltumatud hinnangud aitavad määrata tegeliku väärtuse ja saavutada läbirääkimistel ausa hinna. Paljud metsaomanikud saavad sõltumatu hinnangu abil 15–30% kõrgema hinna.'
      },
      {
        id: 3,
        title: 'Levinumad vead',
        content: 'Ebapiisav info puidumahu kohta, ainult ostja hinnangule tuginemine, ettevalmistamata dokumentatsioon ja turuhindade mittetundmine – need on levinumad vead, mis vähendavad omaniku tulu.'
      }
    ],
    about: {
      title: 'Ettevõttest',
      subtitle: 'Kogemus metsanduses',
      description: 'Oleme metsateenuste pakkuja, spetsialiseerunud sõltumatule raieala hindamisele ja täpsetele metsamõõdistustele. Tegutseme kooskõlas õigusaktidega ja tihedas koostöös riigiasutustega.',
      mission: 'Meie eesmärk on tagada metsaomanikele korrektne, läbipaistev ja professionaalne teenus kogu koostöö vältel.',
      points: [
        'Spetsialiseerume sõltumatule raieala hindamisele',
        'Täpsed metsamõõdistused vastavalt õigusaktidele',
        'Tihe koostöö riikliku metsateenistusega',
        'Täielik dokumentatsiooni tugi',
        'Teeme koostööd nii eraisikute kui juriidiliste isikutega'
      ],
      regionsLabel: 'Tegutsemispiirkonnad',
      regions: ['Rīga ja ümbrus', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Jätkusuutlik metsamajandamine',
      sustainabilityText: 'Aitame metsaomanikel säilitada metsa väärtust tulevastele põlvkondadele, järgides jätkusuutliku majandamise põhimõtteid ja õigusakte.',
      testimonialsEyebrow: 'Tagasiside',
      testimonialsTitle: 'Mida meie kliendid ütlevad',
      testimonialsDescription: 'Päris kogemused ja hinnangud meie koostööle.',
      testimonialsAdd: 'Lisa tagasiside',
      testimonialsLoading: 'Laen tagasisidet...',
      testimonialsEmpty: 'Hetkel puuduvad tagasisided. Ole esimene, kes jagab kogemust!',
      testimonialsModalTitle: 'Lisa tagasiside',
      form: {
        nameLabel: 'Nimi või ettevõte',
        regionLabel: 'Piirkond',
        ratingLabel: 'Hinnang',
        speedLabel: 'Kiirus',
        qualityLabel: 'Kvaliteet',
        communicationLabel: 'Suhtlus',
        responsivenessLabel: 'Reageerimine',
        textLabel: 'Tagasiside tekst',
        cancel: 'Tühista',
        submit: 'Saada tagasiside',
        sending: 'Saatmine...',
        success: 'Tagasiside saadeti kinnitamiseks',
        error: 'Tagasiside saatmine ebaõnnestus. Palun proovige uuesti.'
      },
      metrics: {
        speed: 'Kiirus',
        quality: 'Kvaliteet',
        communication: 'Suhtlus',
        responsiveness: 'Reageerimine'
      }
    },
    contact: {
      eyebrow: 'Võtke meiega ühendust',
      title: 'Kontaktid',
      description: 'Võtke meiega ühendust teenuse tellimiseks või konsultatsiooni saamiseks oma metsavalduse kohta.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Metsandusspetsialist',
      formNote: 'Täitke päringuvorm ja me võtame teiega ühendust.',
      infoTitle: 'Kontaktandmed',
      phoneLabel: 'Telefon',
      emailLabel: 'E-post',
      addressLabel: 'Juriidiline aadress',
      hoursLabel: 'Tööaeg',
      freeConsultationTitle: 'Tasuta konsultatsioon',
      freeConsultationText: 'Esimene vestlus ja olukorra hindamine on tasuta. Võtke meiega ühendust ja leiame koos parima lahenduse.',
      formTitle: 'Päringuvorm',
      successTitle: 'Aitäh päringu eest!',
      successBody: 'Võtame teiega peagi ühendust.',
      formNameLabel: 'Nimi, perekonnanimi',
      formNamePlaceholder: 'Jaan Tamm',
      formPhoneLabel: 'Telefoninumber',
      formPhonePlaceholder: '+372 555 1234',
      formEmailLabel: 'E-posti aadress',
      formEmailPlaceholder: 'jaan@example.com',
      formMessageLabel: 'Sõnum',
      formMessagePlaceholder: 'Teie küsimus või olukorra kirjeldus...',
      formConsent: 'Vormi saates nõustute oma isikuandmete töötlemisega vastavalt GDPRile.',
      formSubmitting: 'Saatmine...',
      formSubmit: 'Saada päring',
      toastSavedTitle: 'Päring salvestatud',
      toastSavedBody: 'E-posti saatmiseks on vajalik kinnitatud domeen. Sõnum on nähtav adminiportaalis.',
      toastSentTitle: 'Päring saadetud!',
      toastSentBody: 'Võtame teiega peagi ühendust.',
      toastErrorTitle: 'Viga päringu saatmisel',
      submitError: 'Viga päringu saatmisel. Palun proovige uuesti.',
      prefillLabel: 'Soovin saada hinnapakkumist'
    },
    cookie: {
      text: 'See veebisait kasutab küpsiseid, et parandada kasutuskogemust.',
      accept: 'Nõustun'
    },
    privacy: {
      badge: 'Privaatsuspoliitika',
      title: 'Sila Meži privaatsuspoliitika',
      intro: 'Hoolime teie andmete turvalisusest ja privaatsusest. Selles poliitikas selgitame, milliseid andmeid töötleme ja miks.',
      controllerTitle: 'Andmete vastutav töötleja',
      controllerRegLabel: 'Reg. nr:',
      controllerAddressLabel: 'Aadress:',
      controllerEmailLabel: 'E-post andmeküsimustele:',
      dataTitle: 'Milliseid andmeid töödeldakse',
      dataItemContact: 'Kontaktivormis esitatud andmed (nimi, e-post, telefon, sõnum).',
      dataItemVisits: 'Külastuste arvestus pärast küpsiste nõusolekut (IP-aadress, piirkond, külastuse aeg).',
      dataItemEmail: 'E-kirjade saatmise andmed Resend teenuse kaudu.',
      visitsTitle: 'Külastuste arvestus',
      visitsText: 'Külastusi arvestatakse ainult pärast küpsiste nõusolekut. Piirkonna määramiseks kasutame IPinfo.',
      cookiesTitle: 'Küpsised',
      cookiesText: 'See veebisait kasutab vajalikke, funktsionaalseid ja statistilisi küpsiseid, et tagada töö, parandada kogemust ja mõista külastuste trende.',
      retentionTitle: 'Andmete säilitamine ja õigused',
      retentionText: 'Andmeid säilitatakse nii kaua, kui see on teenuse osutamiseks vajalik või seadusega nõutud. Teil on õigus nõuda andmete parandamist või kustutamist kirjutades ülaltoodud e-posti aadressile.',
      thirdPartyTitle: 'Kolmandate osapoolte teenused',
      thirdPartyText: 'Piirkonna määramiseks kasutame IPinfo, e-kirjade saatmiseks Resend. Kolmandad osapooled töötlevad andmeid vastavalt oma privaatsuspoliitikatele.'
    },
    footer: {
      companyDescription: 'Sõltumatu raieala hindamine ja metsateenused üle kogu Läti. Töötame ainult metsaomaniku huvides.',
      companyNote: 'Teeme koostööd nii eraisikute kui juriidiliste isikutega.',
      navigationTitle: 'Navigatsioon',
      servicesTitle: 'Teenused',
      contactTitle: 'Kontaktid',
      quickLinks: {
        home: 'Avaleht',
        services: 'Teenused',
        process: 'Kuidas toimub',
        portal: 'Kliendiportaal',
        why: 'Miks sõltumatu hindamine',
        about: 'Meist',
        contact: 'Kontaktid'
      },
      services: {
        assessment: 'Raieala hindamine',
        measurements: 'Metsamõõdistused',
        documentation: 'Dokumentide koostamine',
        euProjects: 'EL projektid'
      },
      rights: 'Kõik õigused kaitstud.',
      privacy: 'Privaatsuspoliitika',
      terms: 'Kasutustingimused'
    },
    nav: {
      home: 'Avaleht',
      services: 'Teenused',
      works: 'Tööd',
      process: 'Koostöö',
      why: 'Miks meie',
      about: 'Meist',
      contact: 'Kontakt',
      portal: 'Kliendiportaal',
      consult: 'Taotle',
      consultMobile: 'Taotle konsultatsiooni'
    },
    portalUi: {
      common: { loading: 'Laadimine...' },
      status: {
        planned: 'Planeeritud',
        inProgress: 'Käimas',
        completed: 'Lõpetatud',
        active: 'Aktiivne',
        onHold: 'Peatatud',
        awaitingInfo: 'Ootab infot',
        submitted: 'Esitatud'
      },
      nav: {
        client: {
          dashboard: 'Ülevaade',
          projects: 'Projektid',
          jobs: 'Tööd',
          documents: 'Dokumendid',
          messages: 'Sõnumid',
          contact: 'Kontakt'
        },
        admin: {
          dashboard: 'Ülevaade',
          clients: 'Kliendid',
          projects: 'Projektid',
          jobs: 'Tööd',
          documents: 'Dokumendid',
          messages: 'Teavitused',
          visitors: 'Külastused',
          testimonials: 'Tagasiside',
          audit: 'Auditi logi',
          payroll: 'Palga arvestus'
        }
      },
      layout: {
        portalLabel: 'Kliendiportaal',
        roleAdmin: 'Administraator',
        roleClient: 'Klient',
        logout: 'Logi välja'
      },
      login: {
        portalLabel: 'Kliendiportaal',
        title: 'Logi kliendiportaali',
        description: 'Siin saate jälgida tööde staatuseid, dokumente ja aruandeid oma kinnistu kohta.',
        usernameLabel: 'Kasutajanimi',
        usernamePlaceholder: 'Sisestage kasutajanimi',
        passwordLabel: 'Parool',
        passwordPlaceholder: 'Sisestage parool',
        togglePassword: 'Näita parooli',
        submit: 'Logi sisse',
        submitting: 'Sisselogimine...',
        forgotText: 'Unustasid parooli?',
        contactAdmin: 'Võtke ühendust administraatoriga',
        securityTitle: 'Turvateade',
        securityText: 'Ligipääs ainult volitatud klientidele. Ligipääsuks võtke meiega ühendust:',
        backToSite: 'Tagasi avalehele',
        successToast: 'Sisselogimine õnnestus!',
        errorFallback: 'Sisselogimise viga'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Ligipääs puudub',
        description: 'Teil ei ole õigust sellele jaotisele ligi pääseda.',
        detail: 'Kui arvate, et see on viga, võtke ühendust administraatoriga.',
        backToPanel: 'Tagasi paneelile',
        home: 'Avaleht'
      },
      documents: {
        title: 'Lisa dokument projektile',
        fileRequired: 'Palun valige fail',
        uploadSuccess: 'Fail üles laaditud',
        uploadError: 'Üleslaadimise viga',
        fileLabel: 'Fail',
        fileInstruction: 'Klõpsake faili valimiseks',
        fileFormats: 'PDF, Excel, Word, Pildid',
        categoryLabel: 'Dokumendi tüüp',
        categories: [
          { value: 'skice', label: 'Skeem' },
          { value: 'iesniegums', label: 'Taotlus' },
          { value: 'ligums', label: 'Leping' },
          { value: 'atskaite', label: 'Aruanne' },
          { value: 'foto', label: 'Foto' },
          { value: 'cits', label: 'Muu' }
        ],
        visibleLabel: 'Nähtav kliendile',
        visibleHint: 'Klient saab dokumenti vaadata ja alla laadida',
        upload: 'Laadi üles',
        uploading: 'Üleslaadimine...',
        cancel: 'Tühista'
      },
      client: {
        dashboard: {
          greeting: 'Tere tulemast',
          subtitle: 'Teie',
          subtitleHighlight: 'kliendiportaali ülevaade',
          stats: {
            totalJobs: 'Töid kokku',
            activeJobs: 'Aktiivsed tööd',
            completedJobs: 'Lõpetatud',
            newMessages: 'Uued sõnumid'
          },
          lastUpdate: 'Viimane uuendus:',
          actions: {
            jobsTitle: 'Vaata kõiki töid',
            jobsDescription: 'Vaata tööde staatuseid ja detaile',
            documentsTitle: 'Dokumendid',
            documentsDescription: 'Vaata ja laadi alla failid'
          },
          recentTitle: 'Viimased tööd',
          viewAll: 'Vaata kõiki',
          responsibleLabel: 'Vastutaja',
          emptyJobs: 'Töid pole veel'
        },
        projects: {
          title: 'Minu projektid',
          subtitlePrefix: 'Teie',
          subtitleHighlight: 'metsaprojektid',
          subtitleSuffix: 'ja nende progress',
          cadastralLabel: 'Katastri nr:',
          progressLabel: 'Üldine progress',
          jobsTotal: 'Kokku',
          jobsCompleted: 'Lõpetatud',
          jobsInProgress: 'Käimas',
          jobsPlanned: 'Planeeritud',
          nextStepTitle: 'Mis edasi?',
          viewDetails: 'Vaata detaile',
          emptyTitle: 'Projekte pole',
          emptySubtitle: 'Projektid ilmuvad siia, kui administraator need loob.'
        },
        jobs: {
          title: 'Tööd',
          subtitlePrefix: 'Vaadake oma töid ja nende',
          subtitleHighlight: 'staatusi',
          searchPlaceholder: 'Otsi töid...',
          filterAll: 'Kõik',
          filterPlanned: 'Planeeritud',
          filterInProgress: 'Käimas',
          filterCompleted: 'Lõpetatud',
          deadlineLabel: 'Kuni',
          emptyTitle: 'Töid ei leitud',
          emptyFiltered: 'Proovige muuta otsingukriteeriume',
          emptyAll: 'Töid pole veel lisatud'
        },
        jobDetail: {
          backToJobs: 'Tagasi tööde juurde',
          notFoundTitle: 'Tööd ei leitud',
          infoTitle: 'Töö info',
          responsibleLabel: 'Vastutaja',
          startDateLabel: 'Alguskuupäev',
          plannedEndLabel: 'Planeeritud lõppkuupäev',
          completedLabel: 'Lõpetatud',
          notesTitle: 'Märkmed',
          documentsTitle: 'Lisatud dokumendid',
          documentsEmpty: 'Dokumente ei ole',
          downloadError: 'Dokumendi allalaadimine ebaõnnestus',
          timelineTitle: 'Staatuse ajajoon',
          timelineEmpty: 'Ajaloo kirjeid pole'
        },
        documents: {
          title: 'Dokumendid',
          subtitlePrefix: 'Vaadake ja laadige alla oma',
          subtitleHighlight: 'dokumente',
          searchPlaceholder: 'Otsi dokumente, projekte või autoreid...',
          filterAll: 'Kõik',
          allProjects: 'Kõik projektid',
          allUploaders: 'Kõik autorid',
          sortNewest: 'Uuemad ees',
          sortOldest: 'Vanemad ees',
          latestOnly: 'Ainult viimased versioonid',
          download: 'Laadi alla',
          downloadError: 'Dokumendi allalaadimine ebaõnnestus',
          emptyTitle: 'Dokumente pole',
          emptyNoDocuments: 'Dokumente pole veel.',
          emptyFiltered: 'Valitud filtritele vastavaid dokumente ei leitud.',
          versionLabel: 'Versioon',
          categoryOther: 'Muu',
          categories: {
            valsts_institucijam: 'Riigiasutustele',
            atskaites: 'Aruanded',
            merijumu_dati: 'Mõõtmisandmed',
            skices: 'Skeemid',
            cits: 'Muu'
          }
        },
        messages: {
          title: 'Sõnumid',
          subtitle: 'Teavitused ja sõnumid administratsioonilt',
          inboxTitle: 'Sisendkaust',
          emptyList: 'Sõnumeid pole',
          emptyDetailTitle: 'Valige sõnum',
          emptyDetailText: 'Klõpsake sõnumil, et seda lugeda'
        },
        contact: {
          title: 'Kontakt',
          subtitlePrefix: 'Esitage küsimus või',
          subtitleHighlight: 'võtke meiega ühendust',
          phoneLabel: 'Telefon',
          emailLabel: 'E-post',
          hoursLabel: 'Tööaeg',
          formTitle: 'Saada sõnum',
          subjectLabel: 'Teema',
          subjectPlaceholder: 'Sõnumi teema',
          messageLabel: 'Sõnum',
          messagePlaceholder: 'Teie küsimus või sõnum...',
          submit: 'Saada',
          submitting: 'Saatmine...',
          successTitle: 'Sõnum saadetud!',
          successBody: 'Võtame teiega ühendust.',
          toastSuccess: 'Sõnum saadetud!',
          toastError: 'Viga sõnumi saatmisel'
        }
      },
      admin: {
        dashboard: {
          title: 'Administratsioon',
          titleSuffix: 'paneel',
          subtitlePrefix: 'Halda',
          subtitleHighlight: 'kliente, töid ja dokumente',
          stats: {
            totalClients: 'Kliente kokku',
            totalJobs: 'Töid kokku',
            activeJobs: 'Aktiivsed tööd',
            completedJobs: 'Lõpetatud'
          },
          quick: {
            clientsTitle: 'Halda kliente',
            clientsDescription: 'Lisa ja muuda kliente',
            jobsTitle: 'Halda töid',
            jobsDescription: 'Loo ja uuenda töid',
            documentsTitle: 'Dokumendid',
            documentsDescription: 'Laadi üles dokumente'
          },
          recentTitle: 'Viimased tööd',
          viewAll: 'Vaata kõiki',
          emptyJobs: 'Töid pole'
        },
        clients: {
          title: 'Kliendid',
          subtitle: 'Halda kasutajaid ja ligipääse',
          addButton: 'Lisa klient',
          searchPlaceholder: 'Otsi kliente...',
          table: {
            client: 'Klient',
            username: 'Kasutajanimi',
            contacts: 'Kontaktid',
            role: 'Roll',
            status: 'Staatus',
            actions: 'Tegevused'
          },
          roleAdmin: 'Admin',
          roleClient: 'Klient',
          statusActive: 'Aktiivne',
          statusInactive: 'Mitteaktiivne',
          confirmDelete: 'Kas soovite kindlasti kustutada kasutaja "{name}"?',
          toastCreated: 'Kasutaja loodud',
          toastUpdated: 'Kasutaja uuendatud',
          toastDeleted: 'Kasutaja kustutatud',
          toastDeleteError: 'Kustutamise viga',
          toastError: 'Viga',
          passwordLengthError: 'Parool peab olema vähemalt 12 märki pikk',
          modal: {
            addTitle: 'Lisa klient',
            editTitle: 'Muuda kasutajat',
            clientNameLabel: 'Kliendi nimi / ettevõte',
            clientNamePlaceholder: 'OÜ Metsamaa',
            emailLabel: 'E-post',
            phoneLabel: 'Telefon',
            usernameLabel: 'Kasutajanimi',
            usernamePlaceholder: 'kasutajanimi',
            passwordLabel: 'Parool *',
            passwordEditLabel: 'Uus parool (valikuline)',
            passwordPlaceholder: 'Vähemalt 12 märki',
            roleLabel: 'Roll',
            cancel: 'Tühista',
            create: 'Loo',
            save: 'Salvesta'
          }
        },
        projects: {
          title: 'Projektide haldus',
          subtitle: 'Halda klientide projekte ja töid',
          addButton: 'Uus projekt',
          searchPlaceholder: 'Otsi projekte...',
          progressLabel: 'Progress',
          stats: {
            total: 'Projekte kokku',
            active: 'Aktiivsed',
            completed: 'Lõpetatud',
            totalJobs: 'Töid kokku'
          },
          jobsTotal: 'Kokku',
          jobsCompleted: 'Lõpetatud',
          jobsInProgress: 'Käimas',
          jobsPlanned: 'Planeeritud',
          editButton: 'Muuda',
          deleteButton: 'Kustuta',
          emptyState: 'Projekte ei leitud',
          confirmDelete: 'Kas soovite kindlasti selle projekti kustutada?',
          toastCreated: 'Projekt loodud',
          toastUpdated: 'Projekt uuendatud',
          toastDeleted: 'Projekt kustutatud',
          toastDeleteError: 'Projekti kustutamine ebaõnnestus',
          toastError: 'Viga',
          toastLoadError: 'Projektide laadimine ebaõnnestus',
          noClient: 'Pole määratud',
          modal: {
            addTitle: 'Uus projekt',
            editTitle: 'Muuda projekti',
            nameLabel: 'Projekti nimi',
            namePlaceholder: 'Lejasrunķi kinnistu – Tööd 2026',
            clientLabel: 'Klient',
            clientPlaceholder: 'Valige klient',
            propertyNameLabel: 'Kinnistu nimi',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Katastri number',
            addressLabel: 'Kinnistu aadress',
            addressPlaceholder: 'Ropaži vald',
            descriptionLabel: 'Kirjeldus',
            descriptionPlaceholder: 'Projekti detailne kirjeldus...',
            statusLabel: 'Staatus',
            nextStepLabel: 'Mis edasi?',
            nextStepPlaceholder: 'Lõpetada raieala märkimine',
            cancel: 'Tühista',
            create: 'Loo',
            save: 'Salvesta'
          }
        },
        jobs: {
          title: 'Tööd',
          subtitle: 'Halda töid ja nende staatuseid',
          addButton: 'Lisa töö',
          searchPlaceholder: 'Otsi töid...',
          filterAll: 'Kõik',
          table: {
            job: 'Töö',
            client: 'Klient',
            status: 'Staatus',
            dates: 'Kuupäevad',
            responsible: 'Vastutaja',
            actions: 'Tegevused'
          },
          deadlineLabel: 'Kuni',
          confirmDelete: 'Kas soovite kindlasti kustutada töö "{title}"?',
          unknownClient: 'Teadmata',
          toastCreated: 'Töö loodud',
          toastUpdated: 'Töö uuendatud',
          toastDeleted: 'Töö kustutatud',
          toastDeleteError: 'Viga',
          toastError: 'Viga',
          modal: {
            addTitle: 'Lisa töö',
            editTitle: 'Muuda tööd',
            titleLabel: 'Töö nimi',
            titlePlaceholder: 'Seisvate puude märgistamine',
            descriptionLabel: 'Kirjeldus',
            descriptionPlaceholder: 'Töö kirjeldus...',
            clientLabel: 'Klient',
            clientPlaceholder: 'Valige klient',
            projectLabel: 'Projekt',
            projectPlaceholder: 'Valige projekt',
            projectPlaceholderEmpty: 'Valige esmalt klient',
            statusLabel: 'Staatus',
            responsibleLabel: 'Vastutaja',
            responsiblePlaceholder: 'Jaan Tamm',
            startDateLabel: 'Alguskuupäev',
            endDateLabel: 'Planeeritud lõppkuupäev',
            notesLabel: 'Märkmed kliendile',
            notesPlaceholder: 'Märkmed, mis on kliendile nähtavad...',
            cancel: 'Tühista',
            create: 'Loo',
            save: 'Salvesta'
          }
        },
        bulkJob: {
          title: 'Lisa projektile mitu tööd',
          selectLabel: 'Valige töö tüübid:',
          selectAll: 'Vali kõik',
          clearAll: 'Tühjenda',
          selectError: 'Palun valige vähemalt üks töö tüüp',
          selectedCount: 'Valitud',
          selectedSuffix: 'töö tüüpi',
          statusNote: 'Kõik tööd luuakse staatusega „Planeeritud“',
          cancel: 'Tühista',
          creating: 'Loomine...',
          createCount: 'Loo {count} tööd',
          successTitle: 'Tööd loodud edukalt!',
          error: 'Tööde loomine ebaõnnestus',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Seisvate puude märgistamine' },
            { id: 'caurmera_merishana', label: 'Läbimõõdu mõõtmine' },
            { id: 'cirsmas_stigoshana', label: 'Raieala märkimine' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Kinnistu piiride taastamine' },
            { id: 'robezzimju_atjaunoshana', label: 'Piirimärkide taastamine' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Jäetavate puude märkimine valikraiel' },
            { id: 'cirsmu_iezimeshana', label: 'Raieala piiride märkimine' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentatsiooni koostamine' },
            { id: 'es_projektu_sagatavoshana', label: 'EL projektide ettevalmistus' },
            { id: 'cits', label: 'Muu' }
          ]
        },
        audit: {
          title: 'Auditi logi',
          subtitle: 'Süsteemi tegevuste ajalugu',
          emptyTitle: 'Auditi kirjeid pole',
          emptyBody: 'Tegevuste ajalugu kuvatakse siin'
        },
        visitors: {
          title: 'Külastuste statistika',
          subtitle: 'Avaliku veebilehe külastused',
          range7: '7 päeva',
          range30: '30 päeva',
          range7Short: '7 päeva',
          range30Short: '30 päeva',
          rangeOther: '{count} päeva',
          totalLabel: 'Külastusi kokku',
          uniqueLabel: 'Unikaalsed külastajad',
          periodLabel: 'Periood',
          dailyTitle: 'Külastused päevade kaupa',
          dailyEmpty: 'Valitud perioodil puuduvad andmed.',
          recentTitle: 'Viimased külastused',
          recentEmpty: 'Külastuste kirjeid pole.',
          unknownRegion: 'Tundmatu piirkond',
          visitNumber: 'Külastus #{number}'
        },
        testimonials: {
          title: 'Tagasiside haldus',
          subtitle: 'Kinnitage või peitke kliendi tagasisided enne avaldamist.',
          filters: {
            all: 'Kõik',
            pending: 'Ootel kinnitust',
            approved: 'Avaldatud',
            hidden: 'Peidetud'
          },
          loading: 'Tagasiside laadimine...',
          empty: 'Valitud filtrile vastavaid tagasisidesid ei ole.',
          average: 'Keskmiselt {rating}/5',
          speed: 'Kiirus',
          quality: 'Kvaliteet',
          communication: 'Suhtlus',
          responsiveness: 'Reageerimine',
          publish: 'Avalda',
          hide: 'Peida',
          returnToPending: 'Tagasi ootele'
        },
        payroll: {
          title: 'Palga arvestus',
          subtitle: 'Töötajate palgaarvestus kuude kaupa',
          addEntry: 'Lisa kirje',
          export: 'Ekspordi XLSX',
          confirmDelete: 'Kas kustutada see kirje?',
          toastCreated: 'Kirje salvestatud',
          toastUpdated: 'Kirje uuendatud',
          toastDeleted: 'Kirje kustutatud',
          toastDeleteError: 'Kirjet ei õnnestunud kustutada',
          toastError: 'Kirjet ei õnnestunud salvestada',
          validation: {
            employee: 'Valige töötaja',
            workTypes: 'Valige vähemalt üks töö tüüp'
          },
          filters: {
            month: 'Kuu',
            year: 'Aasta',
            employee: 'Töötaja',
            client: 'Klient',
            status: 'Arve',
            statusAll: 'Kõik',
            statusPaid: 'Makstud',
            statusUnpaid: 'Maksmata'
          },
          summary: {
            totalSalary: 'Brutopalk kokku',
            totalCosts: 'Kulud kokku',
            fuelCost: 'Kütus',
            paintCost: 'Värv'
          },
          table: {
            title: 'Palgakirjed',
            date: 'Kuupäev',
            employee: 'Töötaja',
            client: 'Klient',
            property: 'Objekt',
            workTypes: 'Tööde tüübid',
            salary: 'Bruto',
            costs: 'Kulud',
            paid: 'Makstud',
            actions: 'Tegevused',
            edit: 'Muuda',
            delete: 'Kustuta'
          },
          empty: {
            title: 'Palgakirjeid pole',
            body: 'Valitud perioodil kirjeid pole.'
          },
          form: {
            addTitle: 'Uus palgakirje',
            editTitle: 'Muuda palgakirjet',
            date: 'Kuupäev',
            employee: 'Töötaja',
            client: 'Klient (valikuline)',
            propertyName: 'Objekti nimi',
            cadastralNumber: 'Katastri number',
            kilometers: 'Sõidetud kilomeetrid',
            paintCans: 'Värviballoonid (tk)',
            fuelRate: 'Kütuse määr (€/km)',
            paintPrice: 'Värviballooni hind (€/tk)',
            workTypes: 'Tööde tüübid',
            amount: 'Maht',
            rate: 'Tasu',
            notes: 'Märkused',
            customRateNote: 'Määr sisestatakse käsitsi',
            invoicePaid: 'Makse laekunud',
            save: 'Salvesta',
            cancel: 'Tühista'
          },
          totals: {
            salary: 'Brutopalk',
            costs: 'Ettevõtte kulud',
            fuel: 'Kütusekulu',
            paint: 'Värvikulu'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Puude märgistamine',
            cirsmas_stigoshana: 'Raieala märkimine',
            caurmera_merishana: 'Läbimõõdu mõõtmine',
            paliekoso_koku_izzimeshana: 'Jäetavate puude märkimine',
            cirsmu_iezimeshana: 'Raieala piiride märkimine',
            ipashuma_robezu_atjaunoshana: 'Piiride taastamine',
            robezzimju_atjaunoshana: 'Piirimärkide taastamine'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'tk'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projekti ei leitud',
          back: 'Tagasi',
          propertyLabel: 'Kinnistu:',
          cadastralLabel: 'Katastri:',
          addressLabel: 'Aadress:',
          progressLabel: 'Üldine progress',
          jobsTotal: 'Töid kokku',
          jobsCompleted: 'Lõpetatud',
          jobsInProgress: 'Käimas',
          jobsPlanned: 'Planeeritud',
          nextStepTitle: 'Mis edasi?',
          jobsTitle: 'Projekti tööd',
          bulkAddJobs: 'Lisa mitu tööd',
          deadlineLabel: 'Tähtaeg',
          lastUpdateLabel: 'Viimane muudatus:',
          emptyJobs: 'Selles projektis ei ole veel ühtegi tööd'
        }
      }
    }
  },
  sv: {
    languageLabel: 'SV',
    company: {
      slogan: 'Hållbart skogsbruk'
    },
    heroBadge: 'Oberoende skogstjänster',
    hero: {
      title: 'Oberoende värdering av avverkningsområde för skogsägare',
      subtitle: 'Vi hjälper skogsägare att noggrant bedöma värdet på avverkningsområdet och förbereda skogen för avverkning, med professionella mätningar och all nödvändig dokumentation.',
      description: 'Vi arbetar endast för skogsägarens intresse – vi köper inte avverkningsområden och är inte kopplade till virkesuppköpare.',
      workIntro: 'Vad vi gör',
      workItems: [
        'Markering av stående träd',
        'Diameter­mätningar',
        'Uppmärkning av avverkningsområde',
        'Återställning av fastighetsgränser och gränsmarkeringar',
        'Upprättande och inlämning av dokumentation till myndigheter'
      ],
      workNote: 'Fullständig lista över arbeten finns i avsnittet ”Arbeten”.',
      reasonsTitle: 'Varför välja oss',
      reasons: [
        'Noggranna skogsmätningar',
        'Oberoende värdering av avverkningsområde',
        'Korrekt dokumentation',
        'Full transparens i processen'
      ],
      closing: 'Kunder kan följa arbetets framsteg online var som helst.',
      tagline: 'Kontakta oss för ett professionellt bemötande!',
      ctaPrimary: 'Beställ värdering av avverkningsområde',
      ctaSecondary: 'Kundportal',
      salesHighlights: [
        'Oberoende värdering',
        'Noggranna mätningar',
        'Fullständig dokumentation',
        'Full transparens'
      ],
      calloutTitle: 'Sila Meži‑garanti',
      calloutBody: 'Noggranna mätningar. Korrekt dokumentation. Full transparens.',
      workLink: 'Se arbeten',
      scrollHint: 'Scrolla ner',
      subtitleHighlight: 'noggrant bedöma värdet på avverkningsområdet',
      descriptionHighlight: 'vi köper inte avverkningsområden och är inte kopplade till virkesuppköpare.'
    },
    trustBadges: [
      { id: 1, title: 'Noggranna skogsmätningar', description: 'Detaljerade fältmätningar och analys' },
      { id: 2, title: 'Oberoende värdering av avverkningsområde', description: 'Utan intresse i virkesinköp' },
      { id: 3, title: 'Korrekt dokumentation', description: 'Fullt stöd för förberedelse och inlämning' },
      { id: 4, title: 'Full transparens', description: 'Kunder följer arbetet online' }
    ],
    services: {
      eyebrow: 'Våra tjänster',
      title: 'Professionella skogstjänster för skogsägare',
      description: 'Vi erbjuder ett komplett utbud av skogstjänster — från skogsvärdering och mätning till dokumentation, projektledning och organisering av skogsarbete.',
      mission: 'Vårt mål är att hjälpa skogsägare att fatta välgrundade beslut genom korrekt information, professionellt arbetssätt och fullt processtöd.',
      ctaQuestion: 'Osäker på vilken tjänst du behöver?',
      ctaLink: 'Kontakta oss för en kostnadsfri konsultation'
    },
    servicesList: [
      {
        id: 1,
        category: 'Skogs- och avverkningsområdesvärdering',
        description: 'Vi genomför professionell värdering av stående träd och avverkningsområden baserat på detaljerade fältmätningar, aktuella marknadspriser och gällande regelverk. Värderingen görs oberoende av virkesinköp och ger objektiv och pålitlig information till skogsägaren.',
        items: [
          'Markering av stående träd',
          'Mätning av trädens diameter och andra parametrar',
          'Beräkning och analys av avverkningsområdets värde'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Skogsmätning och gränsarbeten',
        description: 'Vi erbjuder olika skogsmätningar och fastighetsgränsjusteringar i fält. Alla arbeten utförs enligt kadastrala data och gällande regelverk. Noggranna mätningar hjälper till att undvika gränstvister och säkerställa korrekt skogsförvaltning.',
        items: [
          'Uppmärkning av avverkningsområde',
          'Återställning av fastighetsgränser i fält',
          'Installation och återställning av gränsmarkeringar'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Skogsförnyelse och ungskogsvård',
        description: 'Vi hjälper skogsägare att säkerställa hållbar skogsutveckling genom att organisera förnyelse och ungskogsvård. Rätt skötsel i tidiga utvecklingsfaser påverkar skogens kvalitet och framtida värde.',
        items: [
          'Organisering av skogsförnyelse',
          'Planering och samordning av planteringsarbeten',
          'Organisering av ungskogsvård'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentation och tillstånd',
        description: 'Vi förbereder och lämnar in all nödvändig dokumentation till Statens skogstjänst och andra myndigheter. Vi ger fullt administrativt stöd genom hela processen så att skogsägare slipper komplicerad byråkrati.',
        items: [
          'Dokumentförberedelse för statliga institutioner',
          'Upprättande och inlämning av ansökningar',
          'Fullt stöd i den administrativa processen'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'EU-stödprojekt',
        description: 'Vi rådgiver skogsägare om tillgängliga EU-stöd inom skogsbruk. Vi ansvarar för hela projektprocessen — från idé till genomförande.',
        items: [
          'Rådgivning om EU-stöd',
          'Upprättande av projektdokumentation',
          'Inlämning och uppföljning av projekt'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Arbeten',
      title: 'Arbeten',
      description: 'Välj arbeten du är intresserad av så tar vi fram en exakt offert. Ditt val läggs automatiskt till i förfrågningsformuläret.',
      summaryTitle: 'Valda arbeten',
      summaryEmpty: 'Inga arbeten valda. Välj en tjänst i listan ovan.',
      requestCta: 'Begär offert',
      contactCta: 'Kontakta oss',
      selectError: 'Välj minst ett arbete för att begära pris.',
      itemSelected: 'Tillagt i offertförfrågan',
      itemAdd: 'Markera för att begära pris'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Skogsarbeten',
        description: 'Noggranna fältarbeten och förberedelse av avverkningsområde för säker och korrekt skogsförvaltning.',
        items: [
          'Uppmärkning av avverkningsområde',
          'Trädmarkering',
          'Kvistsågning av stående träd'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Skogsförnyelse och skötsel',
        description: 'Säkerställer hållbar skogsutveckling genom riktade förnyelsearbeten.',
        items: [
          'Skogsförnyelse',
          'Ungskogsvård',
          'Skydd av ungskog mot viltskador'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Förvaltning av skogsfastigheter',
        description: 'Helhetsförvaltning av skogsfastigheter och samordning av arbeten från planering till genomförande.',
        items: ['Förvaltning av skogsfastigheter']
      },
      {
        id: 'es',
        title: 'EU-projektförberedelse',
        description: 'Rådgivning, dokumentation och uppföljning av projekt inom EU-stödprogram.',
        items: ['Inlämning och uppföljning av projekt']
      }
    ],
    process: {
      eyebrow: 'Samarbetsprocess',
      title: 'Så går samarbetet till',
      description: 'En tydlig och transparent process från förfrågan till färdigställande.',
      steps: [
        { id: 1, title: 'Förfrågan', description: 'Kunden kontaktar oss för att beställa värdering eller annan tjänst.' },
        { id: 2, title: 'Fastighetsbesiktning', description: 'Vi besöker fastigheten och utför nödvändiga fältarbeten.' },
        { id: 3, title: 'Mätningar och värdering', description: 'Vi mäter skogen noggrant och tar fram en objektiv värdering.' },
        { id: 4, title: 'Dokumentation', description: 'Vi upprättar och lämnar in nödvändiga dokument till statliga myndigheter.' },
        { id: 5, title: 'Uppföljning online', description: 'Kunden kan följa arbetets framsteg i kundportalen.' },
        { id: 6, title: 'Slutrapport', description: 'Vi ger en tydlig rapport om utförda arbeten och resultat.' }
      ]
    },
    portal: {
      eyebrow: 'Digital plattform',
      title: 'Digital plattform – Kundportal',
      description: 'Vi erbjuder våra kunder en bekväm och säker onlineportal som ger ständig tillgång till projekt- och arbetsstatus. Portalen gör det möjligt att följa uppdateringar, följa status och få tillgång till alla projektdokument på ett ställe.',
      subtitle: 'Plattformen är utvecklad för maximal transparens och smidig kommunikation med vårt team. Kunder kan när som helst se aktuell status utan att behöva kontakta oss. Portalen fungerar på både dator och mobil, så informationen finns alltid nära till hands.',
      featuresTitle: 'Huvudfunktioner',
      features: [
        { id: 1, title: 'Arbetsstatus', description: 'Följ projektets framsteg i realtid – planerat, pågående eller klart.', icon: 'Activity' },
        { id: 2, title: 'Dokumentåtkomst', description: 'Alla projektdokument samlade på ett ställe, redo att visas och laddas ner.', icon: 'FolderOpen' },
        { id: 3, title: 'Aviseringar', description: 'Få uppdateringar om framsteg, ändringar och viktiga nyheter.', icon: 'Bell' },
        { id: 4, title: 'Tillgänglig överallt', description: 'Fungerar på dator och mobil med enkel åtkomst var som helst.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Logga in i portalen',
      ctaRequest: 'Begär åtkomst',
      preview: {
        headerTitle: 'Mina projekt',
        headerActive: '3 aktiva',
        items: [
          { title: 'Värdering av avverkningsområde #127', status: 'Slutförd', tone: 'success' },
          { title: 'Skogsmätning', status: 'Pågår', tone: 'warning' },
          { title: 'Dokumentation för SFS', status: 'Planerad', tone: 'info' }
        ],
        footerLeft: 'Senaste aktivitet: idag',
        footerRight: '2 nya dokument'
      }
    },
    why: {
      title: 'Varför välja oberoende värdering',
      description: 'En värdering som görs av en potentiell köpare innebär alltid en intressekonflikt. Oberoende värdering ger en objektiv bild av det verkliga värdet och hjälper skogsägaren att fatta välgrundade beslut.',
      conclusion: 'Oberoende värdering hjälper ofta till att undvika ofördelaktiga affärer och ger en tydlig bild av skogsfastighetens potential.',
      stats: [
        { value: '15–30%', label: 'Möjlig inkomstskillnad' },
        { value: '100%', label: 'Objektiv värdering' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Varför är köparen inte en objektiv värderare?',
        content: 'Köparen har ett ekonomiskt intresse av att köpa skogen så billigt som möjligt, vilket skapar en intressekonflikt. En oberoende värderare arbetar enbart för din fördel.'
      },
      {
        id: 2,
        title: 'Hur påverkar oberoende värdering inkomsten?',
        content: 'Noggrann och oberoende värdering hjälper till att fastställa verkligt värde och nå ett rättvist pris i förhandlingar. Många skogsägare har fått 15–30% högre pris med oberoende värdering.'
      },
      {
        id: 3,
        title: 'Vanliga misstag',
        content: 'Otillräcklig information om virkesvolymer, att enbart lita på köparens värdering, oförberedd dokumentation och brist på marknadskännedom – dessa misstag minskar skogsägarens intäkter.'
      }
    ],
    about: {
      title: 'Om företaget',
      subtitle: 'Erfarenhet inom skogsbruk',
      description: 'Vi är en skogstjänsteleverantör specialiserad på oberoende värdering av avverkningsområden och noggranna skogsmätningar. Vi arbetar enligt gällande regler och i nära samarbete med statliga myndigheter.',
      mission: 'Vårt mål är att ge skogsägare korrekt, transparent och professionell service genom hela samarbetet.',
      points: [
        'Specialiserade på oberoende värdering av avverkningsområden',
        'Noggranna skogsmätningar i enlighet med regelverk',
        'Nära samarbete med Statens skogstjänst',
        'Fullständig dokumentationssupport',
        'Vi samarbetar med både privatpersoner och juridiska personer'
      ],
      regionsLabel: 'Verksamhetsområden',
      regions: ['Riga och omnejd', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Hållbart skogsbruk',
      sustainabilityText: 'Vi hjälper skogsägare att bevara skogens värde för framtida generationer genom att följa hållbara principer och regelverk.',
      testimonialsEyebrow: 'Omdömen',
      testimonialsTitle: 'Vad våra kunder säger',
      testimonialsDescription: 'Äkta upplevelser och omdömen om vårt samarbete.',
      testimonialsAdd: 'Lägg till omdöme',
      testimonialsLoading: 'Laddar omdömen...',
      testimonialsEmpty: 'Inga omdömen än. Bli först med att dela din upplevelse!',
      testimonialsModalTitle: 'Lägg till omdöme',
      form: {
        nameLabel: 'Namn eller företag',
        regionLabel: 'Region',
        ratingLabel: 'Betyg',
        speedLabel: 'Hastighet',
        qualityLabel: 'Kvalitet',
        communicationLabel: 'Kommunikation',
        responsivenessLabel: 'Respons',
        textLabel: 'Omdömestext',
        cancel: 'Avbryt',
        submit: 'Skicka omdöme',
        sending: 'Skickar...',
        success: 'Omdöme skickat för godkännande',
        error: 'Misslyckades att skicka omdöme. Försök igen.'
      },
      metrics: {
        speed: 'Hastighet',
        quality: 'Kvalitet',
        communication: 'Kommunikation',
        responsiveness: 'Respons'
      }
    },
    contact: {
      eyebrow: 'Kontakta oss',
      title: 'Kontakt',
      description: 'Kontakta oss för att beställa en tjänst eller få rådgivning om din skogsfastighet.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Skogsspecialist',
      formNote: 'Fyll i formuläret så kontaktar vi dig.',
      infoTitle: 'Kontaktinformation',
      phoneLabel: 'Telefon',
      emailLabel: 'E‑post',
      addressLabel: 'Juridisk adress',
      hoursLabel: 'Arbetstid',
      freeConsultationTitle: 'Kostnadsfri konsultation',
      freeConsultationText: 'Första samtalet och bedömningen är kostnadsfri. Kontakta oss så hittar vi bästa lösningen tillsammans.',
      formTitle: 'Förfrågningsformulär',
      successTitle: 'Tack för din förfrågan!',
      successBody: 'Vi kontaktar dig inom kort.',
      formNameLabel: 'Namn, efternamn',
      formNamePlaceholder: 'Anna Andersson',
      formPhoneLabel: 'Telefonnummer',
      formPhonePlaceholder: '+46 70 123 4567',
      formEmailLabel: 'E‑postadress',
      formEmailPlaceholder: 'anna@example.com',
      formMessageLabel: 'Meddelande',
      formMessagePlaceholder: 'Din fråga eller beskrivning av situationen...',
      formConsent: 'Genom att skicka formuläret godkänner du behandling av personuppgifter enligt GDPR.',
      formSubmitting: 'Skickar...',
      formSubmit: 'Skicka förfrågan',
      toastSavedTitle: 'Förfrågan sparad',
      toastSavedBody: 'E‑postleverans kräver verifierad domän. Meddelandet syns i adminportalen.',
      toastSentTitle: 'Förfrågan skickad!',
      toastSentBody: 'Vi kontaktar dig inom kort.',
      toastErrorTitle: 'Fel vid sändning av förfrågan',
      submitError: 'Fel vid sändning av förfrågan. Försök igen.',
      prefillLabel: 'Jag vill ha en prisoffert för'
    },
    cookie: {
      text: 'Denna webbplats använder cookies för att förbättra din upplevelse.',
      accept: 'Jag godkänner'
    },
    privacy: {
      badge: 'Integritetspolicy',
      title: 'Sila Meži integritetspolicy',
      intro: 'Vi värnar om din datasäkerhet och integritet. I denna policy förklarar vi vilka data vi behandlar och varför.',
      controllerTitle: 'Personuppgiftsansvarig',
      controllerRegLabel: 'Reg.nr:',
      controllerAddressLabel: 'Adress:',
      controllerEmailLabel: 'E‑post för datafrågor:',
      dataTitle: 'Vilka data behandlas',
      dataItemContact: 'Uppgifter från kontaktformuläret (namn, e‑post, telefon, meddelande).',
      dataItemVisits: 'Besöksloggning efter cookie‑samtycke (IP‑adress, region, besökstid).',
      dataItemEmail: 'E‑postleveransdata via Resend‑tjänsten.',
      visitsTitle: 'Besöksstatistik',
      visitsText: 'Besök loggas endast efter ditt cookie‑samtycke. För regionsbestämning använder vi IPinfo.',
      cookiesTitle: 'Cookies',
      cookiesText: 'Denna webbplats använder nödvändiga, funktionella och statistiska cookies för att säkerställa drift, förbättra upplevelsen och förstå besökstrender.',
      retentionTitle: 'Lagring och rättigheter',
      retentionText: 'Data lagras så länge det behövs för tjänsten eller enligt lag. Du kan begära rättelse eller radering genom att skriva till ovanstående e‑postadress.',
      thirdPartyTitle: 'Tredjepartstjänster',
      thirdPartyText: 'Vi använder IPinfo för regionsbestämning och Resend för e‑postleverans. Tredje parter behandlar data enligt sina egna integritetspolicys.'
    },
    footer: {
      companyDescription: 'Oberoende värdering av avverkningsområde och skogstjänster i hela Lettland. Vi arbetar endast i skogsägarens intresse.',
      companyNote: 'Vi samarbetar med både privatpersoner och juridiska personer.',
      navigationTitle: 'Navigering',
      servicesTitle: 'Tjänster',
      contactTitle: 'Kontakt',
      quickLinks: {
        home: 'Hem',
        services: 'Tjänster',
        process: 'Så går det till',
        portal: 'Kundportal',
        why: 'Varför oberoende värdering',
        about: 'Om oss',
        contact: 'Kontakt'
      },
      services: {
        assessment: 'Värdering av avverkningsområde',
        measurements: 'Skogsmätningar',
        documentation: 'Dokumentation',
        euProjects: 'EU‑projekt'
      },
      rights: 'Alla rättigheter förbehållna.',
      privacy: 'Integritetspolicy',
      terms: 'Användarvillkor'
    },
    nav: {
      home: 'Hem',
      services: 'Tjänster',
      works: 'Arbeten',
      process: 'Process',
      why: 'Varför vi',
      about: 'Om',
      contact: 'Kontakt',
      portal: 'Kundportal',
      consult: 'Ansök',
      consultMobile: 'Boka konsultation'
    },
    portalUi: {
      common: { loading: 'Laddar...' },
      status: {
        planned: 'Planerad',
        inProgress: 'Pågår',
        completed: 'Avslutad',
        active: 'Aktiv',
        onHold: 'Pausad',
        awaitingInfo: 'Avvaktar info',
        submitted: 'Inlämnad'
      },
      nav: {
        client: {
          dashboard: 'Översikt',
          projects: 'Projekt',
          jobs: 'Arbeten',
          documents: 'Dokument',
          messages: 'Meddelanden',
          contact: 'Kontakt'
        },
        admin: {
          dashboard: 'Översikt',
          clients: 'Kunder',
          projects: 'Projekt',
          jobs: 'Arbeten',
          documents: 'Dokument',
          messages: 'Aviseringar',
          visitors: 'Besök',
          testimonials: 'Omdömen',
          audit: 'Audit log',
          payroll: 'Löneberäkning'
        }
      },
      layout: {
        portalLabel: 'Kundportal',
        roleAdmin: 'Administratör',
        roleClient: 'Kund',
        logout: 'Logga ut'
      },
      login: {
        portalLabel: 'Kundportal',
        title: 'Logga in i kundportalen',
        description: 'Här kan du följa arbetsstatus, dokument och rapporter om din fastighet.',
        usernameLabel: 'Användarnamn',
        usernamePlaceholder: 'Ange användarnamn',
        passwordLabel: 'Lösenord',
        passwordPlaceholder: 'Ange lösenord',
        togglePassword: 'Visa lösenord',
        submit: 'Logga in',
        submitting: 'Loggar in...',
        forgotText: 'Glömt lösenord?',
        contactAdmin: 'Kontakta administratören',
        securityTitle: 'Säkerhetsmeddelande',
        securityText: 'Åtkomst endast för behöriga kunder. Kontakta oss för åtkomst:',
        backToSite: 'Tillbaka till startsidan',
        successToast: 'Inloggning lyckades!',
        errorFallback: 'Inloggningsfel'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Ingen åtkomst',
        description: 'Du har inte behörighet att komma åt denna sektion.',
        detail: 'Om du anser att detta är ett fel, kontakta administratören.',
        backToPanel: 'Tillbaka till panelen',
        home: 'Hem'
      },
      documents: {
        title: 'Lägg till dokument i projekt',
        fileRequired: 'Vänligen välj en fil',
        uploadSuccess: 'Fil uppladdad',
        uploadError: 'Uppladdningsfel',
        fileLabel: 'Fil',
        fileInstruction: 'Klicka för att välja fil',
        fileFormats: 'PDF, Excel, Word, Bilder',
        categoryLabel: 'Dokumenttyp',
        categories: [
          { value: 'skice', label: 'Skiss' },
          { value: 'iesniegums', label: 'Ansökan' },
          { value: 'ligums', label: 'Avtal' },
          { value: 'atskaite', label: 'Rapport' },
          { value: 'foto', label: 'Foto' },
          { value: 'cits', label: 'Övrigt' }
        ],
        visibleLabel: 'Synlig för kund',
        visibleHint: 'Kunden kan se och ladda ner dokumentet',
        upload: 'Ladda upp',
        uploading: 'Laddar upp...',
        cancel: 'Avbryt'
      },
      client: {
        dashboard: {
          greeting: 'Välkommen',
          subtitle: 'Din',
          subtitleHighlight: 'kundportalöversikt',
          stats: {
            totalJobs: 'Totalt antal jobb',
            activeJobs: 'Aktiva jobb',
            completedJobs: 'Avslutade',
            newMessages: 'Nya meddelanden'
          },
          lastUpdate: 'Senaste uppdatering:',
          actions: {
            jobsTitle: 'Visa alla jobb',
            jobsDescription: 'Granska jobbstatus och detaljer',
            documentsTitle: 'Dokument',
            documentsDescription: 'Visa och ladda ner filer'
          },
          recentTitle: 'Senaste jobb',
          viewAll: 'Visa alla',
          responsibleLabel: 'Ansvarig',
          emptyJobs: 'Inga jobb ännu'
        },
        projects: {
          title: 'Mina projekt',
          subtitlePrefix: 'Dina',
          subtitleHighlight: 'skogsprojekt',
          subtitleSuffix: 'och deras framsteg',
          cadastralLabel: 'Fastighetsnr:',
          progressLabel: 'Övergripande framsteg',
          jobsTotal: 'Totalt',
          jobsCompleted: 'Avslutade',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planerade',
          nextStepTitle: 'Vad händer härnäst?',
          viewDetails: 'Visa detaljer',
          emptyTitle: 'Inga projekt',
          emptySubtitle: 'Dina projekt visas här när administratören skapar dem.'
        },
        jobs: {
          title: 'Arbeten',
          subtitlePrefix: 'Se dina arbeten och deras',
          subtitleHighlight: 'status',
          searchPlaceholder: 'Sök arbeten...',
          filterAll: 'Alla',
          filterPlanned: 'Planerade',
          filterInProgress: 'Pågår',
          filterCompleted: 'Avslutade',
          deadlineLabel: 'Till',
          emptyTitle: 'Inga arbeten hittades',
          emptyFiltered: 'Försök ändra sökkriterierna',
          emptyAll: 'Inga arbeten tillagda ännu'
        },
        jobDetail: {
          backToJobs: 'Tillbaka till arbeten',
          notFoundTitle: 'Arbete hittades inte',
          infoTitle: 'Arbetsinformation',
          responsibleLabel: 'Ansvarig',
          startDateLabel: 'Startdatum',
          plannedEndLabel: 'Planerat slutdatum',
          completedLabel: 'Avslutad',
          notesTitle: 'Anteckningar',
          documentsTitle: 'Bifogade dokument',
          documentsEmpty: 'Inga dokument bifogade',
          downloadError: 'Det gick inte att ladda ner dokumentet',
          timelineTitle: 'Statuslinje',
          timelineEmpty: 'Inga historikposter'
        },
        documents: {
          title: 'Dokument',
          subtitlePrefix: 'Visa och ladda ner dina',
          subtitleHighlight: 'dokument',
          searchPlaceholder: 'Sök dokument, projekt eller författare...',
          filterAll: 'Alla',
          allProjects: 'Alla projekt',
          allUploaders: 'Alla författare',
          sortNewest: 'Nyaste först',
          sortOldest: 'Äldsta först',
          latestOnly: 'Endast senaste versioner',
          download: 'Ladda ner',
          downloadError: 'Det gick inte att ladda ner dokumentet',
          emptyTitle: 'Inga dokument',
          emptyNoDocuments: 'Inga dokument finns ännu.',
          emptyFiltered: 'Inga dokument matchar valda filter.',
          versionLabel: 'Version',
          categoryOther: 'Övrigt',
          categories: {
            valsts_institucijam: 'Till statliga institutioner',
            atskaites: 'Rapporter',
            merijumu_dati: 'Mätdata',
            skices: 'Skisser',
            cits: 'Övrigt'
          }
        },
        messages: {
          title: 'Meddelanden',
          subtitle: 'Aviseringar och meddelanden från administrationen',
          inboxTitle: 'Inkorg',
          emptyList: 'Inga meddelanden',
          emptyDetailTitle: 'Välj ett meddelande',
          emptyDetailText: 'Klicka på ett meddelande för att läsa det'
        },
        contact: {
          title: 'Kontakt',
          subtitlePrefix: 'Ställ en fråga eller',
          subtitleHighlight: 'kontakta oss',
          phoneLabel: 'Telefon',
          emailLabel: 'E‑post',
          hoursLabel: 'Arbetstid',
          formTitle: 'Skicka meddelande',
          subjectLabel: 'Ämne',
          subjectPlaceholder: 'Meddelandets ämne',
          messageLabel: 'Meddelande',
          messagePlaceholder: 'Din fråga eller ditt meddelande...',
          submit: 'Skicka',
          submitting: 'Skickar...',
          successTitle: 'Meddelande skickat!',
          successBody: 'Vi kontaktar dig.',
          toastSuccess: 'Meddelande skickat!',
          toastError: 'Fel vid sändning av meddelande'
        }
      },
      admin: {
        dashboard: {
          title: 'Administration',
          titleSuffix: 'panel',
          subtitlePrefix: 'Hantera',
          subtitleHighlight: 'kunder, arbeten och dokument',
          stats: {
            totalClients: 'Totalt antal kunder',
            totalJobs: 'Totalt antal arbeten',
            activeJobs: 'Aktiva arbeten',
            completedJobs: 'Avslutade'
          },
          quick: {
            clientsTitle: 'Hantera kunder',
            clientsDescription: 'Lägg till och redigera kunder',
            jobsTitle: 'Hantera arbeten',
            jobsDescription: 'Skapa och uppdatera arbeten',
            documentsTitle: 'Dokument',
            documentsDescription: 'Ladda upp dokument'
          },
          recentTitle: 'Senaste arbeten',
          viewAll: 'Visa alla',
          emptyJobs: 'Inga arbeten'
        },
        clients: {
          title: 'Kunder',
          subtitle: 'Hantera användare och åtkomsträttigheter',
          addButton: 'Lägg till kund',
          searchPlaceholder: 'Sök kunder...',
          table: {
            client: 'Kund',
            username: 'Användarnamn',
            contacts: 'Kontakter',
            role: 'Roll',
            status: 'Status',
            actions: 'Åtgärder'
          },
          roleAdmin: 'Admin',
          roleClient: 'Kund',
          statusActive: 'Aktiv',
          statusInactive: 'Inaktiv',
          confirmDelete: 'Är du säker på att du vill ta bort användaren "{name}"?',
          toastCreated: 'Användare skapad',
          toastUpdated: 'Användare uppdaterad',
          toastDeleted: 'Användare borttagen',
          toastDeleteError: 'Fel vid borttagning',
          toastError: 'Fel',
          passwordLengthError: 'Lösenord måste vara minst 12 tecken',
          modal: {
            addTitle: 'Lägg till kund',
            editTitle: 'Redigera användare',
            clientNameLabel: 'Kundnamn / företag',
            clientNamePlaceholder: 'AB Skogsägare',
            emailLabel: 'E‑post',
            phoneLabel: 'Telefon',
            usernameLabel: 'Användarnamn',
            usernamePlaceholder: 'anvandarnamn',
            passwordLabel: 'Lösenord *',
            passwordEditLabel: 'Nytt lösenord (valfritt)',
            passwordPlaceholder: 'Minst 12 tecken',
            roleLabel: 'Roll',
            cancel: 'Avbryt',
            create: 'Skapa',
            save: 'Spara'
          }
        },
        projects: {
          title: 'Projekthantering',
          subtitle: 'Hantera kundernas projekt och arbeten',
          addButton: 'Nytt projekt',
          searchPlaceholder: 'Sök projekt...',
          progressLabel: 'Framsteg',
          stats: {
            total: 'Totalt antal projekt',
            active: 'Aktiva',
            completed: 'Avslutade',
            totalJobs: 'Totalt antal arbeten'
          },
          jobsTotal: 'Totalt',
          jobsCompleted: 'Avslutade',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planerade',
          editButton: 'Redigera',
          deleteButton: 'Ta bort',
          emptyState: 'Inga projekt hittades',
          confirmDelete: 'Är du säker på att du vill ta bort detta projekt?',
          toastCreated: 'Projekt skapat',
          toastUpdated: 'Projekt uppdaterat',
          toastDeleted: 'Projekt borttaget',
          toastDeleteError: 'Det gick inte att ta bort projektet',
          toastError: 'Fel',
          toastLoadError: 'Det gick inte att ladda projekt',
          noClient: 'Ej angivet',
          modal: {
            addTitle: 'Nytt projekt',
            editTitle: 'Redigera projekt',
            nameLabel: 'Projektnamn',
            namePlaceholder: 'Lejasrunķi fastighet – Arbeten 2026',
            clientLabel: 'Kund',
            clientPlaceholder: 'Välj kund',
            propertyNameLabel: 'Fastighetsnamn',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Fastighetsbeteckning',
            addressLabel: 'Fastighetsadress',
            addressPlaceholder: 'Ropaži kommun',
            descriptionLabel: 'Beskrivning',
            descriptionPlaceholder: 'Detaljerad projektbeskrivning...',
            statusLabel: 'Status',
            nextStepLabel: 'Vad händer härnäst?',
            nextStepPlaceholder: 'Slutför uppmärkning av avverkningsområde',
            cancel: 'Avbryt',
            create: 'Skapa',
            save: 'Spara'
          }
        },
        jobs: {
          title: 'Arbeten',
          subtitle: 'Hantera arbeten och deras status',
          addButton: 'Lägg till arbete',
          searchPlaceholder: 'Sök arbeten...',
          filterAll: 'Alla',
          table: {
            job: 'Arbete',
            client: 'Kund',
            status: 'Status',
            dates: 'Datum',
            responsible: 'Ansvarig',
            actions: 'Åtgärder'
          },
          deadlineLabel: 'Till',
          confirmDelete: 'Är du säker på att du vill ta bort arbetet "{title}"?',
          unknownClient: 'Okänd',
          toastCreated: 'Arbete skapat',
          toastUpdated: 'Arbete uppdaterat',
          toastDeleted: 'Arbete borttaget',
          toastDeleteError: 'Fel',
          toastError: 'Fel',
          modal: {
            addTitle: 'Lägg till arbete',
            editTitle: 'Redigera arbete',
            titleLabel: 'Arbetsnamn',
            titlePlaceholder: 'Markering av stående träd',
            descriptionLabel: 'Beskrivning',
            descriptionPlaceholder: 'Arbetsbeskrivning...',
            clientLabel: 'Kund',
            clientPlaceholder: 'Välj kund',
            projectLabel: 'Projekt',
            projectPlaceholder: 'Välj projekt',
            projectPlaceholderEmpty: 'Välj kund först',
            statusLabel: 'Status',
            responsibleLabel: 'Ansvarig',
            responsiblePlaceholder: 'Anna Andersson',
            startDateLabel: 'Startdatum',
            endDateLabel: 'Planerat slutdatum',
            notesLabel: 'Anteckningar till kund',
            notesPlaceholder: 'Anteckningar som kunden kan se...',
            cancel: 'Avbryt',
            create: 'Skapa',
            save: 'Spara'
          }
        },
        bulkJob: {
          title: 'Lägg till flera arbeten till projekt',
          selectLabel: 'Välj arbetstyper:',
          selectAll: 'Välj alla',
          clearAll: 'Rensa',
          selectError: 'Välj minst en arbetstyp',
          selectedCount: 'Valda',
          selectedSuffix: 'arbetstyper',
          statusNote: 'Alla arbeten skapas med statusen ”Planerad”',
          cancel: 'Avbryt',
          creating: 'Skapar...',
          createCount: 'Skapa {count} arbeten',
          successTitle: 'Arbeten skapades!',
          error: 'Det gick inte att skapa arbeten',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Markering av stående träd' },
            { id: 'caurmera_merishana', label: 'Diameter­mätning' },
            { id: 'cirsmas_stigoshana', label: 'Uppmärkning av avverkningsområde' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Återställning av fastighetsgränser' },
            { id: 'robezzimju_atjaunoshana', label: 'Återställning av gränsmarkeringar' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Märkning av kvarstående träd vid selektiv avverkning' },
            { id: 'cirsmu_iezimeshana', label: 'Markering av avverkningsområde' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentationsförberedelse' },
            { id: 'es_projektu_sagatavoshana', label: 'EU-projektförberedelse' },
            { id: 'cits', label: 'Övrigt' }
          ]
        },
        audit: {
          title: 'Audit log',
          subtitle: 'Systemets aktivitetshistorik',
          emptyTitle: 'Inga audit log-poster',
          emptyBody: 'Aktivitetshistorik visas här'
        },
        visitors: {
          title: 'Besöksstatistik',
          subtitle: 'Besök på den publika webbplatsen',
          range7: '7 dagar',
          range30: '30 dagar',
          range7Short: '7 dagar',
          range30Short: '30 dagar',
          rangeOther: '{count} dagar',
          totalLabel: 'Totalt antal besök',
          uniqueLabel: 'Unika besökare',
          periodLabel: 'Period',
          dailyTitle: 'Dagliga besök',
          dailyEmpty: 'Inga data för vald period.',
          recentTitle: 'Senaste besök',
          recentEmpty: 'Inga besöksposter.',
          unknownRegion: 'Okänd region',
          visitNumber: 'Besök #{number}'
        },
        testimonials: {
          title: 'Omdömeshantering',
          subtitle: 'Godkänn eller dölj kundomdömen innan de visas på webbplatsen.',
          filters: {
            all: 'Alla',
            pending: 'Väntar på godkännande',
            approved: 'Publicerade',
            hidden: 'Dolda'
          },
          loading: 'Laddar omdömen...',
          empty: 'Inga omdömen för valt filter.',
          average: 'Genomsnitt {rating}/5',
          speed: 'Hastighet',
          quality: 'Kvalitet',
          communication: 'Kommunikation',
          responsiveness: 'Respons',
          publish: 'Publicera',
          hide: 'Dölj',
          returnToPending: 'Åter till väntande'
        },
        payroll: {
          title: 'Löneberäkning',
          subtitle: 'Månadsvis löneberäkning för medarbetare',
          addEntry: 'Lägg till post',
          export: 'Exportera XLSX',
          confirmDelete: 'Vill du ta bort den här posten?',
          toastCreated: 'Post sparad',
          toastUpdated: 'Post uppdaterad',
          toastDeleted: 'Post borttagen',
          toastDeleteError: 'Det gick inte att ta bort posten',
          toastError: 'Det gick inte att spara posten',
          validation: {
            employee: 'Välj en medarbetare',
            workTypes: 'Välj minst en arbetstyp'
          },
          filters: {
            month: 'Månad',
            year: 'År',
            employee: 'Medarbetare',
            client: 'Kund',
            status: 'Faktura',
            statusAll: 'Alla',
            statusPaid: 'Betald',
            statusUnpaid: 'Obetald'
          },
          summary: {
            totalSalary: 'Totalt bruttolön',
            totalCosts: 'Totala kostnader',
            fuelCost: 'Bränsle',
            paintCost: 'Färg'
          },
          table: {
            title: 'Löneposter',
            date: 'Datum',
            employee: 'Medarbetare',
            client: 'Kund',
            property: 'Fastighet',
            workTypes: 'Arbetstyper',
            salary: 'Brutto',
            costs: 'Kostnader',
            paid: 'Betald',
            actions: 'Åtgärder',
            edit: 'Redigera',
            delete: 'Ta bort'
          },
          empty: {
            title: 'Inga löneposter',
            body: 'Det finns inga poster för vald period.'
          },
          form: {
            addTitle: 'Ny lönepost',
            editTitle: 'Redigera lönepost',
            date: 'Datum',
            employee: 'Medarbetare',
            client: 'Kund (valfritt)',
            propertyName: 'Fastighetsnamn',
            cadastralNumber: 'Fastighetsbeteckning',
            kilometers: 'Körda kilometer',
            paintCans: 'Färgburkar (st)',
            fuelRate: 'Bränslepris (€/km)',
            paintPrice: 'Pris per färgburk (€/st)',
            workTypes: 'Arbetstyper',
            amount: 'Omfattning',
            rate: 'Pris',
            notes: 'Anteckningar',
            customRateNote: 'Pris anges manuellt',
            invoicePaid: 'Betalning mottagen',
            save: 'Spara',
            cancel: 'Avbryt'
          },
          totals: {
            salary: 'Bruttolön',
            costs: 'Företagskostnader',
            fuel: 'Bränslekostnad',
            paint: 'Färgkostnad'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Trädmärkning',
            cirsmas_stigoshana: 'Uppmärkning av avverkningsområde',
            caurmera_merishana: 'Diameter­mätning',
            paliekoso_koku_izzimeshana: 'Märkning av kvarstående träd',
            cirsmu_iezimeshana: 'Markering av avverkningsområde',
            ipashuma_robezu_atjaunoshana: 'Gränsåterställning',
            robezzimju_atjaunoshana: 'Återställning av gränsmarkeringar'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'st'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projekt hittades inte',
          back: 'Tillbaka',
          propertyLabel: 'Fastighet:',
          cadastralLabel: 'Fastighet:',
          addressLabel: 'Adress:',
          progressLabel: 'Övergripande framsteg',
          jobsTotal: 'Totalt antal arbeten',
          jobsCompleted: 'Avslutade',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planerade',
          nextStepTitle: 'Vad händer härnäst?',
          jobsTitle: 'Projektarbeten',
          bulkAddJobs: 'Lägg till flera arbeten',
          deadlineLabel: 'Deadline',
          lastUpdateLabel: 'Senaste ändring:',
          emptyJobs: 'Inga arbeten har lagts till i detta projekt ännu'
        }
      }
    }
  },
  fi: {
    languageLabel: 'FI',
    company: {
      slogan: 'Kestävä metsänhoito'
    },
    heroBadge: 'Riippumattomat metsätalouden palvelut',
    hero: {
      title: 'Riippumaton hakkuualueen arviointi metsänomistajille',
      subtitle: 'Autamme metsänomistajia arvioimaan hakkuualueen arvon tarkasti ja valmistelemaan metsän hakkuuseen tarjoamalla ammattimaisia mittauksia ja kaiken tarvittavan dokumentaation.',
      description: 'Toimimme vain metsänomistajan edun mukaisesti – emme osta hakkuualueita emmekä ole sidoksissa puun ostajiin.',
      workIntro: 'Mitä teemme',
      workItems: [
        'Kasvavien puiden merkintä',
        'Läpimitan mittaus',
        'Hakkuualueen rajaus',
        'Kiinteistön rajojen ja rajamerkkien palautus',
        'Dokumentaation valmistelu ja toimittaminen viranomaisille'
      ],
      workNote: 'Täydellinen työlista löytyy osiosta ”Työt”.',
      reasonsTitle: 'Miksi valita meidät',
      reasons: [
        'Tarkat metsämitat',
        'Riippumaton hakkuualueen arviointi',
        'Asianmukainen dokumentaatio',
        'Täysi prosessin läpinäkyvyys'
      ],
      closing: 'Asiakkaat voivat seurata työn etenemistä verkossa mistä tahansa.',
      tagline: 'Ota yhteyttä saadaksesi ammattimaisen palvelun!',
      ctaPrimary: 'Pyydä hakkuualueen arviointi',
      ctaSecondary: 'Asiakasportaali',
      salesHighlights: [
        'Riippumaton arvio',
        'Tarkat mittaukset',
        'Täysi dokumentaatio',
        'Täysi läpinäkyvyys'
      ],
      calloutTitle: 'Sila Meži ‑takuu',
      calloutBody: 'Tarkat mittaukset. Asianmukainen dokumentaatio. Täysi läpinäkyvyys.',
      workLink: 'Katso työt',
      scrollHint: 'Vieritä alas',
      subtitleHighlight: 'arvioimaan hakkuualueen arvon tarkasti',
      descriptionHighlight: 'emme osta hakkuualueita emmekä ole sidoksissa puun ostajiin.'
    },
    trustBadges: [
      { id: 1, title: 'Tarkat metsämitat', description: 'Yksityiskohtaiset kenttämittaukset ja analyysi' },
      { id: 2, title: 'Riippumaton hakkuualueen arviointi', description: 'Ei intressiä puun ostossa' },
      { id: 3, title: 'Asianmukainen dokumentaatio', description: 'Täysi tuki valmisteluun ja toimitukseen' },
      { id: 4, title: 'Täysi läpinäkyvyys', description: 'Asiakkaat seuraavat töitä verkossa' }
    ],
    services: {
      eyebrow: 'Palvelumme',
      title: 'Ammattimaiset metsätalouden palvelut metsänomistajille',
      description: 'Tarjoamme kattavan valikoiman metsätalouden palveluita — metsän arvioinnista ja mittauksista dokumentointiin, projektinhallintaan ja metsätöiden järjestämiseen.',
      mission: 'Tavoitteemme on auttaa metsänomistajia tekemään perusteltuja päätöksiä tarjoamalla tarkkaa tietoa, ammattimaista lähestymistapaa ja täyden prosessituen.',
      ctaQuestion: 'Etkö ole varma, mitä palvelua tarvitset?',
      ctaLink: 'Ota yhteyttä ilmaiseen konsultaatioon'
    },
    servicesList: [
      {
        id: 1,
        category: 'Metsän ja hakkuualueen arviointi',
        description: 'Teemme kasvavien puiden ja hakkuualueiden ammattimaista arviointia yksityiskohtaisten kenttämittausten, ajankohtaisten markkinahintojen ja voimassa olevien säädösten perusteella. Arviointi tehdään riippumattomasti puun ostosta, mikä varmistaa objektiivisen ja luotettavan tiedon metsänomistajalle.',
        items: [
          'Kasvavien puiden merkintä',
          'Puiden läpimitan ja muiden parametrien mittaus',
          'Hakkuualueen arvon laskenta ja analyysi'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Metsämittaukset ja rajatyöt',
        description: 'Tarjoamme erilaisia metsämittoja ja kiinteistön rajojen tarkentamista maastossa. Kaikki työt tehdään kiinteistörekisteritietojen ja voimassa olevien säädösten mukaisesti. Tarkat mittaukset auttavat välttämään rajariitoja ja varmistavat asianmukaisen metsänhoidon.',
        items: [
          'Hakkuualueen rajaus',
          'Kiinteistön rajojen palautus maastossa',
          'Rajamerkkien asennus ja palautus'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Metsän uudistaminen ja taimikonhoito',
        description: 'Autamme metsänomistajia varmistamaan kestävän metsän kehityksen järjestämällä uudistamis- ja taimikonhoitotöitä. Oikea hoito varhaisissa kehitysvaiheissa vaikuttaa merkittävästi metsän laatuun ja tulevaan arvoon.',
        items: [
          'Metsänuudistustöiden järjestäminen',
          'Istutustöiden suunnittelu ja koordinointi',
          'Taimikonhoitotöiden järjestäminen'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentointi ja hyväksynnät',
        description: 'Valmistelemme ja toimitamme kaiken tarvittavan dokumentaation Metsähallitukselle ja muille viranomaisille. Tarjoamme täydellisen hallinnollisen tuen koko prosessin ajan, jotta metsänomistajat välttyvät monimutkaiselta byrokratialta.',
        items: [
          'Dokumenttien valmistelu valtion viranomaisille',
          'Hakemusten valmistelu ja toimittaminen',
          'Täysi hallinnollinen prosessituki'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'EU‑tukiprojektit',
        description: 'Neuvomme metsänomistajia EU:n tukimahdollisuuksista metsätaloudessa. Tarjoamme koko projektin valmistelun ja hallinnoinnin — ideasta toteutukseen.',
        items: [
          'Neuvonta EU‑tukivaihtoehdoista',
          'Projektidokumentaation valmistelu',
          'Projektien jättäminen ja seuranta'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Työt',
      title: 'Työt',
      description: 'Valitse kiinnostavat työt, ja laadimme tarkan hintatarjouksen. Valintasi lisätään automaattisesti pyyntölomakkeeseen.',
      summaryTitle: 'Valitut työt',
      summaryEmpty: 'Ei valittuja töitä. Valitse palvelu yllä olevasta listasta.',
      requestCta: 'Pyydä hintatarjous',
      contactCta: 'Ota yhteyttä',
      selectError: 'Valitse vähintään yksi työ saadaksesi hinnan.',
      itemSelected: 'Lisätty hintapyyntöön',
      itemAdd: 'Merkitse hintapyyntöä varten'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Metsätyöt',
        description: 'Tarkat kenttätyöt ja hakkuualueen valmistelu turvalliseen ja asianmukaiseen metsänhoitoon.',
        items: [
          'Hakkuualueen rajaus',
          'Puiden merkintä',
          'Kasvavien puiden oksinta'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Metsän uudistaminen ja hoito',
        description: 'Kestävän metsän kehityksen varmistaminen tavoitteellisilla uudistamistöillä.',
        items: [
          'Metsän uudistaminen',
          'Taimikonhoito',
          'Taimikon suojaus eläinvahingoilta'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Metsäkiinteistöjen hallinta',
        description: 'Koko elinkaaren metsäkiinteistöjen hallinta ja töiden koordinointi suunnittelusta toteutukseen.',
        items: ['Metsäkiinteistöjen hallinta']
      },
      {
        id: 'es',
        title: 'EU‑projektien valmistelu',
        description: 'Neuvonta, dokumentointi ja projektien seuranta EU‑tukiohjelmissa.',
        items: ['Projektien jättäminen ja seuranta']
      }
    ],
    process: {
      eyebrow: 'Yhteistyöprosessi',
      title: 'Näin yhteistyö etenee',
      description: 'Selkeä ja läpinäkyvä prosessi pyynnöstä valmiiksi.',
      steps: [
        { id: 1, title: 'Pyyntö', description: 'Asiakas ottaa yhteyttä tilatakseen arvion tai muun palvelun.' },
        { id: 2, title: 'Kiinteistön katselmus', description: 'Vierailemme kiinteistöllä ja teemme tarvittavat kenttätyöt.' },
        { id: 3, title: 'Mittaukset ja arviointi', description: 'Mittaamme metsän tarkasti ja laadimme objektiivisen arvion.' },
        { id: 4, title: 'Dokumentointi', description: 'Laadimme ja toimitamme tarvittavat asiakirjat valtion viranomaisille.' },
        { id: 5, title: 'Seuranta verkossa', description: 'Asiakas voi seurata työn etenemistä asiakasportaalissa.' },
        { id: 6, title: 'Loppuraportti', description: 'Toimitamme selkeän raportin tehdyistä töistä ja tuloksista.' }
      ]
    },
    portal: {
      eyebrow: 'Digitaalinen alusta',
      title: 'Digitaalinen alusta – Asiakasportaali',
      description: 'Tarjoamme asiakkaillemme kätevän ja turvallisen verkkopohjaisen portaalin, joka antaa jatkuvan pääsyn projektin ja työn etenemiseen. Portaalissa voi tarkastella päivityksiä, seurata tiloja ja löytää kaikki projektiin liittyvät asiakirjat yhdessä paikassa.',
      subtitle: 'Alusta on suunniteltu maksimaaliseen läpinäkyvyyteen ja sujuvaan viestintään tiimimme kanssa. Asiakkaat näkevät tilanteen milloin tahansa ilman erillistä yhteydenottoa. Portaali toimii sekä tietokoneella että mobiilissa, joten tiedot ovat saatavilla kaikkialla.',
      featuresTitle: 'Keskeiset ominaisuudet',
      features: [
        { id: 1, title: 'Työn tila', description: 'Seuraa projektin etenemistä reaaliajassa – suunniteltu, käynnissä tai valmis.', icon: 'Activity' },
        { id: 2, title: 'Asiakirjojen saatavuus', description: 'Kaikki projektin asiakirjat yhdessä paikassa, valmiina katsottavaksi ja ladattavaksi.', icon: 'FolderOpen' },
        { id: 3, title: 'Ilmoitukset', description: 'Saat tiedot etenemisestä, muutoksista ja tärkeistä ilmoituksista.', icon: 'Bell' },
        { id: 4, title: 'Saatavilla kaikkialla', description: 'Toimii tietokoneella ja mobiilissa – helppo pääsy missä tahansa.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Kirjaudu portaaliin',
      ctaRequest: 'Pyydä käyttöoikeutta',
      preview: {
        headerTitle: 'Omat projektit',
        headerActive: '3 aktiivista',
        items: [
          { title: 'Hakkuualueen arviointi #127', status: 'Valmis', tone: 'success' },
          { title: 'Metsämittaus', status: 'Käynnissä', tone: 'warning' },
          { title: 'Dokumentointi metsäpalvelulle', status: 'Suunniteltu', tone: 'info' }
        ],
        footerLeft: 'Viimeisin aktiviteetti: tänään',
        footerRight: '2 uutta asiakirjaa'
      }
    },
    why: {
      title: 'Miksi valita riippumaton arviointi',
      description: 'Potentiaalisen ostajan tekemä arviointi sisältää aina eturistiriidan. Riippumaton arviointi tarjoaa objektiivisen näkemyksen todellisesta arvosta ja auttaa metsänomistajaa tekemään perusteltuja päätöksiä.',
      conclusion: 'Riippumaton arviointi auttaa usein välttämään epäedullisia kauppoja ja antaa selkeän kuvan metsänomaisuuden potentiaalista.',
      stats: [
        { value: '15–30%', label: 'Mahdollinen tulon ero' },
        { value: '100%', label: 'Objektiivinen arvio' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Miksi ostaja ei ole objektiivinen arvioija?',
        content: 'Ostajalla on taloudellinen intressi ostaa metsä mahdollisimman edullisesti, mikä aiheuttaa eturistiriidan. Riippumaton arvioija toimii vain sinun eduksesi.'
      },
      {
        id: 2,
        title: 'Miten riippumaton arviointi vaikuttaa tuloihin?',
        content: 'Tarkka ja riippumaton arviointi auttaa määrittämään todellisen arvon ja saavuttamaan reilun hinnan neuvotteluissa. Monet metsänomistajat ovat saaneet 15–30% korkeampia hintoja riippumattoman arvioinnin avulla.'
      },
      {
        id: 3,
        title: 'Yleisimmät virheet',
        content: 'Riittämätön tieto puumääristä, pelkästään ostajan arvioon luottaminen, puutteellinen dokumentaatio ja markkinahintojen tuntemattomuus – nämä virheet pienentävät metsänomistajan tuloja.'
      }
    ],
    about: {
      title: 'Yrityksestä',
      subtitle: 'Kokemus metsätaloudessa',
      description: 'Olemme metsätalouden palveluntarjoaja, joka on erikoistunut riippumattomaan hakkuualueen arviointiin ja tarkkoihin metsämittoihin. Toimimme säädösten mukaisesti ja tiiviissä yhteistyössä valtion viranomaisten kanssa.',
      mission: 'Tavoitteemme on tarjota metsänomistajille oikea, läpinäkyvä ja ammattimainen palvelu koko yhteistyön ajan.',
      points: [
        'Erikoistuneet riippumattomaan hakkuualueen arviointiin',
        'Tarkat metsämitat säädösten mukaisesti',
        'Tiivis yhteistyö valtion metsäviranomaisten kanssa',
        'Täysi dokumentointituki',
        'Teemme yhteistyötä sekä yksityishenkilöiden että juridisten toimijoiden kanssa'
      ],
      regionsLabel: 'Toiminta-alueet',
      regions: ['Riika ja ympäristö', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Kestävä metsänhoito',
      sustainabilityText: 'Autamme metsänomistajia säilyttämään metsän arvon tuleville sukupolville noudattamalla kestävän hoidon periaatteita ja säädöksiä.',
      testimonialsEyebrow: 'Suositukset',
      testimonialsTitle: 'Mitä asiakkaamme sanovat',
      testimonialsDescription: 'Aitoja kokemuksia ja palautetta yhteistyöstämme.',
      testimonialsAdd: 'Lisää suositus',
      testimonialsLoading: 'Ladataan suosituksia...',
      testimonialsEmpty: 'Ei suosituksia vielä. Ole ensimmäinen, joka jakaa kokemuksensa!',
      testimonialsModalTitle: 'Lisää suositus',
      form: {
        nameLabel: 'Nimi tai yritys',
        regionLabel: 'Alue',
        ratingLabel: 'Arvio',
        speedLabel: 'Nopeus',
        qualityLabel: 'Laatu',
        communicationLabel: 'Viestintä',
        responsivenessLabel: 'Vastauksen nopeus',
        textLabel: 'Suositusteksti',
        cancel: 'Peruuta',
        submit: 'Lähetä suositus',
        sending: 'Lähetetään...',
        success: 'Suositus lähetettiin hyväksyttäväksi',
        error: 'Suosituksen lähetys epäonnistui. Yritä uudelleen.'
      },
      metrics: {
        speed: 'Nopeus',
        quality: 'Laatu',
        communication: 'Viestintä',
        responsiveness: 'Vastauksen nopeus'
      }
    },
    contact: {
      eyebrow: 'Ota yhteyttä',
      title: 'Yhteystiedot',
      description: 'Ota yhteyttä palvelun tilaamiseksi tai saadaksesi neuvontaa metsänomistuksestasi.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Metsätalousasiantuntija',
      formNote: 'Täytä lomake, niin otamme sinuun yhteyttä.',
      infoTitle: 'Yhteystiedot',
      phoneLabel: 'Puhelin',
      emailLabel: 'Sähköposti',
      addressLabel: 'Yrityksen osoite',
      hoursLabel: 'Aukioloajat',
      freeConsultationTitle: 'Maksuton konsultaatio',
      freeConsultationText: 'Ensimmäinen keskustelu ja tilanteen arviointi ovat maksuttomia. Ota yhteyttä ja löydämme yhdessä parhaan ratkaisun.',
      formTitle: 'Yhteydenottolomake',
      successTitle: 'Kiitos yhteydenotosta!',
      successBody: 'Otamme sinuun yhteyttä pian.',
      formNameLabel: 'Etunimi ja sukunimi',
      formNamePlaceholder: 'Matti Meikäläinen',
      formPhoneLabel: 'Puhelinnumero',
      formPhonePlaceholder: '+358 40 123 4567',
      formEmailLabel: 'Sähköpostiosoite',
      formEmailPlaceholder: 'matti@example.com',
      formMessageLabel: 'Viesti',
      formMessagePlaceholder: 'Kysymyksesi tai tilanteen kuvaus...',
      formConsent: 'Lähettämällä lomakkeen hyväksyt henkilötietojen käsittelyn GDPR:n mukaisesti.',
      formSubmitting: 'Lähetetään...',
      formSubmit: 'Lähetä pyyntö',
      toastSavedTitle: 'Pyyntö tallennettu',
      toastSavedBody: 'Sähköpostin toimitus vaatii vahvistetun verkkotunnuksen. Viesti näkyy admin‑portaalissa.',
      toastSentTitle: 'Pyyntö lähetetty!',
      toastSentBody: 'Otamme sinuun yhteyttä pian.',
      toastErrorTitle: 'Virhe pyyntöä lähetettäessä',
      submitError: 'Virhe pyyntöä lähetettäessä. Yritä uudelleen.',
      prefillLabel: 'Haluan hinnan seuraaville palveluille'
    },
    cookie: {
      text: 'Tämä sivusto käyttää evästeitä käyttökokemuksen parantamiseksi.',
      accept: 'Hyväksyn'
    },
    privacy: {
      badge: 'Tietosuojakäytäntö',
      title: 'Sila Meži tietosuojakäytäntö',
      intro: 'Pidämme huolta tietoturvastasi ja yksityisyydestäsi. Tässä käytännössä kerromme, mitä tietoja käsittelemme ja miksi.',
      controllerTitle: 'Rekisterinpitäjä',
      controllerRegLabel: 'Rek. nro:',
      controllerAddressLabel: 'Osoite:',
      controllerEmailLabel: 'Sähköposti tietokysymyksille:',
      dataTitle: 'Mitä tietoja käsitellään',
      dataItemContact: 'Yhteydenottolomakkeen tiedot (nimi, sähköposti, puhelin, viesti).',
      dataItemVisits: 'Vierailujen seuranta evästehyväksynnän jälkeen (IP‑osoite, alue, vierailun aika).',
      dataItemEmail: 'Sähköpostien toimitustiedot Resend‑palvelun kautta.',
      visitsTitle: 'Vierailujen seuranta',
      visitsText: 'Vierailuja seurataan vain evästehyväksynnän jälkeen. Alueen määrittämiseen käytämme IPinfoa.',
      cookiesTitle: 'Evästeet',
      cookiesText: 'Tämä sivusto käyttää välttämättömiä, toiminnallisia ja tilastollisia evästeitä toiminnan varmistamiseksi, kokemuksen parantamiseksi ja kävijätrendien ymmärtämiseksi.',
      retentionTitle: 'Tietojen säilytys ja oikeudet',
      retentionText: 'Tietoja säilytetään niin kauan kuin palvelun tuottamiseen tarvitaan tai lain edellyttämällä tavalla. Voit pyytää tietojen oikaisua tai poistamista kirjoittamalla yllä olevaan sähköpostiosoitteeseen.',
      thirdPartyTitle: 'Kolmannen osapuolen palvelut',
      thirdPartyText: 'Alueen määrittämiseen käytämme IPinfoa, sähköpostin toimitukseen Resendia. Kolmannet osapuolet käsittelevät tietoja omien tietosuojakäytäntöjensä mukaisesti.'
    },
    footer: {
      companyDescription: 'Riippumaton hakkuualueen arviointi ja metsätalouden palvelut kaikkialla Latviassa. Toimimme vain metsänomistajan edun mukaisesti.',
      companyNote: 'Teemme yhteistyötä sekä yksityishenkilöiden että juridisten toimijoiden kanssa.',
      navigationTitle: 'Navigointi',
      servicesTitle: 'Palvelut',
      contactTitle: 'Yhteystiedot',
      quickLinks: {
        home: 'Etusivu',
        services: 'Palvelut',
        process: 'Miten se toimii',
        portal: 'Asiakasportaali',
        why: 'Miksi riippumaton arvio',
        about: 'Meistä',
        contact: 'Yhteystiedot'
      },
      services: {
        assessment: 'Hakkuualueen arviointi',
        measurements: 'Metsämitat',
        documentation: 'Dokumentointi',
        euProjects: 'EU‑projektit'
      },
      rights: 'Kaikki oikeudet pidätetään.',
      privacy: 'Tietosuojakäytäntö',
      terms: 'Käyttöehdot'
    },
    nav: {
      home: 'Etusivu',
      services: 'Palvelut',
      works: 'Työt',
      process: 'Prosessi',
      why: 'Miksi me',
      about: 'Tietoa',
      contact: 'Yhteystiedot',
      portal: 'Asiakasportaali',
      consult: 'Pyydä',
      consultMobile: 'Varaa konsultaatio'
    },
    portalUi: {
      common: { loading: 'Ladataan...' },
      status: {
        planned: 'Suunniteltu',
        inProgress: 'Käynnissä',
        completed: 'Valmis',
        active: 'Aktiivinen',
        onHold: 'Tauolla',
        awaitingInfo: 'Odottaa tietoja',
        submitted: 'Toimitettu'
      },
      nav: {
        client: {
          dashboard: 'Yleiskatsaus',
          projects: 'Projektit',
          jobs: 'Työt',
          documents: 'Asiakirjat',
          messages: 'Viestit',
          contact: 'Yhteystiedot'
        },
        admin: {
          dashboard: 'Yleiskatsaus',
          clients: 'Asiakkaat',
          projects: 'Projektit',
          jobs: 'Työt',
          documents: 'Asiakirjat',
          messages: 'Ilmoitukset',
          visitors: 'Vierailut',
          testimonials: 'Suositukset',
          audit: 'Audit‑lokit',
          payroll: 'Palkanlaskenta'
        }
      },
      layout: {
        portalLabel: 'Asiakasportaali',
        roleAdmin: 'Ylläpitäjä',
        roleClient: 'Asiakas',
        logout: 'Kirjaudu ulos'
      },
      login: {
        portalLabel: 'Asiakasportaali',
        title: 'Kirjaudu asiakasportaaliin',
        description: 'Täällä voit seurata työn tilaa, asiakirjoja ja raportteja omasta kiinteistöstäsi.',
        usernameLabel: 'Käyttäjätunnus',
        usernamePlaceholder: 'Anna käyttäjätunnus',
        passwordLabel: 'Salasana',
        passwordPlaceholder: 'Anna salasana',
        togglePassword: 'Näytä salasana',
        submit: 'Kirjaudu',
        submitting: 'Kirjaudutaan...',
        forgotText: 'Unohditko salasanan?',
        contactAdmin: 'Ota yhteyttä ylläpitäjään',
        securityTitle: 'Tietoturvailmoitus',
        securityText: 'Pääsy vain valtuutetuille asiakkaille. Ota yhteyttä saadaksesi pääsyn:',
        backToSite: 'Takaisin etusivulle',
        successToast: 'Kirjautuminen onnistui!',
        errorFallback: 'Kirjautumisvirhe'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Ei käyttöoikeutta',
        description: 'Sinulla ei ole oikeutta tähän osioon.',
        detail: 'Jos tämä on virhe, ota yhteyttä ylläpitäjään.',
        backToPanel: 'Takaisin näkymään',
        home: 'Etusivu'
      },
      documents: {
        title: 'Lisää asiakirja projektiin',
        fileRequired: 'Valitse tiedosto',
        uploadSuccess: 'Tiedosto ladattu',
        uploadError: 'Latausvirhe',
        fileLabel: 'Tiedosto',
        fileInstruction: 'Napsauta valitaksesi tiedoston',
        fileFormats: 'PDF, Excel, Word, Kuvat',
        categoryLabel: 'Asiakirjan tyyppi',
        categories: [
          { value: 'skice', label: 'Luonnos' },
          { value: 'iesniegums', label: 'Hakemus' },
          { value: 'ligums', label: 'Sopimus' },
          { value: 'atskaite', label: 'Raportti' },
          { value: 'foto', label: 'Kuva' },
          { value: 'cits', label: 'Muu' }
        ],
        visibleLabel: 'Näkyy asiakkaalle',
        visibleHint: 'Asiakas voi nähdä ja ladata tämän asiakirjan',
        upload: 'Lataa',
        uploading: 'Ladataan...',
        cancel: 'Peruuta'
      },
      client: {
        dashboard: {
          greeting: 'Tervetuloa',
          subtitle: 'Sinun',
          subtitleHighlight: 'asiakasportaalin yleiskatsaus',
          stats: {
            totalJobs: 'Töitä yhteensä',
            activeJobs: 'Aktiiviset työt',
            completedJobs: 'Valmiit',
            newMessages: 'Uudet viestit'
          },
          lastUpdate: 'Viimeisin päivitys:',
          actions: {
            jobsTitle: 'Näytä kaikki työt',
            jobsDescription: 'Tarkastele työn tiloja ja yksityiskohtia',
            documentsTitle: 'Asiakirjat',
            documentsDescription: 'Katso ja lataa tiedostoja'
          },
          recentTitle: 'Viimeisimmät työt',
          viewAll: 'Näytä kaikki',
          responsibleLabel: 'Vastuuhenkilö',
          emptyJobs: 'Ei töitä vielä'
        },
        projects: {
          title: 'Omat projektit',
          subtitlePrefix: 'Sinun',
          subtitleHighlight: 'metsäprojektisi',
          subtitleSuffix: 'ja niiden edistyminen',
          cadastralLabel: 'Kiinteistötunnus:',
          progressLabel: 'Kokonaisprogressi',
          jobsTotal: 'Yhteensä',
          jobsCompleted: 'Valmiit',
          jobsInProgress: 'Käynnissä',
          jobsPlanned: 'Suunnitellut',
          nextStepTitle: 'Mitä seuraavaksi?',
          viewDetails: 'Katso tiedot',
          emptyTitle: 'Ei projekteja',
          emptySubtitle: 'Projektit näkyvät täällä, kun ylläpitäjä luo ne.'
        },
        jobs: {
          title: 'Työt',
          subtitlePrefix: 'Tarkastele töitäsi ja niiden',
          subtitleHighlight: 'tiloja',
          searchPlaceholder: 'Hae töitä...',
          filterAll: 'Kaikki',
          filterPlanned: 'Suunnitellut',
          filterInProgress: 'Käynnissä',
          filterCompleted: 'Valmiit',
          deadlineLabel: 'Määräaika',
          emptyTitle: 'Töitä ei löytynyt',
          emptyFiltered: 'Kokeile muuttaa hakuehtoja',
          emptyAll: 'Töitä ei ole vielä lisätty'
        },
        jobDetail: {
          backToJobs: 'Takaisin töihin',
          notFoundTitle: 'Työtä ei löytynyt',
          infoTitle: 'Työn tiedot',
          responsibleLabel: 'Vastuuhenkilö',
          startDateLabel: 'Aloituspäivä',
          plannedEndLabel: 'Suunniteltu päättymispäivä',
          completedLabel: 'Valmis',
          notesTitle: 'Huomiot',
          documentsTitle: 'Liitetyt asiakirjat',
          documentsEmpty: 'Ei liitettyjä asiakirjoja',
          downloadError: 'Asiakirjan lataus epäonnistui',
          timelineTitle: 'Tilahistoria',
          timelineEmpty: 'Ei historiatietoja'
        },
        documents: {
          title: 'Asiakirjat',
          subtitlePrefix: 'Katso ja lataa',
          subtitleHighlight: 'asiakirjasi',
          searchPlaceholder: 'Hae asiakirjoja, projekteja tai tekijöitä...',
          filterAll: 'Kaikki',
          allProjects: 'Kaikki projektit',
          allUploaders: 'Kaikki tekijät',
          sortNewest: 'Uusimmat ensin',
          sortOldest: 'Vanhimmat ensin',
          latestOnly: 'Vain uusimmat versiot',
          download: 'Lataa',
          downloadError: 'Asiakirjan lataus epäonnistui',
          emptyTitle: 'Ei asiakirjoja',
          emptyNoDocuments: 'Asiakirjoja ei ole vielä.',
          emptyFiltered: 'Valituilla suodattimilla ei löytynyt asiakirjoja.',
          versionLabel: 'Versio',
          categoryOther: 'Muu',
          categories: {
            valsts_institucijam: 'Valtion viranomaisille',
            atskaites: 'Raportit',
            merijumu_dati: 'Mittausdata',
            skices: 'Luonnokset',
            cits: 'Muu'
          }
        },
        messages: {
          title: 'Viestit',
          subtitle: 'Ilmoitukset ja viestit hallinnolta',
          inboxTitle: 'Saapuneet',
          emptyList: 'Ei viestejä',
          emptyDetailTitle: 'Valitse viesti',
          emptyDetailText: 'Napsauta viestiä lukeaksesi sen'
        },
        contact: {
          title: 'Yhteystiedot',
          subtitlePrefix: 'Esitä kysymys tai',
          subtitleHighlight: 'ota yhteyttä',
          phoneLabel: 'Puhelin',
          emailLabel: 'Sähköposti',
          hoursLabel: 'Aukioloajat',
          formTitle: 'Lähetä viesti',
          subjectLabel: 'Aihe',
          subjectPlaceholder: 'Viestin aihe',
          messageLabel: 'Viesti',
          messagePlaceholder: 'Kysymyksesi tai viestisi...',
          submit: 'Lähetä',
          submitting: 'Lähetetään...',
          successTitle: 'Viesti lähetetty!',
          successBody: 'Otamme sinuun yhteyttä.',
          toastSuccess: 'Viesti lähetetty!',
          toastError: 'Virhe viestin lähetyksessä'
        }
      },
      admin: {
        dashboard: {
          title: 'Hallinto',
          titleSuffix: 'paneeli',
          subtitlePrefix: 'Hallitse',
          subtitleHighlight: 'asiakkaita, töitä ja asiakirjoja',
          stats: {
            totalClients: 'Asiakkaita yhteensä',
            totalJobs: 'Töitä yhteensä',
            activeJobs: 'Aktiiviset työt',
            completedJobs: 'Valmiit'
          },
          quick: {
            clientsTitle: 'Hallitse asiakkaita',
            clientsDescription: 'Lisää ja muokkaa asiakkaita',
            jobsTitle: 'Hallitse töitä',
            jobsDescription: 'Luo ja päivitä töitä',
            documentsTitle: 'Asiakirjat',
            documentsDescription: 'Lataa asiakirjoja'
          },
          recentTitle: 'Viimeisimmät työt',
          viewAll: 'Näytä kaikki',
          emptyJobs: 'Ei töitä'
        },
        clients: {
          title: 'Asiakkaat',
          subtitle: 'Hallitse käyttäjiä ja käyttöoikeuksia',
          addButton: 'Lisää asiakas',
          searchPlaceholder: 'Hae asiakkaita...',
          table: {
            client: 'Asiakas',
            username: 'Käyttäjätunnus',
            contacts: 'Yhteystiedot',
            role: 'Rooli',
            status: 'Tila',
            actions: 'Toiminnot'
          },
          roleAdmin: 'Ylläpitäjä',
          roleClient: 'Asiakas',
          statusActive: 'Aktiivinen',
          statusInactive: 'Ei aktiivinen',
          confirmDelete: 'Haluatko varmasti poistaa käyttäjän "{name}"?',
          toastCreated: 'Käyttäjä luotu',
          toastUpdated: 'Käyttäjä päivitetty',
          toastDeleted: 'Käyttäjä poistettu',
          toastDeleteError: 'Poistovirhe',
          toastError: 'Virhe',
          passwordLengthError: 'Salasanan on oltava vähintään 12 merkkiä',
          modal: {
            addTitle: 'Lisää asiakas',
            editTitle: 'Muokkaa käyttäjää',
            clientNameLabel: 'Asiakkaan nimi / yritys',
            clientNamePlaceholder: 'Oy Metsänomistaja',
            emailLabel: 'Sähköposti',
            phoneLabel: 'Puhelin',
            usernameLabel: 'Käyttäjätunnus',
            usernamePlaceholder: 'kayttaja',
            passwordLabel: 'Salasana *',
            passwordEditLabel: 'Uusi salasana (valinnainen)',
            passwordPlaceholder: 'Vähintään 12 merkkiä',
            roleLabel: 'Rooli',
            cancel: 'Peruuta',
            create: 'Luo',
            save: 'Tallenna'
          }
        },
        projects: {
          title: 'Projektien hallinta',
          subtitle: 'Hallitse asiakkaiden projekteja ja töitä',
          addButton: 'Uusi projekti',
          searchPlaceholder: 'Hae projekteja...',
          progressLabel: 'Edistyminen',
          stats: {
            total: 'Projekteja yhteensä',
            active: 'Aktiiviset',
            completed: 'Valmiit',
            totalJobs: 'Töitä yhteensä'
          },
          jobsTotal: 'Yhteensä',
          jobsCompleted: 'Valmiit',
          jobsInProgress: 'Käynnissä',
          jobsPlanned: 'Suunnitellut',
          editButton: 'Muokkaa',
          deleteButton: 'Poista',
          emptyState: 'Projekteja ei löytynyt',
          confirmDelete: 'Haluatko varmasti poistaa tämän projektin?',
          toastCreated: 'Projekti luotu',
          toastUpdated: 'Projekti päivitetty',
          toastDeleted: 'Projekti poistettu',
          toastDeleteError: 'Projektin poisto epäonnistui',
          toastError: 'Virhe',
          toastLoadError: 'Projektien lataus epäonnistui',
          noClient: 'Ei määritetty',
          modal: {
            addTitle: 'Uusi projekti',
            editTitle: 'Muokkaa projektia',
            nameLabel: 'Projektin nimi',
            namePlaceholder: 'Lejasrunķi tila – Työt 2026',
            clientLabel: 'Asiakas',
            clientPlaceholder: 'Valitse asiakas',
            propertyNameLabel: 'Kiinteistön nimi',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Kiinteistötunnus',
            addressLabel: 'Kiinteistön osoite',
            addressPlaceholder: 'Ropaži kunta',
            descriptionLabel: 'Kuvaus',
            descriptionPlaceholder: 'Projektin yksityiskohtainen kuvaus...',
            statusLabel: 'Tila',
            nextStepLabel: 'Mitä seuraavaksi?',
            nextStepPlaceholder: 'Viimeistele hakkuualueen rajaus',
            cancel: 'Peruuta',
            create: 'Luo',
            save: 'Tallenna'
          }
        },
        jobs: {
          title: 'Työt',
          subtitle: 'Hallitse töitä ja niiden tiloja',
          addButton: 'Lisää työ',
          searchPlaceholder: 'Hae töitä...',
          filterAll: 'Kaikki',
          table: {
            job: 'Työ',
            client: 'Asiakas',
            status: 'Tila',
            dates: 'Päivämäärät',
            responsible: 'Vastuuhenkilö',
            actions: 'Toiminnot'
          },
          deadlineLabel: 'Määräaika',
          confirmDelete: 'Haluatko varmasti poistaa työn "{title}"?',
          unknownClient: 'Tuntematon',
          toastCreated: 'Työ luotu',
          toastUpdated: 'Työ päivitetty',
          toastDeleted: 'Työ poistettu',
          toastDeleteError: 'Virhe',
          toastError: 'Virhe',
          modal: {
            addTitle: 'Lisää työ',
            editTitle: 'Muokkaa työtä',
            titleLabel: 'Työn nimi',
            titlePlaceholder: 'Kasvavien puiden merkintä',
            descriptionLabel: 'Kuvaus',
            descriptionPlaceholder: 'Työn kuvaus...',
            clientLabel: 'Asiakas',
            clientPlaceholder: 'Valitse asiakas',
            projectLabel: 'Projekti',
            projectPlaceholder: 'Valitse projekti',
            projectPlaceholderEmpty: 'Valitse ensin asiakas',
            statusLabel: 'Tila',
            responsibleLabel: 'Vastuuhenkilö',
            responsiblePlaceholder: 'Matti Meikäläinen',
            startDateLabel: 'Aloituspäivä',
            endDateLabel: 'Suunniteltu päättymispäivä',
            notesLabel: 'Huomiot asiakkaalle',
            notesPlaceholder: 'Huomiot, jotka näkyvät asiakkaalle...',
            cancel: 'Peruuta',
            create: 'Luo',
            save: 'Tallenna'
          }
        },
        bulkJob: {
          title: 'Lisää projektiin useita töitä',
          selectLabel: 'Valitse työtyypit:',
          selectAll: 'Valitse kaikki',
          clearAll: 'Tyhjennä',
          selectError: 'Valitse vähintään yksi työtyyppi',
          selectedCount: 'Valittu',
          selectedSuffix: 'työtyyppiä',
          statusNote: 'Kaikki työt luodaan tilalla ”Suunniteltu”',
          cancel: 'Peruuta',
          creating: 'Luodaan...',
          createCount: 'Luo {count} työtä',
          successTitle: 'Työt luotu onnistuneesti!',
          error: 'Töiden luonti epäonnistui',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Kasvavien puiden merkintä' },
            { id: 'caurmera_merishana', label: 'Läpimitan mittaus' },
            { id: 'cirsmas_stigoshana', label: 'Hakkuualueen rajaus' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Kiinteistön rajojen palautus' },
            { id: 'robezzimju_atjaunoshana', label: 'Rajamerkkien palautus' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Säästöpuiden merkintä valikoivassa hakkuussa' },
            { id: 'cirsmu_iezimeshana', label: 'Hakkuualan merkintä' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentoinnin valmistelu' },
            { id: 'es_projektu_sagatavoshana', label: 'EU‑projektien valmistelu' },
            { id: 'cits', label: 'Muu' }
          ]
        },
        audit: {
          title: 'Audit‑lokit',
          subtitle: 'Järjestelmän toimintahistoria',
          emptyTitle: 'Ei audit‑merkintöjä',
          emptyBody: 'Toimintahistoria näkyy täällä'
        },
        visitors: {
          title: 'Kävijätilastot',
          subtitle: 'Julkisen sivuston käynnit',
          range7: '7 päivää',
          range30: '30 päivää',
          range7Short: '7 päivää',
          range30Short: '30 päivää',
          rangeOther: '{count} päivää',
          totalLabel: 'Käyntejä yhteensä',
          uniqueLabel: 'Uniikit kävijät',
          periodLabel: 'Jakso',
          dailyTitle: 'Päivittäiset käynnit',
          dailyEmpty: 'Ei käyntitietoja valitulle ajalle.',
          recentTitle: 'Viimeisimmät käynnit',
          recentEmpty: 'Ei käyntimerkintöjä.',
          unknownRegion: 'Tuntematon alue',
          visitNumber: 'Käynti #{number}'
        },
        testimonials: {
          title: 'Suositusten hallinta',
          subtitle: 'Hyväksy tai piilota asiakassuositukset ennen julkaisua.',
          filters: {
            all: 'Kaikki',
            pending: 'Odottaa hyväksyntää',
            approved: 'Julkaistut',
            hidden: 'Piilotetut'
          },
          loading: 'Ladataan suosituksia...',
          empty: 'Valittua suodatinta vastaavia suosituksia ei ole.',
          average: 'Keskiarvo {rating}/5',
          speed: 'Nopeus',
          quality: 'Laatu',
          communication: 'Viestintä',
          responsiveness: 'Vasteaika',
          publish: 'Julkaise',
          hide: 'Piilota',
          returnToPending: 'Palauta odottaviin'
        },
        payroll: {
          title: 'Palkanlaskenta',
          subtitle: 'Työntekijöiden palkanlaskenta kuukausittain',
          addEntry: 'Lisää merkintä',
          export: 'Vie XLSX',
          confirmDelete: 'Poistetaanko tämä kirjaus?',
          toastCreated: 'Kirjaus tallennettu',
          toastUpdated: 'Kirjaus päivitetty',
          toastDeleted: 'Kirjaus poistettu',
          toastDeleteError: 'Kirjauksen poisto epäonnistui',
          toastError: 'Kirjauksen tallennus epäonnistui',
          validation: {
            employee: 'Valitse työntekijä',
            workTypes: 'Valitse vähintään yksi työtyyppi'
          },
          filters: {
            month: 'Kuukausi',
            year: 'Vuosi',
            employee: 'Työntekijä',
            client: 'Asiakas',
            status: 'Lasku',
            statusAll: 'Kaikki',
            statusPaid: 'Maksettu',
            statusUnpaid: 'Maksamatta'
          },
          summary: {
            totalSalary: 'Bruttopalkka yhteensä',
            totalCosts: 'Kulut yhteensä',
            fuelCost: 'Polttoaine',
            paintCost: 'Maali'
          },
          table: {
            title: 'Palkkakirjaukset',
            date: 'Päivämäärä',
            employee: 'Työntekijä',
            client: 'Asiakas',
            property: 'Kohde',
            workTypes: 'Työtyypit',
            salary: 'Brutto',
            costs: 'Kulut',
            paid: 'Maksettu',
            actions: 'Toiminnot',
            edit: 'Muokkaa',
            delete: 'Poista'
          },
          empty: {
            title: 'Ei palkkakirjauksia',
            body: 'Valitulle ajanjaksolle ei ole kirjauksia.'
          },
          form: {
            addTitle: 'Uusi palkkakirjaus',
            editTitle: 'Muokkaa palkkakirjausta',
            date: 'Päivämäärä',
            employee: 'Työntekijä',
            client: 'Asiakas (valinnainen)',
            propertyName: 'Kohteen nimi',
            cadastralNumber: 'Kiinteistötunnus',
            kilometers: 'Ajetut kilometrit',
            paintCans: 'Maalipurkit (kpl)',
            fuelRate: 'Polttoaineen hinta (€/km)',
            paintPrice: 'Maalipurkin hinta (€/kpl)',
            workTypes: 'Työtyypit',
            amount: 'Määrä',
            rate: 'Hinta',
            notes: 'Muistiinpanot',
            customRateNote: 'Hinta syötetään käsin',
            invoicePaid: 'Maksu vastaanotettu',
            save: 'Tallenna',
            cancel: 'Peruuta'
          },
          totals: {
            salary: 'Bruttopalkka',
            costs: 'Yrityksen kulut',
            fuel: 'Polttoainekulut',
            paint: 'Maalikulut'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Puiden merkintä',
            cirsmas_stigoshana: 'Hakkuualueen merkintä',
            caurmera_merishana: 'Läpimitan mittaus',
            paliekoso_koku_izzimeshana: 'Säästöpuiden merkintä',
            cirsmu_iezimeshana: 'Hakkuualan merkintä',
            ipashuma_robezu_atjaunoshana: 'Rajojen palautus',
            robezzimju_atjaunoshana: 'Rajamerkkien palautus'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'kpl'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projektia ei löytynyt',
          back: 'Takaisin',
          propertyLabel: 'Kiinteistö:',
          cadastralLabel: 'Kiinteistötunnus:',
          addressLabel: 'Osoite:',
          progressLabel: 'Kokonaisprogressi',
          jobsTotal: 'Töitä yhteensä',
          jobsCompleted: 'Valmiit',
          jobsInProgress: 'Käynnissä',
          jobsPlanned: 'Suunnitellut',
          nextStepTitle: 'Mitä seuraavaksi?',
          jobsTitle: 'Projektin työt',
          bulkAddJobs: 'Lisää useita töitä',
          deadlineLabel: 'Määräaika',
          lastUpdateLabel: 'Viimeisin muutos:',
          emptyJobs: 'Tähän projektiin ei ole vielä lisätty yhtään työtä'
        }
      }
    }
  },
  no: {
    languageLabel: 'NO',
    company: {
      slogan: 'Bærekraftig skogforvaltning'
    },
    heroBadge: 'Uavhengige skogtjenester',
    hero: {
      title: 'Uavhengig verdivurdering av hogstfelt for skogeiere',
      subtitle: 'Vi hjelper skogeiere med å vurdere verdien av hogstfeltet nøyaktig og forberede skogen til hogst gjennom profesjonelle målinger og nødvendig dokumentasjon.',
      description: 'Vi arbeider kun i skogeierens interesse – vi kjøper ikke hogstfelt og er ikke knyttet til tømmerkjøpere.',
      workIntro: 'Hva vi gjør',
      workItems: [
        'Merking av stående trær',
        'Diametermåling',
        'Utmåling av hogstfelt',
        'Gjenoppretting av eiendomsgrenser og grensemerker',
        'Utarbeidelse og innsending av dokumentasjon til myndigheter'
      ],
      workNote: 'Full oversikt over arbeider finnes i seksjonen «Arbeider».',
      reasonsTitle: 'Hvorfor velge oss',
      reasons: [
        'Nøyaktige skogsmålinger',
        'Uavhengig verdivurdering av hogstfelt',
        'Korrekt dokumentasjon',
        'Full prosessgjennomsiktighet'
      ],
      closing: 'Kunder kan følge fremdriften på nett fra hvor som helst.',
      tagline: 'Kontakt oss for en profesjonell tilnærming!',
      ctaPrimary: 'Bestill verdivurdering av hogstfelt',
      ctaSecondary: 'Kundeportal',
      salesHighlights: [
        'Uavhengig vurdering',
        'Nøyaktige målinger',
        'Full dokumentasjon',
        'Full gjennomsiktighet'
      ],
      calloutTitle: 'Sila Meži‑garanti',
      calloutBody: 'Nøyaktige målinger. Korrekt dokumentasjon. Full gjennomsiktighet.',
      workLink: 'Se arbeider',
      scrollHint: 'Rull ned',
      subtitleHighlight: 'vurdere verdien av hogstfeltet nøyaktig',
      descriptionHighlight: 'vi kjøper ikke hogstfelt og er ikke knyttet til tømmerkjøpere.'
    },
    trustBadges: [
      { id: 1, title: 'Nøyaktige skogsmålinger', description: 'Detaljerte feltmålinger og analyse' },
      { id: 2, title: 'Uavhengig verdivurdering av hogstfelt', description: 'Uten interesse i tømmerkjøp' },
      { id: 3, title: 'Korrekt dokumentasjon', description: 'Full støtte for utarbeidelse og innsending' },
      { id: 4, title: 'Full gjennomsiktighet', description: 'Kunder følger arbeidet på nett' }
    ],
    services: {
      eyebrow: 'Våre tjenester',
      title: 'Profesjonelle skogtjenester for skogeiere',
      description: 'Vi tilbyr et komplett spekter av skogtjenester — fra skogvurdering og målinger til dokumentasjon, prosjektledelse og organisering av skogarbeid.',
      mission: 'Vårt mål er å hjelpe skogeiere med å ta informerte beslutninger gjennom nøyaktig informasjon, profesjonell tilnærming og full prosessstøtte.',
      ctaQuestion: 'Usikker på hvilken tjeneste du trenger?',
      ctaLink: 'Kontakt oss for en gratis konsultasjon'
    },
    servicesList: [
      {
        id: 1,
        category: 'Vurdering av skog og hogstfelt',
        description: 'Vi gjennomfører profesjonell vurdering av stående trær og hogstfelt basert på detaljerte feltmålinger, oppdaterte markedspriser og gjeldende regelverk. Vurderingen utføres uavhengig av tømmerkjøp og gir objektiv og pålitelig informasjon til skogeieren.',
        items: [
          'Merking av stående trær',
          'Måling av diameter og andre parametere',
          'Beregning og analyse av hogstfeltets verdi'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Skogsmåling og grensearbeid',
        description: 'Vi tilbyr ulike skogsmålinger og avklaringer av eiendomsgrenser i felt. Alt arbeid utføres basert på matrikkeldata og gjeldende regelverk. Nøyaktige målinger bidrar til å unngå grensetvister og sikrer korrekt skogforvaltning.',
        items: [
          'Utmåling av hogstfelt',
          'Gjenoppretting av eiendomsgrenser i felt',
          'Montering og gjenoppretting av grensemerker'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Skogfornyelse og ungskogpleie',
        description: 'Vi hjelper skogeiere med å sikre bærekraftig skogutvikling ved å organisere fornyelse og ungskogpleie. Riktig pleie i tidlige faser påvirker skogens kvalitet og fremtidige verdi.',
        items: [
          'Organisering av skogfornyelse',
          'Planlegging og koordinering av planting',
          'Organisering av ungskogpleie'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentasjon og godkjenninger',
        description: 'Vi utarbeider og sender inn all nødvendig dokumentasjon til Statens skogtjeneste og andre myndigheter. Vi tilbyr full administrativ støtte gjennom hele prosessen slik at skogeiere unngår komplisert byråkrati.',
        items: [
          'Dokumentforberedelse for statlige institusjoner',
          'Utarbeidelse og innsending av søknader',
          'Full støtte i den administrative prosessen'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'EU‑støtteprosjekter',
        description: 'Vi rådgir skogeiere om tilgjengelige EU‑støtteordninger i skogbruk. Vi leverer full prosjektforberedelse og administrasjon — fra idé til gjennomføring.',
        items: [
          'Rådgivning om EU‑støtte',
          'Utarbeidelse av prosjektdokumentasjon',
          'Innsending og oppfølging av prosjekter'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Arbeider',
      title: 'Arbeider',
      description: 'Velg arbeider du er interessert i, så lager vi et presist pristilbud. Valget ditt legges automatisk til i forespørselsskjemaet.',
      summaryTitle: 'Valgte arbeider',
      summaryEmpty: 'Ingen arbeider valgt. Velg en tjeneste i listen over.',
      requestCta: 'Be om pristilbud',
      contactCta: 'Kontakt oss',
      selectError: 'Velg minst ett arbeid for å be om pris.',
      itemSelected: 'Lagt til i prisforespørsel',
      itemAdd: 'Marker for å be om pris'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Skogsarbeider',
        description: 'Nøyaktige feltarbeider og forberedelse av hogstfelt for trygg og korrekt skogforvaltning.',
        items: [
          'Utmåling av hogstfelt',
          'Merking av trær',
          'Kvisting av stående trær'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Skogfornyelse og stell',
        description: 'Sikrer bærekraftig skogutvikling gjennom målrettet fornyelsesarbeid.',
        items: [
          'Skogfornyelse',
          'Ungskogpleie',
          'Beskyttelse av ungskog mot vilt' 
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Forvaltning av skogeiendom',
        description: 'Fullsyklus forvaltning av skogeiendommer og koordinering fra planlegging til gjennomføring.',
        items: ['Forvaltning av skogeiendom']
      },
      {
        id: 'es',
        title: 'EU‑prosjektforberedelse',
        description: 'Rådgivning, dokumentasjon og oppfølging av prosjekter i EU‑støtteprogrammer.',
        items: ['Innsending og oppfølging av prosjekter']
      }
    ],
    process: {
      eyebrow: 'Samarbeidsprosess',
      title: 'Slik foregår samarbeidet',
      description: 'En tydelig og oversiktlig prosess fra forespørsel til ferdigstillelse.',
      steps: [
        { id: 1, title: 'Forespørsel', description: 'Kunden kontakter oss for å bestille vurdering eller annen tjeneste.' },
        { id: 2, title: 'Befaring', description: 'Vi besøker eiendommen og utfører nødvendige feltarbeider.' },
        { id: 3, title: 'Målinger og vurdering', description: 'Vi måler skogen nøyaktig og utarbeider en objektiv vurdering.' },
        { id: 4, title: 'Dokumentasjon', description: 'Vi utarbeider og sender inn nødvendige dokumenter til statlige myndigheter.' },
        { id: 5, title: 'Oppfølging på nett', description: 'Kunden kan følge fremdriften i kundeportalen.' },
        { id: 6, title: 'Sluttrapport', description: 'Vi leverer en tydelig rapport om utførte arbeider og resultater.' }
      ]
    },
    portal: {
      eyebrow: 'Digital plattform',
      title: 'Digital plattform – Kundeportal',
      description: 'Vi tilbyr kundene en praktisk og sikker nettportal som gir kontinuerlig tilgang til prosjekt- og arbeidsstatus. Portalen gjør det mulig å følge oppdateringer, spore status og få tilgang til alle prosjektdokumenter på ett sted.',
      subtitle: 'Plattformen er utviklet for maksimal gjennomsiktighet og enkel kommunikasjon med teamet vårt. Kunder kan se status når som helst uten å kontakte oss. Portalen fungerer på både PC og mobil, slik at informasjon alltid er tilgjengelig.',
      featuresTitle: 'Nøkkelfunksjoner',
      features: [
        { id: 1, title: 'Arbeidsstatus', description: 'Følg prosjektets fremdrift i sanntid – planlagt, pågående eller ferdig.', icon: 'Activity' },
        { id: 2, title: 'Dokumenttilgang', description: 'Alle prosjektdokumenter samlet på ett sted, klare til visning og nedlasting.', icon: 'FolderOpen' },
        { id: 3, title: 'Varsler', description: 'Motta oppdateringer om fremdrift, endringer og viktige nyheter.', icon: 'Bell' },
        { id: 4, title: 'Tilgjengelig overalt', description: 'Fungerer på PC og mobil med enkel tilgang uansett hvor du er.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Logg inn i portalen',
      ctaRequest: 'Be om tilgang',
      preview: {
        headerTitle: 'Mine prosjekter',
        headerActive: '3 aktive',
        items: [
          { title: 'Vurdering av hogstfelt #127', status: 'Fullført', tone: 'success' },
          { title: 'Skogsmåling', status: 'Pågår', tone: 'warning' },
          { title: 'Dokumentasjon for SFS', status: 'Planlagt', tone: 'info' }
        ],
        footerLeft: 'Siste aktivitet: i dag',
        footerRight: '2 nye dokumenter'
      }
    },
    why: {
      title: 'Hvorfor velge uavhengig vurdering',
      description: 'En vurdering utført av en potensiell kjøper innebærer alltid en interessekonflikt. Uavhengig vurdering gir et objektivt bilde av den reelle verdien og hjelper skogeiere å ta velbegrunnede beslutninger.',
      conclusion: 'Uavhengig vurdering bidrar ofte til å unngå ugunstige avtaler og gir et klart bilde av skogeiendommens potensial.',
      stats: [
        { value: '15–30%', label: 'Mulig inntektsforskjell' },
        { value: '100%', label: 'Objektiv vurdering' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Hvorfor er ikke kjøperen en objektiv vurderer?',
        content: 'Kjøperen har en økonomisk interesse i å kjøpe skogen så billig som mulig, noe som skaper en interessekonflikt. En uavhengig vurderer arbeider kun i din interesse.'
      },
      {
        id: 2,
        title: 'Hvordan påvirker uavhengig vurdering inntektene?',
        content: 'Nøyaktig og uavhengig vurdering hjelper til å fastsette reell verdi og oppnå en rettferdig pris i forhandlinger. Mange skogeiere har oppnådd 15–30% høyere pris med uavhengig vurdering.'
      },
      {
        id: 3,
        title: 'Vanlige feil',
        content: 'Utilstrekkelig informasjon om tømmermengder, kun å stole på kjøperens vurdering, mangelfull dokumentasjon og mangel på markedskunnskap – disse feilene reduserer skogeierens inntekter.'
      }
    ],
    about: {
      title: 'Om selskapet',
      subtitle: 'Erfaring innen skogbruk',
      description: 'Vi er en leverandør av skogtjenester med spesialisering i uavhengig vurdering av hogstfelt og nøyaktige skogsmålinger. Vi arbeider i samsvar med regelverk og i nært samarbeid med statlige institusjoner.',
      mission: 'Vårt mål er å sikre skogeiere en korrekt, transparent og profesjonell tjeneste gjennom hele samarbeidet.',
      points: [
        'Spesialisert på uavhengig vurdering av hogstfelt',
        'Nøyaktige skogsmålinger i tråd med regelverk',
        'Tett samarbeid med Statens skogtjeneste',
        'Full dokumentasjonsstøtte',
        'Vi samarbeider med både privatpersoner og juridiske enheter'
      ],
      regionsLabel: 'Virksomhetsområder',
      regions: ['Riga og omegn', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Bærekraftig skogforvaltning',
      sustainabilityText: 'Vi hjelper skogeiere med å bevare skogens verdi for fremtidige generasjoner ved å følge prinsippene for bærekraftig forvaltning og regelverk.',
      testimonialsEyebrow: 'Tilbakemeldinger',
      testimonialsTitle: 'Hva kundene våre sier',
      testimonialsDescription: 'Ekte erfaringer og vurderinger av vårt samarbeid.',
      testimonialsAdd: 'Legg til tilbakemelding',
      testimonialsLoading: 'Laster tilbakemeldinger...',
      testimonialsEmpty: 'Ingen tilbakemeldinger ennå. Bli den første som deler erfaring!',
      testimonialsModalTitle: 'Legg til tilbakemelding',
      form: {
        nameLabel: 'Navn eller selskap',
        regionLabel: 'Region',
        ratingLabel: 'Vurdering',
        speedLabel: 'Hastighet',
        qualityLabel: 'Kvalitet',
        communicationLabel: 'Kommunikasjon',
        responsivenessLabel: 'Respons',
        textLabel: 'Tilbakemeldingstekst',
        cancel: 'Avbryt',
        submit: 'Send tilbakemelding',
        sending: 'Sender...',
        success: 'Tilbakemelding sendt til godkjenning',
        error: 'Kunne ikke sende tilbakemelding. Prøv igjen.'
      },
      metrics: {
        speed: 'Hastighet',
        quality: 'Kvalitet',
        communication: 'Kommunikasjon',
        responsiveness: 'Respons'
      }
    },
    contact: {
      eyebrow: 'Kontakt oss',
      title: 'Kontakt',
      description: 'Kontakt oss for å bestille tjeneste eller få rådgivning om din skogeiendom.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Skogbruksspesialist',
      formNote: 'Fyll ut skjemaet, så tar vi kontakt.',
      infoTitle: 'Kontaktinformasjon',
      phoneLabel: 'Telefon',
      emailLabel: 'E‑post',
      addressLabel: 'Juridisk adresse',
      hoursLabel: 'Arbeidstid',
      freeConsultationTitle: 'Gratis konsultasjon',
      freeConsultationText: 'Første samtale og vurdering er gratis. Kontakt oss og finn beste løsning sammen.',
      formTitle: 'Forespørselsskjema',
      successTitle: 'Takk for din forespørsel!',
      successBody: 'Vi tar kontakt med deg snart.',
      formNameLabel: 'Navn, etternavn',
      formNamePlaceholder: 'Ola Nordmann',
      formPhoneLabel: 'Telefonnummer',
      formPhonePlaceholder: '+47 900 12 345',
      formEmailLabel: 'E‑postadresse',
      formEmailPlaceholder: 'ola@example.com',
      formMessageLabel: 'Melding',
      formMessagePlaceholder: 'Ditt spørsmål eller situasjonsbeskrivelse...',
      formConsent: 'Ved å sende skjemaet samtykker du til behandling av personopplysninger i henhold til GDPR.',
      formSubmitting: 'Sender...',
      formSubmit: 'Send forespørsel',
      toastSavedTitle: 'Forespørsel lagret',
      toastSavedBody: 'E‑postlevering krever verifisert domene. Meldingen er synlig i adminportalen.',
      toastSentTitle: 'Forespørsel sendt!',
      toastSentBody: 'Vi tar kontakt med deg snart.',
      toastErrorTitle: 'Feil ved sending av forespørsel',
      submitError: 'Feil ved sending av forespørsel. Prøv igjen.',
      prefillLabel: 'Jeg ønsker et pristilbud for'
    },
    cookie: {
      text: 'Dette nettstedet bruker informasjonskapsler for å forbedre opplevelsen.',
      accept: 'Godta'
    },
    privacy: {
      badge: 'Personvern',
      title: 'Sila Meži personvern',
      intro: 'Vi tar personvern og datasikkerhet på alvor. I denne policyen forklarer vi hvilke data vi behandler og hvorfor.',
      controllerTitle: 'Behandlingsansvarlig',
      controllerRegLabel: 'Reg.nr:',
      controllerAddressLabel: 'Adresse:',
      controllerEmailLabel: 'E‑post for dataspørsmål:',
      dataTitle: 'Hvilke data behandles',
      dataItemContact: 'Data fra kontaktskjema (navn, e‑post, telefon, melding).',
      dataItemVisits: 'Besøksregistrering etter samtykke til informasjonskapsler (IP‑adresse, region, besøkstid).',
      dataItemEmail: 'Data om e‑postlevering via Resend.',
      visitsTitle: 'Besøksregistrering',
      visitsText: 'Besøk registreres kun etter samtykke. Vi bruker IPinfo for å fastsette region.',
      cookiesTitle: 'Informasjonskapsler',
      cookiesText: 'Dette nettstedet bruker nødvendige, funksjonelle og statistiske informasjonskapsler for å sikre drift, forbedre opplevelsen og forstå besøkstrender.',
      retentionTitle: 'Lagring og rettigheter',
      retentionText: 'Data lagres så lenge det er nødvendig for tjenestene eller som kreves av lov. Du kan be om retting eller sletting ved å skrive til e‑postadressen over.',
      thirdPartyTitle: 'Tredjepartstjenester',
      thirdPartyText: 'Vi bruker IPinfo for regionsbestemmelse og Resend for e‑postlevering. Tredjeparter behandler data i henhold til sine egne personvernregler.'
    },
    footer: {
      companyDescription: 'Uavhengig verdivurdering av hogstfelt og skogtjenester i hele Latvia. Vi arbeider kun i skogeierens interesse.',
      companyNote: 'Vi samarbeider med både privatpersoner og juridiske enheter.',
      navigationTitle: 'Navigasjon',
      servicesTitle: 'Tjenester',
      contactTitle: 'Kontakt',
      quickLinks: {
        home: 'Hjem',
        services: 'Tjenester',
        process: 'Slik fungerer det',
        portal: 'Kundeportal',
        why: 'Hvorfor uavhengig vurdering',
        about: 'Om oss',
        contact: 'Kontakt'
      },
      services: {
        assessment: 'Vurdering av hogstfelt',
        measurements: 'Skogsmålinger',
        documentation: 'Dokumentasjon',
        euProjects: 'EU‑prosjekter'
      },
      rights: 'Alle rettigheter forbeholdt.',
      privacy: 'Personvern',
      terms: 'Bruksvilkår'
    },
    nav: {
      home: 'Hjem',
      services: 'Tjenester',
      works: 'Arbeider',
      process: 'Prosess',
      why: 'Hvorfor oss',
      about: 'Om',
      contact: 'Kontakt',
      portal: 'Kundeportal',
      consult: 'Søk',
      consultMobile: 'Be om konsultasjon'
    },
    portalUi: {
      common: { loading: 'Laster...' },
      status: {
        planned: 'Planlagt',
        inProgress: 'Pågår',
        completed: 'Fullført',
        active: 'Aktiv',
        onHold: 'Pause',
        awaitingInfo: 'Avventer info',
        submitted: 'Innsendt'
      },
      nav: {
        client: {
          dashboard: 'Oversikt',
          projects: 'Prosjekter',
          jobs: 'Arbeider',
          documents: 'Dokumenter',
          messages: 'Meldinger',
          contact: 'Kontakt'
        },
        admin: {
          dashboard: 'Oversikt',
          clients: 'Kunder',
          projects: 'Prosjekter',
          jobs: 'Arbeider',
          documents: 'Dokumenter',
          messages: 'Varsler',
          visitors: 'Besøk',
          testimonials: 'Tilbakemeldinger',
          audit: 'Audit‑logg',
          payroll: 'Lønnsberegning'
        }
      },
      layout: {
        portalLabel: 'Kundeportal',
        roleAdmin: 'Administrator',
        roleClient: 'Kunde',
        logout: 'Logg ut'
      },
      login: {
        portalLabel: 'Kundeportal',
        title: 'Logg inn i kundeportalen',
        description: 'Her kan du følge arbeidsstatus, dokumenter og rapporter for eiendommen din.',
        usernameLabel: 'Brukernavn',
        usernamePlaceholder: 'Skriv inn brukernavn',
        passwordLabel: 'Passord',
        passwordPlaceholder: 'Skriv inn passord',
        togglePassword: 'Vis passord',
        submit: 'Logg inn',
        submitting: 'Logger inn...',
        forgotText: 'Glemt passord?',
        contactAdmin: 'Kontakt administrator',
        securityTitle: 'Sikkerhetsmelding',
        securityText: 'Tilgang kun for autoriserte kunder. Kontakt oss for tilgang:',
        backToSite: 'Tilbake til hovedsiden',
        successToast: 'Innlogging vellykket!',
        errorFallback: 'Innloggingsfeil'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Ingen tilgang',
        description: 'Du har ikke rettigheter til å se denne seksjonen.',
        detail: 'Hvis du mener dette er en feil, kontakt administrator.',
        backToPanel: 'Tilbake til panel',
        home: 'Hjem'
      },
      documents: {
        title: 'Legg til dokument i prosjekt',
        fileRequired: 'Velg en fil',
        uploadSuccess: 'Fil lastet opp',
        uploadError: 'Opplastingsfeil',
        fileLabel: 'Fil',
        fileInstruction: 'Klikk for å velge fil',
        fileFormats: 'PDF, Excel, Word, Bilder',
        categoryLabel: 'Dokumenttype',
        categories: [
          { value: 'skice', label: 'Skisse' },
          { value: 'iesniegums', label: 'Søknad' },
          { value: 'ligums', label: 'Kontrakt' },
          { value: 'atskaite', label: 'Rapport' },
          { value: 'foto', label: 'Foto' },
          { value: 'cits', label: 'Annet' }
        ],
        visibleLabel: 'Synlig for kunde',
        visibleHint: 'Kunden kan se og laste ned dokumentet',
        upload: 'Last opp',
        uploading: 'Laster opp...',
        cancel: 'Avbryt'
      },
      client: {
        dashboard: {
          greeting: 'Velkommen',
          subtitle: 'Din',
          subtitleHighlight: 'kundeportaloversikt',
          stats: {
            totalJobs: 'Totalt antall jobber',
            activeJobs: 'Aktive jobber',
            completedJobs: 'Fullførte',
            newMessages: 'Nye meldinger'
          },
          lastUpdate: 'Siste oppdatering:',
          actions: {
            jobsTitle: 'Se alle jobber',
            jobsDescription: 'Se jobbstatus og detaljer',
            documentsTitle: 'Dokumenter',
            documentsDescription: 'Se og last ned filer'
          },
          recentTitle: 'Siste jobber',
          viewAll: 'Se alle',
          responsibleLabel: 'Ansvarlig',
          emptyJobs: 'Ingen jobber ennå'
        },
        projects: {
          title: 'Mine prosjekter',
          subtitlePrefix: 'Dine',
          subtitleHighlight: 'skogprosjekter',
          subtitleSuffix: 'og fremdrift',
          cadastralLabel: 'Matrikkel nr.:',
          progressLabel: 'Total fremdrift',
          jobsTotal: 'Totalt',
          jobsCompleted: 'Fullført',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planlagt',
          nextStepTitle: 'Hva skjer videre?',
          viewDetails: 'Se detaljer',
          emptyTitle: 'Ingen prosjekter',
          emptySubtitle: 'Prosjekter vises her når administrator oppretter dem.'
        },
        jobs: {
          title: 'Arbeider',
          subtitlePrefix: 'Se dine arbeider og deres',
          subtitleHighlight: 'status',
          searchPlaceholder: 'Søk arbeider...',
          filterAll: 'Alle',
          filterPlanned: 'Planlagt',
          filterInProgress: 'Pågår',
          filterCompleted: 'Fullført',
          deadlineLabel: 'Frist',
          emptyTitle: 'Ingen arbeider funnet',
          emptyFiltered: 'Prøv å endre søkekriteriene',
          emptyAll: 'Ingen arbeider lagt til ennå'
        },
        jobDetail: {
          backToJobs: 'Tilbake til arbeider',
          notFoundTitle: 'Arbeid ikke funnet',
          infoTitle: 'Arbeidsinformasjon',
          responsibleLabel: 'Ansvarlig',
          startDateLabel: 'Startdato',
          plannedEndLabel: 'Planlagt sluttdato',
          completedLabel: 'Fullført',
          notesTitle: 'Notater',
          documentsTitle: 'Vedlagte dokumenter',
          documentsEmpty: 'Ingen dokumenter vedlagt',
          downloadError: 'Kunne ikke laste ned dokument',
          timelineTitle: 'Statuslinje',
          timelineEmpty: 'Ingen historikkoppføringer'
        },
        documents: {
          title: 'Dokumenter',
          subtitlePrefix: 'Se og last ned dine',
          subtitleHighlight: 'dokumenter',
          searchPlaceholder: 'Søk dokumenter, prosjekter eller forfattere...',
          filterAll: 'Alle',
          allProjects: 'Alle prosjekter',
          allUploaders: 'Alle forfattere',
          sortNewest: 'Nyeste først',
          sortOldest: 'Eldste først',
          latestOnly: 'Kun nyeste versjoner',
          download: 'Last ned',
          downloadError: 'Kunne ikke laste ned dokument',
          emptyTitle: 'Ingen dokumenter',
          emptyNoDocuments: 'Ingen dokumenter tilgjengelige ennå.',
          emptyFiltered: 'Ingen dokumenter passer med valgte filtre.',
          versionLabel: 'Versjon',
          categoryOther: 'Annet',
          categories: {
            valsts_institucijam: 'Til statlige institusjoner',
            atskaites: 'Rapporter',
            merijumu_dati: 'Måledata',
            skices: 'Skisser',
            cits: 'Annet'
          }
        },
        messages: {
          title: 'Meldinger',
          subtitle: 'Varsler og meldinger fra administrasjonen',
          inboxTitle: 'Innboks',
          emptyList: 'Ingen meldinger',
          emptyDetailTitle: 'Velg en melding',
          emptyDetailText: 'Klikk på en melding for å lese den'
        },
        contact: {
          title: 'Kontakt',
          subtitlePrefix: 'Still et spørsmål eller',
          subtitleHighlight: 'ta kontakt',
          phoneLabel: 'Telefon',
          emailLabel: 'E‑post',
          hoursLabel: 'Åpningstider',
          formTitle: 'Send melding',
          subjectLabel: 'Emne',
          subjectPlaceholder: 'Emnet for meldingen',
          messageLabel: 'Melding',
          messagePlaceholder: 'Ditt spørsmål eller melding...',
          submit: 'Send',
          submitting: 'Sender...',
          successTitle: 'Melding sendt!',
          successBody: 'Vi tar kontakt.',
          toastSuccess: 'Melding sendt!',
          toastError: 'Feil ved sending av melding'
        }
      },
      admin: {
        dashboard: {
          title: 'Administrasjon',
          titleSuffix: 'panel',
          subtitlePrefix: 'Administrer',
          subtitleHighlight: 'kunder, arbeider og dokumenter',
          stats: {
            totalClients: 'Totalt antall kunder',
            totalJobs: 'Totalt antall arbeider',
            activeJobs: 'Aktive arbeider',
            completedJobs: 'Fullførte'
          },
          quick: {
            clientsTitle: 'Administrer kunder',
            clientsDescription: 'Legg til og rediger kunder',
            jobsTitle: 'Administrer arbeider',
            jobsDescription: 'Opprett og oppdater arbeider',
            documentsTitle: 'Dokumenter',
            documentsDescription: 'Last opp dokumenter'
          },
          recentTitle: 'Siste arbeider',
          viewAll: 'Se alle',
          emptyJobs: 'Ingen arbeider'
        },
        clients: {
          title: 'Kunder',
          subtitle: 'Administrer brukere og tilgang',
          addButton: 'Legg til kunde',
          searchPlaceholder: 'Søk kunder...',
          table: {
            client: 'Kunde',
            username: 'Brukernavn',
            contacts: 'Kontaktinformasjon',
            role: 'Rolle',
            status: 'Status',
            actions: 'Handlinger'
          },
          roleAdmin: 'Admin',
          roleClient: 'Kunde',
          statusActive: 'Aktiv',
          statusInactive: 'Inaktiv',
          confirmDelete: 'Er du sikker på at du vil slette brukeren "{name}"?',
          toastCreated: 'Bruker opprettet',
          toastUpdated: 'Bruker oppdatert',
          toastDeleted: 'Bruker slettet',
          toastDeleteError: 'Slettefeil',
          toastError: 'Feil',
          passwordLengthError: 'Passordet må være minst 12 tegn',
          modal: {
            addTitle: 'Legg til kunde',
            editTitle: 'Rediger bruker',
            clientNameLabel: 'Kundenavn / selskap',
            clientNamePlaceholder: 'AS Skogeier',
            emailLabel: 'E‑post',
            phoneLabel: 'Telefon',
            usernameLabel: 'Brukernavn',
            usernamePlaceholder: 'brukernavn',
            passwordLabel: 'Passord *',
            passwordEditLabel: 'Nytt passord (valgfritt)',
            passwordPlaceholder: 'Minst 12 tegn',
            roleLabel: 'Rolle',
            cancel: 'Avbryt',
            create: 'Opprett',
            save: 'Lagre'
          }
        },
        projects: {
          title: 'Prosjektstyring',
          subtitle: 'Administrer kundeprosjekter og arbeider',
          addButton: 'Nytt prosjekt',
          searchPlaceholder: 'Søk prosjekter...',
          progressLabel: 'Fremdrift',
          stats: {
            total: 'Totalt antall prosjekter',
            active: 'Aktive',
            completed: 'Fullførte',
            totalJobs: 'Totalt antall arbeider'
          },
          jobsTotal: 'Totalt',
          jobsCompleted: 'Fullførte',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planlagt',
          editButton: 'Rediger',
          deleteButton: 'Slett',
          emptyState: 'Ingen prosjekter funnet',
          confirmDelete: 'Er du sikker på at du vil slette dette prosjektet?',
          toastCreated: 'Prosjekt opprettet',
          toastUpdated: 'Prosjekt oppdatert',
          toastDeleted: 'Prosjekt slettet',
          toastDeleteError: 'Kunne ikke slette prosjektet',
          toastError: 'Feil',
          toastLoadError: 'Kunne ikke laste prosjekter',
          noClient: 'Ikke angitt',
          modal: {
            addTitle: 'Nytt prosjekt',
            editTitle: 'Rediger prosjekt',
            nameLabel: 'Prosjektnavn',
            namePlaceholder: 'Lejasrunķi eiendom – Arbeider 2026',
            clientLabel: 'Kunde',
            clientPlaceholder: 'Velg kunde',
            propertyNameLabel: 'Eiendomsnavn',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Matrikkelnummer',
            addressLabel: 'Eiendomsadresse',
            addressPlaceholder: 'Ropaži kommune',
            descriptionLabel: 'Beskrivelse',
            descriptionPlaceholder: 'Detaljert prosjektbeskrivelse...',
            statusLabel: 'Status',
            nextStepLabel: 'Hva skjer videre?',
            nextStepPlaceholder: 'Fullfør utmåling av hogstfelt',
            cancel: 'Avbryt',
            create: 'Opprett',
            save: 'Lagre'
          }
        },
        jobs: {
          title: 'Arbeider',
          subtitle: 'Administrer arbeider og deres status',
          addButton: 'Legg til arbeid',
          searchPlaceholder: 'Søk arbeider...',
          filterAll: 'Alle',
          table: {
            job: 'Arbeid',
            client: 'Kunde',
            status: 'Status',
            dates: 'Datoer',
            responsible: 'Ansvarlig',
            actions: 'Handlinger'
          },
          deadlineLabel: 'Frist',
          confirmDelete: 'Er du sikker på at du vil slette arbeidet "{title}"?',
          unknownClient: 'Ukjent',
          toastCreated: 'Arbeid opprettet',
          toastUpdated: 'Arbeid oppdatert',
          toastDeleted: 'Arbeid slettet',
          toastDeleteError: 'Feil',
          toastError: 'Feil',
          modal: {
            addTitle: 'Legg til arbeid',
            editTitle: 'Rediger arbeid',
            titleLabel: 'Arbeidsnavn',
            titlePlaceholder: 'Merking av stående trær',
            descriptionLabel: 'Beskrivelse',
            descriptionPlaceholder: 'Arbeidsbeskrivelse...',
            clientLabel: 'Kunde',
            clientPlaceholder: 'Velg kunde',
            projectLabel: 'Prosjekt',
            projectPlaceholder: 'Velg prosjekt',
            projectPlaceholderEmpty: 'Velg først kunde',
            statusLabel: 'Status',
            responsibleLabel: 'Ansvarlig',
            responsiblePlaceholder: 'Ola Nordmann',
            startDateLabel: 'Startdato',
            endDateLabel: 'Planlagt sluttdato',
            notesLabel: 'Notater til kunde',
            notesPlaceholder: 'Notater som kunden kan se...',
            cancel: 'Avbryt',
            create: 'Opprett',
            save: 'Lagre'
          }
        },
        bulkJob: {
          title: 'Legg til flere arbeider i prosjekt',
          selectLabel: 'Velg arbeidstyper:',
          selectAll: 'Velg alle',
          clearAll: 'Tøm',
          selectError: 'Velg minst én arbeidstype',
          selectedCount: 'Valgt',
          selectedSuffix: 'arbeidstyper',
          statusNote: 'Alle arbeider opprettes med status «Planlagt»',
          cancel: 'Avbryt',
          creating: 'Oppretter...',
          createCount: 'Opprett {count} arbeider',
          successTitle: 'Arbeider opprettet!',
          error: 'Kunne ikke opprette arbeider',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Merking av stående trær' },
            { id: 'caurmera_merishana', label: 'Diametermåling' },
            { id: 'cirsmas_stigoshana', label: 'Utmåling av hogstfelt' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Gjenoppretting av eiendomsgrenser' },
            { id: 'robezzimju_atjaunoshana', label: 'Gjenoppretting av grensemerker' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Merking av gjenstående trær ved selektiv hogst' },
            { id: 'cirsmu_iezimeshana', label: 'Avgrensning av hogstfelt' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentasjonsforberedelse' },
            { id: 'es_projektu_sagatavoshana', label: 'EU‑prosjektforberedelse' },
            { id: 'cits', label: 'Annet' }
          ]
        },
        audit: {
          title: 'Audit‑logg',
          subtitle: 'Systemets aktivitetshistorikk',
          emptyTitle: 'Ingen audit‑oppføringer',
          emptyBody: 'Aktivitetshistorikk vises her'
        },
        visitors: {
          title: 'Besøksstatistikk',
          subtitle: 'Besøk på den offentlige nettsiden',
          range7: '7 dager',
          range30: '30 dager',
          range7Short: '7 dager',
          range30Short: '30 dager',
          rangeOther: '{count} dager',
          totalLabel: 'Totalt antall besøk',
          uniqueLabel: 'Unike besøkende',
          periodLabel: 'Periode',
          dailyTitle: 'Daglige besøk',
          dailyEmpty: 'Ingen besøksdata for valgt periode.',
          recentTitle: 'Siste besøk',
          recentEmpty: 'Ingen besøksoppføringer.',
          unknownRegion: 'Ukjent region',
          visitNumber: 'Besøk #{number}'
        },
        testimonials: {
          title: 'Tilbakemeldingshåndtering',
          subtitle: 'Godkjenn eller skjul tilbakemeldinger før de vises på nettsiden.',
          filters: {
            all: 'Alle',
            pending: 'Venter på godkjenning',
            approved: 'Publiserte',
            hidden: 'Skjulte'
          },
          loading: 'Laster tilbakemeldinger...',
          empty: 'Ingen tilbakemeldinger for valgt filter.',
          average: 'Gjennomsnitt {rating}/5',
          speed: 'Hastighet',
          quality: 'Kvalitet',
          communication: 'Kommunikasjon',
          responsiveness: 'Respons',
          publish: 'Publiser',
          hide: 'Skjul',
          returnToPending: 'Tilbake til ventende'
        },
        payroll: {
          title: 'Lønnsberegning',
          subtitle: 'Månedlig lønnsberegning for ansatte',
          addEntry: 'Legg til oppføring',
          export: 'Eksporter XLSX',
          confirmDelete: 'Vil du slette denne oppføringen?',
          toastCreated: 'Oppføring lagret',
          toastUpdated: 'Oppføring oppdatert',
          toastDeleted: 'Oppføring slettet',
          toastDeleteError: 'Kunne ikke slette oppføringen',
          toastError: 'Kunne ikke lagre oppføringen',
          validation: {
            employee: 'Velg en ansatt',
            workTypes: 'Velg minst én arbeidstype'
          },
          filters: {
            month: 'Måned',
            year: 'År',
            employee: 'Ansatt',
            client: 'Klient',
            status: 'Faktura',
            statusAll: 'Alle',
            statusPaid: 'Betalt',
            statusUnpaid: 'Ikke betalt'
          },
          summary: {
            totalSalary: 'Total bruttolønn',
            totalCosts: 'Totale kostnader',
            fuelCost: 'Drivstoff',
            paintCost: 'Maling'
          },
          table: {
            title: 'Lønnsoppføringer',
            date: 'Dato',
            employee: 'Ansatt',
            client: 'Klient',
            property: 'Eiendom',
            workTypes: 'Arbeidstyper',
            salary: 'Brutto',
            costs: 'Kostnader',
            paid: 'Betalt',
            actions: 'Handlinger',
            edit: 'Rediger',
            delete: 'Slett'
          },
          empty: {
            title: 'Ingen lønnsoppføringer',
            body: 'Ingen oppføringer for valgt periode.'
          },
          form: {
            addTitle: 'Ny lønnsoppføring',
            editTitle: 'Rediger lønnsoppføring',
            date: 'Dato',
            employee: 'Ansatt',
            client: 'Klient (valgfritt)',
            propertyName: 'Eiendomsnavn',
            cadastralNumber: 'Matrikkelnummer',
            kilometers: 'Kjørte kilometer',
            paintCans: 'Malingbokser (stk.)',
            fuelRate: 'Drivstoffrate (€/km)',
            paintPrice: 'Pris per malingboks (€/stk.)',
            workTypes: 'Arbeidstyper',
            amount: 'Omfang',
            rate: 'Sats',
            notes: 'Notater',
            customRateNote: 'Sats angis manuelt',
            invoicePaid: 'Betaling mottatt',
            save: 'Lagre',
            cancel: 'Avbryt'
          },
          totals: {
            salary: 'Bruttolønn',
            costs: 'Bedriftskostnader',
            fuel: 'Drivstoffkostnad',
            paint: 'Malingskostnad'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Tremerking',
            cirsmas_stigoshana: 'Merkingsarbeid',
            caurmera_merishana: 'Diameter­måling',
            paliekoso_koku_izzimeshana: 'Merking av stående trær',
            cirsmu_iezimeshana: 'Avgrensning av hogstfelt',
            ipashuma_robezu_atjaunoshana: 'Gjenoppretting av grenser',
            robezzimju_atjaunoshana: 'Gjenoppretting av grensemerker'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'stk.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Prosjekt ikke funnet',
          back: 'Tilbake',
          propertyLabel: 'Eiendom:',
          cadastralLabel: 'Matrikkel:',
          addressLabel: 'Adresse:',
          progressLabel: 'Total fremdrift',
          jobsTotal: 'Totalt antall arbeider',
          jobsCompleted: 'Fullførte',
          jobsInProgress: 'Pågår',
          jobsPlanned: 'Planlagt',
          nextStepTitle: 'Hva skjer videre?',
          jobsTitle: 'Prosjektarbeider',
          bulkAddJobs: 'Legg til flere arbeider',
          deadlineLabel: 'Frist',
          lastUpdateLabel: 'Siste endring:',
          emptyJobs: 'Ingen arbeider er lagt til i dette prosjektet ennå'
        }
      }
    }
  },
  da: {
    languageLabel: 'DA',
    company: {
      slogan: 'Bæredygtig skovforvaltning'
    },
    heroBadge: 'Uafhængige skovtjenester',
    hero: {
      title: 'Uafhængig vurdering af hugstareal for skovejere',
      subtitle: 'Vi hjælper skovejere med at vurdere værdien af hugstarealet præcist og forberede skoven til hugst gennem professionelle målinger og nødvendig dokumentation.',
      description: 'Vi arbejder kun i skovejerens interesse – vi køber ikke hugstarealer og er ikke knyttet til træopkøbere.',
      workIntro: 'Det vi laver',
      workItems: [
        'Mærkning af stående træer',
        'Diameter­måling',
        'Afmærkning af hugstareal',
        'Genopretning af ejendomsgrænser og grænsemærker',
        'Udarbejdelse og indsendelse af dokumentation til myndigheder'
      ],
      workNote: 'Den fulde oversigt over arbejder findes i afsnittet “Arbejder”.',
      reasonsTitle: 'Hvorfor vælge os',
      reasons: [
        'Præcise skovmålinger',
        'Uafhængig vurdering af hugstareal',
        'Korrekt dokumentation',
        'Fuld procesgennemsigtighed'
      ],
      closing: 'Kunder kan følge arbejdets fremskridt online fra hvor som helst.',
      tagline: 'Kontakt os for en professionel tilgang!',
      ctaPrimary: 'Bestil vurdering af hugstareal',
      ctaSecondary: 'Kundeportal',
      salesHighlights: [
        'Uafhængig vurdering',
        'Præcise målinger',
        'Fuld dokumentation',
        'Fuld gennemsigtighed'
      ],
      calloutTitle: 'Sila Meži‑garanti',
      calloutBody: 'Præcise målinger. Korrekt dokumentation. Fuld gennemsigtighed.',
      workLink: 'Se arbejder',
      scrollHint: 'Scroll ned',
      subtitleHighlight: 'vurdere værdien af hugstarealet præcist',
      descriptionHighlight: 'vi køber ikke hugstarealer og er ikke knyttet til træopkøbere.'
    },
    trustBadges: [
      { id: 1, title: 'Præcise skovmålinger', description: 'Detaljerede feltmålinger og analyse' },
      { id: 2, title: 'Uafhængig vurdering af hugstareal', description: 'Uden interesse i træopkøb' },
      { id: 3, title: 'Korrekt dokumentation', description: 'Fuld støtte til udarbejdelse og indsendelse' },
      { id: 4, title: 'Fuld gennemsigtighed', description: 'Kunder følger arbejdet online' }
    ],
    services: {
      eyebrow: 'Vores tjenester',
      title: 'Professionelle skovtjenester for skovejere',
      description: 'Vi tilbyder et komplet udvalg af skovtjenester — fra skovvurdering og målinger til dokumentation, projektledelse og organisering af skovarbejde.',
      mission: 'Vores mål er at hjælpe skovejere med at træffe velinformerede beslutninger gennem præcis information, professionel tilgang og fuld processtøtte.',
      ctaQuestion: 'Er du i tvivl om, hvilken service du har brug for?',
      ctaLink: 'Kontakt os for en gratis konsultation'
    },
    servicesList: [
      {
        id: 1,
        category: 'Skov- og hugstarealvurdering',
        description: 'Vi udfører professionel vurdering af stående træer og hugstarealer baseret på detaljerede feltmålinger, aktuelle markedspriser og gældende regler. Vurderingen udføres uafhængigt af træopkøb og sikrer objektiv og pålidelig information for skovejeren.',
        items: [
          'Mærkning af stående træer',
          'Måling af trædiameter og andre parametre',
          'Beregning og analyse af hugstarealets værdi'
        ],
        icon: 'TreePine'
      },
      {
        id: 2,
        category: 'Skovmåling og grænsearbejde',
        description: 'Vi tilbyder forskellige skovmålinger og afklaring af ejendomsgrænser i marken. Alt arbejde udføres efter matrikeldata og gældende regler. Præcise målinger hjælper med at undgå grænsestridigheder og sikrer korrekt skovforvaltning.',
        items: [
          'Afmærkning af hugstareal',
          'Genopretning af ejendomsgrænser i marken',
          'Opsætning og genopretning af grænsemærker'
        ],
        icon: 'Ruler'
      },
      {
        id: 3,
        category: 'Skovfornyelse og ungskovpleje',
        description: 'Vi hjælper skovejere med at sikre bæredygtig skovudvikling ved at organisere fornyelses- og ungskovplejearbejder. Korrekt pleje i de tidlige faser påvirker skovens kvalitet og fremtidige værdi.',
        items: [
          'Organisering af skovfornyelse',
          'Planlægning og koordinering af plantning',
          'Organisering af ungskovpleje'
        ],
        icon: 'TreePine'
      },
      {
        id: 4,
        category: 'Dokumentation og godkendelser',
        description: 'Vi udarbejder og indsender al nødvendig dokumentation til Statens Skovtjeneste og andre myndigheder. Vi tilbyder fuld administrativ støtte gennem hele processen, så skovejere undgår kompliceret bureaukrati.',
        items: [
          'Dokumentforberedelse til statslige institutioner',
          'Udarbejdelse og indsendelse af ansøgninger',
          'Fuld administrativ processtøtte'
        ],
        icon: 'FileText'
      },
      {
        id: 5,
        category: 'EU‑støtteprojekter',
        description: 'Vi rådgiver skovejere om tilgængelige EU‑støtteordninger i skovbrug. Vi håndterer hele projektprocessen — fra idé til gennemførelse.',
        items: [
          'Rådgivning om EU‑støtte',
          'Udarbejdelse af projektdokumentation',
          'Indsendelse og opfølgning af projekter'
        ],
        icon: 'Award'
      }
    ],
    works: {
      eyebrow: 'Arbejder',
      title: 'Arbejder',
      description: 'Vælg de arbejder, du er interesseret i, så udarbejder vi et præcist tilbud. Dit valg tilføjes automatisk til forespørgselsformularen.',
      summaryTitle: 'Valgte arbejder',
      summaryEmpty: 'Ingen arbejder valgt. Vælg en service i listen ovenfor.',
      requestCta: 'Anmod om tilbud',
      contactCta: 'Kontakt os',
      selectError: 'Vælg mindst én opgave for at anmode om pris.',
      itemSelected: 'Tilføjet til prisforespørgsel',
      itemAdd: 'Markér for at anmode om pris'
    },
    worksCatalog: [
      {
        id: 'mezsaimniecibas',
        title: 'Skovarbejder',
        description: 'Præcise feltarbejder og forberedelse af hugstareal til sikker og korrekt skovforvaltning.',
        items: [
          'Afmærkning af hugstareal',
          'Træmærkning',
          'Afkvistning af stående træer'
        ]
      },
      {
        id: 'atjaunosana',
        title: 'Skovfornyelse og pleje',
        description: 'Sikrer bæredygtig skovudvikling gennem målrettet fornyelsesarbejde.',
        items: [
          'Skovfornyelse',
          'Ungskovpleje',
          'Beskyttelse af ungskov mod dyreskader'
        ]
      },
      {
        id: 'apsaimniekosana',
        title: 'Forvaltning af skovejendomme',
        description: 'Helhedsforvaltning af skovejendomme og koordinering af arbejde fra planlægning til udførelse.',
        items: ['Forvaltning af skovejendomme']
      },
      {
        id: 'es',
        title: 'EU‑projektforberedelse',
        description: 'Rådgivning, dokumentation og opfølgning af projekter i EU‑støtteprogrammer.',
        items: ['Indsendelse og opfølgning af projekter']
      }
    ],
    process: {
      eyebrow: 'Samarbejdsproces',
      title: 'Sådan foregår samarbejdet',
      description: 'En klar og overskuelig proces fra forespørgsel til afslutning.',
      steps: [
        { id: 1, title: 'Forespørgsel', description: 'Kunden kontakter os for at bestille vurdering eller anden service.' },
        { id: 2, title: 'Besigtigelse', description: 'Vi besøger ejendommen og udfører nødvendige feltarbejder.' },
        { id: 3, title: 'Målinger og vurdering', description: 'Vi måler skoven præcist og udarbejder en objektiv vurdering.' },
        { id: 4, title: 'Dokumentation', description: 'Vi udarbejder og indsender nødvendige dokumenter til statslige myndigheder.' },
        { id: 5, title: 'Opfølgning online', description: 'Kunden kan følge arbejdets fremdrift i kundeportalen.' },
        { id: 6, title: 'Slutrapport', description: 'Vi leverer en klar rapport om udførte arbejder og resultater.' }
      ]
    },
    portal: {
      eyebrow: 'Digital platform',
      title: 'Digital platform – Kundeportal',
      description: 'Vi tilbyder vores kunder en bekvem og sikker onlineportal, der giver konstant adgang til projekt- og arbejdsstatus. Portalen gør det muligt at følge opdateringer, spore status og få adgang til alle projektdokumenter samlet.',
      subtitle: 'Platformen er udviklet til maksimal gennemsigtighed og nem kommunikation med vores team. Kunder kan se den aktuelle status uden at kontakte os. Portalen fungerer både på computer og mobil, så informationen altid er tilgængelig.',
      featuresTitle: 'Nøglefunktioner',
      features: [
        { id: 1, title: 'Arbejdsstatus', description: 'Følg projektets fremdrift i realtid – planlagt, i gang eller afsluttet.', icon: 'Activity' },
        { id: 2, title: 'Dokumentadgang', description: 'Alle projektdokumenter samlet ét sted, klar til visning og download.', icon: 'FolderOpen' },
        { id: 3, title: 'Notifikationer', description: 'Modtag opdateringer om fremdrift, ændringer og vigtige nyheder.', icon: 'Bell' },
        { id: 4, title: 'Tilgængelig overalt', description: 'Fungerer på computer og mobil med nem adgang uanset placering.', icon: 'Smartphone' }
      ],
      ctaLogin: 'Log ind på portalen',
      ctaRequest: 'Anmod om adgang',
      preview: {
        headerTitle: 'Mine projekter',
        headerActive: '3 aktive',
        items: [
          { title: 'Vurdering af hugstareal #127', status: 'Afsluttet', tone: 'success' },
          { title: 'Skovmåling', status: 'I gang', tone: 'warning' },
          { title: 'Dokumentation til SFS', status: 'Planlagt', tone: 'info' }
        ],
        footerLeft: 'Seneste aktivitet: i dag',
        footerRight: '2 nye dokumenter'
      }
    },
    why: {
      title: 'Hvorfor vælge uafhængig vurdering',
      description: 'En vurdering udført af en potentiel køber indebærer altid en interessekonflikt. Uafhængig vurdering giver et objektivt billede af den reelle værdi og hjælper skovejeren med at træffe velbegrundede beslutninger.',
      conclusion: 'Uafhængig vurdering hjælper ofte med at undgå ugunstige aftaler og giver et klart billede af skovejendommens potentiale.',
      stats: [
        { value: '15–30%', label: 'Mulig indtægtsforskel' },
        { value: '100%', label: 'Objektiv vurdering' }
      ]
    },
    whyFaq: [
      {
        id: 1,
        title: 'Hvorfor er køberen ikke en objektiv vurderer?',
        content: 'Køberen har en økonomisk interesse i at købe skoven så billigt som muligt, hvilket skaber en interessekonflikt. En uafhængig vurderer arbejder kun for din fordel.'
      },
      {
        id: 2,
        title: 'Hvordan påvirker uafhængig vurdering indtægten?',
        content: 'En præcis og uafhængig vurdering hjælper med at fastslå den reelle værdi og opnå en fair pris i forhandlinger. Mange skovejere har opnået 15–30% højere pris med uafhængig vurdering.'
      },
      {
        id: 3,
        title: 'Hyppige fejl',
        content: 'Utilstrækkelig information om trævolumen, kun at stole på køberens vurdering, uforberedt dokumentation og manglende markedskendskab – disse fejl reducerer skovejerens indtjening.'
      }
    ],
    about: {
      title: 'Om virksomheden',
      subtitle: 'Erfaring inden for skovbrug',
      description: 'Vi er en skovtjenesteudbyder med speciale i uafhængig vurdering af hugstarealer og præcise skovmålinger. Vi arbejder i overensstemmelse med gældende regler og i tæt samarbejde med statslige institutioner.',
      mission: 'Vores mål er at sikre skovejere en korrekt, gennemsigtig og professionel service gennem hele samarbejdet.',
      points: [
        'Specialiseret i uafhængig vurdering af hugstarealer',
        'Præcise skovmålinger i overensstemmelse med regler',
        'Tæt samarbejde med Statens Skovtjeneste',
        'Fuld dokumentationssupport',
        'Vi samarbejder med både private og juridiske enheder'
      ],
      regionsLabel: 'Aktivitetsområder',
      regions: ['Riga og omegn', 'Vidzeme', 'Latgale', 'Kurzeme', 'Zemgale'],
      stats: [],
      sustainabilityTitle: 'Bæredygtig skovforvaltning',
      sustainabilityText: 'Vi hjælper skovejere med at bevare skovens værdi for kommende generationer ved at følge bæredygtige principper og regler.',
      testimonialsEyebrow: 'Udtalelser',
      testimonialsTitle: 'Hvad vores kunder siger',
      testimonialsDescription: 'Ægte oplevelser og vurderinger af vores samarbejde.',
      testimonialsAdd: 'Tilføj udtalelse',
      testimonialsLoading: 'Indlæser udtalelser...',
      testimonialsEmpty: 'Ingen udtalelser endnu. Bliv den første til at dele din oplevelse!',
      testimonialsModalTitle: 'Tilføj udtalelse',
      form: {
        nameLabel: 'Navn eller virksomhed',
        regionLabel: 'Region',
        ratingLabel: 'Vurdering',
        speedLabel: 'Hastighed',
        qualityLabel: 'Kvalitet',
        communicationLabel: 'Kommunikation',
        responsivenessLabel: 'Respons',
        textLabel: 'Udtalelsestekst',
        cancel: 'Annuller',
        submit: 'Send udtalelse',
        sending: 'Sender...',
        success: 'Udtalelse sendt til godkendelse',
        error: 'Kunne ikke sende udtalelse. Prøv igen.'
      },
      metrics: {
        speed: 'Hastighed',
        quality: 'Kvalitet',
        communication: 'Kommunikation',
        responsiveness: 'Respons'
      }
    },
    contact: {
      eyebrow: 'Kontakt os',
      title: 'Kontakt',
      description: 'Kontakt os for at bestille en service eller få rådgivning om din skovejendom.',
      specialistName: 'Rūdolfs Mahts',
      specialistRole: 'Skovbrugsspecialist',
      formNote: 'Udfyld formularen, så kontakter vi dig.',
      infoTitle: 'Kontaktinformation',
      phoneLabel: 'Telefon',
      emailLabel: 'E‑mail',
      addressLabel: 'Juridisk adresse',
      hoursLabel: 'Arbejdstid',
      freeConsultationTitle: 'Gratis konsultation',
      freeConsultationText: 'Den første samtale og vurdering er gratis. Kontakt os, så finder vi den bedste løsning sammen.',
      formTitle: 'Forespørgselsformular',
      successTitle: 'Tak for din forespørgsel!',
      successBody: 'Vi kontakter dig snarest.',
      formNameLabel: 'Navn, efternavn',
      formNamePlaceholder: 'Lars Jensen',
      formPhoneLabel: 'Telefonnummer',
      formPhonePlaceholder: '+45 20 12 34 56',
      formEmailLabel: 'E‑mailadresse',
      formEmailPlaceholder: 'lars@example.com',
      formMessageLabel: 'Besked',
      formMessagePlaceholder: 'Dit spørgsmål eller beskrivelse af situationen...',
      formConsent: 'Ved at indsende formularen accepterer du behandling af dine personoplysninger i henhold til GDPR.',
      formSubmitting: 'Sender...',
      formSubmit: 'Send forespørgsel',
      toastSavedTitle: 'Forespørgsel gemt',
      toastSavedBody: 'E‑maillevering kræver et verificeret domæne. Beskeden er synlig i adminportalen.',
      toastSentTitle: 'Forespørgsel sendt!',
      toastSentBody: 'Vi kontakter dig snarest.',
      toastErrorTitle: 'Fejl ved afsendelse af forespørgsel',
      submitError: 'Fejl ved afsendelse af forespørgsel. Prøv igen.',
      prefillLabel: 'Jeg ønsker et pristilbud for'
    },
    cookie: {
      text: 'Denne hjemmeside bruger cookies for at forbedre din oplevelse.',
      accept: 'Accepter'
    },
    privacy: {
      badge: 'Privatlivspolitik',
      title: 'Sila Meži privatlivspolitik',
      intro: 'Vi beskytter dine data og privatliv. I denne politik forklarer vi, hvilke data vi behandler og hvorfor.',
      controllerTitle: 'Dataansvarlig',
      controllerRegLabel: 'CVR nr.:',
      controllerAddressLabel: 'Adresse:',
      controllerEmailLabel: 'E‑mail til dataspørgsmål:',
      dataTitle: 'Hvilke data behandles',
      dataItemContact: 'Data fra kontaktformularen (navn, e‑mail, telefon, besked).',
      dataItemVisits: 'Besøgsregistrering efter samtykke til cookies (IP‑adresse, region, besøgstid).',
      dataItemEmail: 'Data om e‑maillevering via Resend.',
      visitsTitle: 'Besøgsregistrering',
      visitsText: 'Besøg registreres kun efter samtykke. Vi bruger IPinfo til at fastsætte region.',
      cookiesTitle: 'Cookies',
      cookiesText: 'Denne hjemmeside bruger nødvendige, funktionelle og statistiske cookies for at sikre drift, forbedre oplevelsen og forstå besøgs­trends.',
      retentionTitle: 'Opbevaring og rettigheder',
      retentionText: 'Data opbevares så længe det er nødvendigt for tjenester eller som krævet ved lov. Du kan anmode om rettelse eller sletning ved at skrive til e‑mailadressen ovenfor.',
      thirdPartyTitle: 'Tredjepartstjenester',
      thirdPartyText: 'Vi bruger IPinfo til regionsbestemmelse og Resend til e‑maillevering. Tredjeparter behandler data i henhold til deres egne privatlivspolitikker.'
    },
    footer: {
      companyDescription: 'Uafhængig vurdering af hugstareal og skovtjenester i hele Letland. Vi arbejder kun i skovejerens interesse.',
      companyNote: 'Vi samarbejder med både private og juridiske enheder.',
      navigationTitle: 'Navigation',
      servicesTitle: 'Tjenester',
      contactTitle: 'Kontakt',
      quickLinks: {
        home: 'Forside',
        services: 'Tjenester',
        process: 'Sådan fungerer det',
        portal: 'Kundeportal',
        why: 'Hvorfor uafhængig vurdering',
        about: 'Om os',
        contact: 'Kontakt'
      },
      services: {
        assessment: 'Vurdering af hugstareal',
        measurements: 'Skovmålinger',
        documentation: 'Dokumentation',
        euProjects: 'EU‑projekter'
      },
      rights: 'Alle rettigheder forbeholdes.',
      privacy: 'Privatlivspolitik',
      terms: 'Brugsvilkår'
    },
    nav: {
      home: 'Forside',
      services: 'Tjenester',
      works: 'Arbejder',
      process: 'Proces',
      why: 'Hvorfor os',
      about: 'Om',
      contact: 'Kontakt',
      portal: 'Kundeportal',
      consult: 'Ansøg',
      consultMobile: 'Book konsultation'
    },
    portalUi: {
      common: { loading: 'Indlæser...' },
      status: {
        planned: 'Planlagt',
        inProgress: 'I gang',
        completed: 'Afsluttet',
        active: 'Aktiv',
        onHold: 'Pauset',
        awaitingInfo: 'Afventer info',
        submitted: 'Indsendt'
      },
      nav: {
        client: {
          dashboard: 'Overblik',
          projects: 'Projekter',
          jobs: 'Arbejder',
          documents: 'Dokumenter',
          messages: 'Beskeder',
          contact: 'Kontakt'
        },
        admin: {
          dashboard: 'Overblik',
          clients: 'Kunder',
          projects: 'Projekter',
          jobs: 'Arbejder',
          documents: 'Dokumenter',
          messages: 'Notifikationer',
          visitors: 'Besøg',
          testimonials: 'Udtalelser',
          payroll: 'Lønberegning'
        }
      },
      layout: {
        portalLabel: 'Kundeportal',
        roleAdmin: 'Administrator',
        roleClient: 'Kunde',
        logout: 'Log ud'
      },
      login: {
        portalLabel: 'Kundeportal',
        title: 'Log ind på kundeportalen',
        description: 'Her kan du følge arbejdsstatus, dokumenter og rapporter om din ejendom.',
        usernameLabel: 'Brugernavn',
        usernamePlaceholder: 'Indtast brugernavn',
        passwordLabel: 'Adgangskode',
        passwordPlaceholder: 'Indtast adgangskode',
        togglePassword: 'Vis adgangskode',
        submit: 'Log ind',
        submitting: 'Logger ind...',
        forgotText: 'Glemt adgangskode?',
        contactAdmin: 'Kontakt administrator',
        securityTitle: 'Sikkerhedsmeddelelse',
        securityText: 'Adgang kun for autoriserede kunder. Kontakt os for adgang:',
        backToSite: 'Tilbage til forsiden',
        successToast: 'Login lykkedes!',
        errorFallback: 'Loginfejl'
      },
      employee: {
        tasks: {
          title: 'Darba uzdevumi',
          subtitle: 'Skatiet piešķirtos uzdevumus un iesniedziet atskaites',
          empty: 'Pašlaik nav piešķirtu uzdevumu.',
          client: 'Klients',
          project: 'Projekts',
          property: 'Īpašums',
          dueDate: 'Termiņš',
          submitReport: 'Iesniegt atskaiti',
          viewTask: 'Skatīt uzdevumu',
          reportTitle: 'Atskaite par uzdevumu',
          reportLabel: 'Atskaite',
          reportDescription: 'Ievadiet atskaiti un izdevumus',
          reportPlaceholder: 'Aprakstiet paveikto darbu...',
          expenses: 'Izdevumi',
          addExpense: 'Pievienot izdevumu',
          expenseCategory: 'Kategorija',
          expenseCategoryPlaceholder: 'Degviela',
          expenseAmount: 'Summa (€)',
          expenseNote: 'Piezīme',
          expenseNotePlaceholder: 'Piemēram, degviela darba vajadzībām',
          expenseReceipt: 'Čeka bilde',
          removeExpense: 'Noņemt',
          statusUpdate: 'Atjaunināt statusu',
          cancel: 'Atcelt',
          submit: 'Iesniegt',
          submitting: 'Saglabā...',
          toastLoadError: 'Neizdevās ielādēt uzdevumus',
          toastReportRequired: 'Lūdzu ievadiet atskaiti',
          toastReportSaved: 'Atskaite iesniegta',
          toastReportError: 'Neizdevās iesniegt atskaiti',
          toastReceiptError: 'Neizdevās augšupielādēt čeku'
        }
      },
      forbidden: {
        title: 'Ingen adgang',
        description: 'Du har ikke adgang til denne sektion.',
        detail: 'Hvis du mener, dette er en fejl, kontakt administrator.',
        backToPanel: 'Tilbage til panel',
        home: 'Forside'
      },
      documents: {
        title: 'Tilføj dokument til projekt',
        fileRequired: 'Vælg venligst en fil',
        uploadSuccess: 'Fil uploadet',
        uploadError: 'Uploadfejl',
        fileLabel: 'Fil',
        fileInstruction: 'Klik for at vælge fil',
        fileFormats: 'PDF, Excel, Word, Billeder',
        categoryLabel: 'Dokumenttype',
        categories: [
          { value: 'skice', label: 'Skitse' },
          { value: 'iesniegums', label: 'Ansøgning' },
          { value: 'ligums', label: 'Kontrakt' },
          { value: 'atskaite', label: 'Rapport' },
          { value: 'foto', label: 'Foto' },
          { value: 'cits', label: 'Andet' }
        ],
        visibleLabel: 'Synlig for kunde',
        visibleHint: 'Kunden kan se og downloade dette dokument',
        upload: 'Upload',
        uploading: 'Uploader...',
        cancel: 'Annuller'
      },
      client: {
        dashboard: {
          greeting: 'Velkommen',
          subtitle: 'Din',
          subtitleHighlight: 'kundeportal‑oversigt',
          stats: {
            totalJobs: 'Samlet antal jobs',
            activeJobs: 'Aktive jobs',
            completedJobs: 'Afsluttede',
            newMessages: 'Nye beskeder'
          },
          lastUpdate: 'Seneste opdatering:',
          actions: {
            jobsTitle: 'Se alle jobs',
            jobsDescription: 'Gennemgå jobstatus og detaljer',
            documentsTitle: 'Dokumenter',
            documentsDescription: 'Se og download filer'
          },
          recentTitle: 'Seneste jobs',
          viewAll: 'Se alle',
          responsibleLabel: 'Ansvarlig',
          emptyJobs: 'Ingen jobs endnu'
        },
        projects: {
          title: 'Mine projekter',
          subtitlePrefix: 'Dine',
          subtitleHighlight: 'skovprojekter',
          subtitleSuffix: 'og deres fremdrift',
          cadastralLabel: 'Matr.nr.:',
          progressLabel: 'Samlet fremdrift',
          jobsTotal: 'I alt',
          jobsCompleted: 'Afsluttet',
          jobsInProgress: 'I gang',
          jobsPlanned: 'Planlagt',
          nextStepTitle: 'Hvad sker der nu?',
          viewDetails: 'Se detaljer',
          emptyTitle: 'Ingen projekter',
          emptySubtitle: 'Dine projekter vises her, når administrator opretter dem.'
        },
        jobs: {
          title: 'Arbejder',
          subtitlePrefix: 'Se dine arbejder og deres',
          subtitleHighlight: 'status',
          searchPlaceholder: 'Søg arbejder...',
          filterAll: 'Alle',
          filterPlanned: 'Planlagt',
          filterInProgress: 'I gang',
          filterCompleted: 'Afsluttet',
          deadlineLabel: 'Deadline',
          emptyTitle: 'Ingen arbejder fundet',
          emptyFiltered: 'Prøv at ændre søgekriterierne',
          emptyAll: 'Ingen arbejder tilføjet endnu'
        },
        jobDetail: {
          backToJobs: 'Tilbage til arbejder',
          notFoundTitle: 'Arbejde ikke fundet',
          infoTitle: 'Arbejdsinformation',
          responsibleLabel: 'Ansvarlig',
          startDateLabel: 'Startdato',
          plannedEndLabel: 'Planlagt slutdato',
          completedLabel: 'Afsluttet',
          notesTitle: 'Noter',
          documentsTitle: 'Vedhæftede dokumenter',
          documentsEmpty: 'Ingen vedhæftede dokumenter',
          downloadError: 'Kunne ikke downloade dokumentet',
          timelineTitle: 'Statuslinje',
          timelineEmpty: 'Ingen historikposter'
        },
        documents: {
          title: 'Dokumenter',
          subtitlePrefix: 'Se og download dine',
          subtitleHighlight: 'dokumenter',
          searchPlaceholder: 'Søg dokumenter, projekter eller forfattere...',
          filterAll: 'Alle',
          allProjects: 'Alle projekter',
          allUploaders: 'Alle forfattere',
          sortNewest: 'Nyeste først',
          sortOldest: 'Ældste først',
          latestOnly: 'Kun nyeste versioner',
          download: 'Download',
          downloadError: 'Kunne ikke downloade dokumentet',
          emptyTitle: 'Ingen dokumenter',
          emptyNoDocuments: 'Ingen dokumenter endnu.',
          emptyFiltered: 'Ingen dokumenter matcher de valgte filtre.',
          versionLabel: 'Version',
          categoryOther: 'Andet',
          categories: {
            valsts_institucijam: 'Til statslige institutioner',
            atskaites: 'Rapporter',
            merijumu_dati: 'Måledata',
            skices: 'Skitser',
            cits: 'Andet'
          }
        },
        messages: {
          title: 'Beskeder',
          subtitle: 'Notifikationer og beskeder fra administrationen',
          inboxTitle: 'Indbakke',
          emptyList: 'Ingen beskeder',
          emptyDetailTitle: 'Vælg en besked',
          emptyDetailText: 'Klik på en besked for at læse den'
        },
        contact: {
          title: 'Kontakt',
          subtitlePrefix: 'Stil et spørgsmål eller',
          subtitleHighlight: 'kontakt os',
          phoneLabel: 'Telefon',
          emailLabel: 'E‑mail',
          hoursLabel: 'Åbningstider',
          formTitle: 'Send besked',
          subjectLabel: 'Emne',
          subjectPlaceholder: 'Beskedens emne',
          messageLabel: 'Besked',
          messagePlaceholder: 'Dit spørgsmål eller din besked...',
          submit: 'Send',
          submitting: 'Sender...',
          successTitle: 'Besked sendt!',
          successBody: 'Vi kontakter dig.',
          toastSuccess: 'Besked sendt!',
          toastError: 'Fejl ved afsendelse af besked'
        }
      },
      admin: {
        dashboard: {
          title: 'Administration',
          titleSuffix: 'panel',
          subtitlePrefix: 'Administrer',
          subtitleHighlight: 'kunder, arbejder og dokumenter',
          stats: {
            totalClients: 'Samlet antal kunder',
            totalJobs: 'Samlet antal arbejder',
            activeJobs: 'Aktive arbejder',
            completedJobs: 'Afsluttede'
          },
          quick: {
            clientsTitle: 'Administrer kunder',
            clientsDescription: 'Tilføj og rediger kunder',
            jobsTitle: 'Administrer arbejder',
            jobsDescription: 'Opret og opdater arbejder',
            documentsTitle: 'Dokumenter',
            documentsDescription: 'Upload dokumenter'
          },
          recentTitle: 'Seneste arbejder',
          viewAll: 'Se alle',
          emptyJobs: 'Ingen arbejder'
        },
        clients: {
          title: 'Kunder',
          subtitle: 'Administrer brugere og adgang',
          addButton: 'Tilføj kunde',
          searchPlaceholder: 'Søg kunder...',
          table: {
            client: 'Kunde',
            username: 'Brugernavn',
            contacts: 'Kontaktinfo',
            role: 'Rolle',
            status: 'Status',
            actions: 'Handlinger'
          },
          roleAdmin: 'Admin',
          roleClient: 'Kunde',
          statusActive: 'Aktiv',
          statusInactive: 'Inaktiv',
          confirmDelete: 'Er du sikker på, at du vil slette brugeren "{name}"?',
          toastCreated: 'Bruger oprettet',
          toastUpdated: 'Bruger opdateret',
          toastDeleted: 'Bruger slettet',
          toastDeleteError: 'Slettefejl',
          toastError: 'Fejl',
          passwordLengthError: 'Adgangskoden skal være mindst 12 tegn',
          modal: {
            addTitle: 'Tilføj kunde',
            editTitle: 'Rediger bruger',
            clientNameLabel: 'Kundenavn / virksomhed',
            clientNamePlaceholder: 'ApS Skovejer',
            emailLabel: 'E‑mail',
            phoneLabel: 'Telefon',
            usernameLabel: 'Brugernavn',
            usernamePlaceholder: 'brugernavn',
            passwordLabel: 'Adgangskode *',
            passwordEditLabel: 'Ny adgangskode (valgfrit)',
            passwordPlaceholder: 'Mindst 12 tegn',
            roleLabel: 'Rolle',
            cancel: 'Annuller',
            create: 'Opret',
            save: 'Gem'
          }
        },
        projects: {
          title: 'Projektstyring',
          subtitle: 'Administrer kundernes projekter og arbejder',
          addButton: 'Nyt projekt',
          searchPlaceholder: 'Søg projekter...',
          progressLabel: 'Fremdrift',
          stats: {
            total: 'Samlet antal projekter',
            active: 'Aktive',
            completed: 'Afsluttede',
            totalJobs: 'Samlet antal arbejder'
          },
          jobsTotal: 'I alt',
          jobsCompleted: 'Afsluttede',
          jobsInProgress: 'I gang',
          jobsPlanned: 'Planlagte',
          editButton: 'Rediger',
          deleteButton: 'Slet',
          emptyState: 'Ingen projekter fundet',
          confirmDelete: 'Er du sikker på, at du vil slette dette projekt?',
          toastCreated: 'Projekt oprettet',
          toastUpdated: 'Projekt opdateret',
          toastDeleted: 'Projekt slettet',
          toastDeleteError: 'Kunne ikke slette projektet',
          toastError: 'Fejl',
          toastLoadError: 'Kunne ikke indlæse projekter',
          noClient: 'Ikke angivet',
          modal: {
            addTitle: 'Nyt projekt',
            editTitle: 'Rediger projekt',
            nameLabel: 'Projektnavn',
            namePlaceholder: 'Lejasrunķi ejendom – Arbejder 2026',
            clientLabel: 'Kunde',
            clientPlaceholder: 'Vælg kunde',
            propertyNameLabel: 'Ejendomsnavn',
            propertyNamePlaceholder: 'Lejasrunķi',
            cadastralLabel: 'Matrikelnummer',
            addressLabel: 'Ejendomsadresse',
            addressPlaceholder: 'Ropaži kommune',
            descriptionLabel: 'Beskrivelse',
            descriptionPlaceholder: 'Detaljeret projektbeskrivelse...',
            statusLabel: 'Status',
            nextStepLabel: 'Hvad sker der nu?',
            nextStepPlaceholder: 'Afslut afmærkning af hugstareal',
            cancel: 'Annuller',
            create: 'Opret',
            save: 'Gem'
          }
        },
        jobs: {
          title: 'Arbejder',
          subtitle: 'Administrer arbejder og deres status',
          addButton: 'Tilføj arbejde',
          searchPlaceholder: 'Søg arbejder...',
          filterAll: 'Alle',
          table: {
            job: 'Arbejde',
            client: 'Kunde',
            status: 'Status',
            dates: 'Datoer',
            responsible: 'Ansvarlig',
            actions: 'Handlinger'
          },
          deadlineLabel: 'Deadline',
          confirmDelete: 'Er du sikker på, at du vil slette arbejdet "{title}"?',
          unknownClient: 'Ukendt',
          toastCreated: 'Arbejde oprettet',
          toastUpdated: 'Arbejde opdateret',
          toastDeleted: 'Arbejde slettet',
          toastDeleteError: 'Fejl',
          toastError: 'Fejl',
          modal: {
            addTitle: 'Tilføj arbejde',
            editTitle: 'Rediger arbejde',
            titleLabel: 'Arbejdsnavn',
            titlePlaceholder: 'Mærkning af stående træer',
            descriptionLabel: 'Beskrivelse',
            descriptionPlaceholder: 'Arbejdsbeskrivelse...',
            clientLabel: 'Kunde',
            clientPlaceholder: 'Vælg kunde',
            projectLabel: 'Projekt',
            projectPlaceholder: 'Vælg projekt',
            projectPlaceholderEmpty: 'Vælg først kunde',
            statusLabel: 'Status',
            responsibleLabel: 'Ansvarlig',
            responsiblePlaceholder: 'Lars Jensen',
            startDateLabel: 'Startdato',
            endDateLabel: 'Planlagt slutdato',
            notesLabel: 'Noter til kunde',
            notesPlaceholder: 'Noter som kunden kan se...',
            cancel: 'Annuller',
            create: 'Opret',
            save: 'Gem'
          }
        },
        bulkJob: {
          title: 'Tilføj flere arbejder til projekt',
          selectLabel: 'Vælg arbejdstyper:',
          selectAll: 'Vælg alle',
          clearAll: 'Ryd',
          selectError: 'Vælg mindst én arbejdstype',
          selectedCount: 'Valgt',
          selectedSuffix: 'arbejdstyper',
          statusNote: 'Alle arbejder oprettes med status “Planlagt”',
          cancel: 'Annuller',
          creating: 'Opretter...',
          createCount: 'Opret {count} arbejder',
          successTitle: 'Arbejder oprettet!',
          error: 'Kunne ikke oprette arbejder',
          workTypes: [
            { id: 'augoshu_koku_dastoshana', label: 'Mærkning af stående træer' },
            { id: 'caurmera_merishana', label: 'Diameter­måling' },
            { id: 'cirsmas_stigoshana', label: 'Afmærkning af hugstareal' },
            { id: 'ipashuma_robezu_atjaunoshana', label: 'Genopretning af ejendomsgrænser' },
            { id: 'robezzimju_atjaunoshana', label: 'Genopretning af grænsemærker' },
            { id: 'paliekoso_koku_izzimeshana', label: 'Mærkning af blivende træer ved selektiv hugst' },
            { id: 'cirsmu_iezimeshana', label: 'Markering af hugstområde' },
            { id: 'dokumentacijas_sagatavoshana', label: 'Dokumentationsforberedelse' },
            { id: 'es_projektu_sagatavoshana', label: 'EU‑projektforberedelse' },
            { id: 'cits', label: 'Andet' }
          ]
        },
        audit: {
          title: 'Audit log',
          subtitle: 'Systemets aktivitets­historik',
          emptyTitle: 'Ingen audit‑poster',
          emptyBody: 'Aktivitets­historik vises her'
        },
        visitors: {
          title: 'Besøgsstatistik',
          subtitle: 'Besøg på den offentlige hjemmeside',
          range7: '7 dage',
          range30: '30 dage',
          range7Short: '7 dage',
          range30Short: '30 dage',
          rangeOther: '{count} dage',
          totalLabel: 'Samlet antal besøg',
          uniqueLabel: 'Unikke besøgende',
          periodLabel: 'Periode',
          dailyTitle: 'Daglige besøg',
          dailyEmpty: 'Ingen data for valgt periode.',
          recentTitle: 'Seneste besøg',
          recentEmpty: 'Ingen besøgs­poster.',
          unknownRegion: 'Ukendt region',
          visitNumber: 'Besøg #{number}'
        },
        testimonials: {
          title: 'Håndtering af udtalelser',
          subtitle: 'Godkend eller skjul kunders udtalelser før de vises på hjemmesiden.',
          filters: {
            all: 'Alle',
            pending: 'Afventer godkendelse',
            approved: 'Publiceret',
            hidden: 'Skjult'
          },
          loading: 'Indlæser udtalelser...',
          empty: 'Ingen udtalelser for valgt filter.',
          average: 'Gennemsnit {rating}/5',
          speed: 'Hastighed',
          quality: 'Kvalitet',
          communication: 'Kommunikation',
          responsiveness: 'Respons',
          publish: 'Publicer',
          hide: 'Skjul',
          returnToPending: 'Tilbage til afventende'
        },
        payroll: {
          title: 'Lønberegning',
          subtitle: 'Månedlig lønberegning for medarbejdere',
          addEntry: 'Tilføj post',
          export: 'Eksportér XLSX',
          confirmDelete: 'Vil du slette denne post?',
          toastCreated: 'Post gemt',
          toastUpdated: 'Post opdateret',
          toastDeleted: 'Post slettet',
          toastDeleteError: 'Kunne ikke slette posten',
          toastError: 'Kunne ikke gemme posten',
          validation: {
            employee: 'Vælg medarbejder',
            workTypes: 'Vælg mindst én arbejdstype'
          },
          filters: {
            month: 'Måned',
            year: 'År',
            employee: 'Medarbejder',
            client: 'Kunde',
            status: 'Faktura',
            statusAll: 'Alle',
            statusPaid: 'Betalt',
            statusUnpaid: 'Ikke betalt'
          },
          summary: {
            totalSalary: 'Samlet bruttoløn',
            totalCosts: 'Samlede omkostninger',
            fuelCost: 'Brændstof',
            paintCost: 'Maling'
          },
          table: {
            title: 'Lønposter',
            date: 'Dato',
            employee: 'Medarbejder',
            client: 'Kunde',
            property: 'Ejendom',
            workTypes: 'Arbejdstyper',
            salary: 'Brutto',
            costs: 'Omkostninger',
            paid: 'Betalt',
            actions: 'Handlinger',
            edit: 'Rediger',
            delete: 'Slet'
          },
          empty: {
            title: 'Ingen lønposter',
            body: 'Der er ingen poster for den valgte periode.'
          },
          form: {
            addTitle: 'Ny lønpost',
            editTitle: 'Rediger lønpost',
            date: 'Dato',
            employee: 'Medarbejder',
            client: 'Kunde (valgfrit)',
            propertyName: 'Ejendomsnavn',
            cadastralNumber: 'Matrikelnummer',
            kilometers: 'Kørte kilometer',
            paintCans: 'Malingsdåser (stk.)',
            fuelRate: 'Brændstofsats (€/km)',
            paintPrice: 'Pris pr. malingsdåse (€/stk.)',
            workTypes: 'Arbejdstyper',
            amount: 'Mængde',
            rate: 'Sats',
            notes: 'Noter',
            customRateNote: 'Sats indtastes manuelt',
            invoicePaid: 'Betaling modtaget',
            save: 'Gem',
            cancel: 'Annuller'
          },
          totals: {
            salary: 'Bruttoløn',
            costs: 'Virksomhedsomkostninger',
            fuel: 'Brændstofomkostning',
            paint: 'Malingsomkostning'
          },
          workTypes: {
            augoshu_koku_dastoshana: 'Træmærkning',
            cirsmas_stigoshana: 'Afmærkning af område',
            caurmera_merishana: 'Diameter­måling',
            paliekoso_koku_izzimeshana: 'Markering af tilbageværende træer',
            cirsmu_iezimeshana: 'Markering af hugstområde',
            ipashuma_robezu_atjaunoshana: 'Genskabelse af grænser',
            robezzimju_atjaunoshana: 'Genskabelse af grænsemærker'
          },
          units: {
            hectares: 'ha',
            kilometers: 'km',
            pieces: 'stk.'
          }
        }
      },
      shared: {
        projectDetail: {
          notFound: 'Projekt ikke fundet',
          back: 'Tilbage',
          propertyLabel: 'Ejendom:',
          cadastralLabel: 'Matrikel:',
          addressLabel: 'Adresse:',
          progressLabel: 'Samlet fremdrift',
          jobsTotal: 'Samlet antal arbejder',
          jobsCompleted: 'Afsluttede',
          jobsInProgress: 'I gang',
          jobsPlanned: 'Planlagt',
          nextStepTitle: 'Hvad sker der nu?',
          jobsTitle: 'Projektarbejder',
          bulkAddJobs: 'Tilføj flere arbejder',
          deadlineLabel: 'Deadline',
          lastUpdateLabel: 'Seneste ændring:',
          emptyJobs: 'Ingen arbejder er tilføjet til dette projekt endnu'
        }
      }
    }
  },
};

export const languageOptions = [
  { code: 'lv', label: 'LV', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f1-1f1fb.svg' },
  { code: 'en', label: 'EN', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ec-1f1e7.svg' },
  { code: 'ru', label: 'RU', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f7-1f1fa.svg' },
  { code: 'lt', label: 'LT', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f1-1f1f9.svg' },
  { code: 'et', label: 'ET', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ea-1f1ea.svg' },
  { code: 'sv', label: 'SV', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f8-1f1ea.svg' },
  { code: 'fi', label: 'FI', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1eb-1f1ee.svg' },
  { code: 'no', label: 'NO', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f3-1f1f4.svg' },
  { code: 'da', label: 'DA', flagUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1e9-1f1f0.svg' }
];
